/* eslint-disable */
// @ts-nocheck
// THIS FILE IS GENERATED, DO NOT EDIT
// Regenerate the file by running 'yarn compile:ajv'
'use strict';
import { fullFormats } from 'ajv-formats/dist/formats';
const formatWrapper = { ...fullFormats };
function ucs2length(str) {
    const len = str.length;
    let length = 0;
    let pos = 0;
    let value;
    while (pos < len) {
        length++;
        value = str.charCodeAt(pos++);
        if (value >= 0xd800 && value <= 0xdbff && pos < len) {
            value = str.charCodeAt(pos);
            if ((value & 0xfc00) === 0xdc00)
                pos++;
        }
    }
    return length;
}
function padString(input) {
    var segmentLength = 4;
    var stringLength = input.length;
    var diff = stringLength % segmentLength;
    if (!diff) {
        return input;
    }
    var position = stringLength;
    var padLength = segmentLength - diff;
    var paddedStringLength = stringLength + padLength;
    var buffer = Buffer.alloc(paddedStringLength);
    buffer.write(input);
    while (padLength--) {
        buffer.write('=', position++);
    }
    return buffer.toString();
}
function toBase64(base64url) {
    base64url = base64url.toString();
    return padString(base64url).replace(/\-/g, '+').replace(/_/g, '/');
}
function base64urlToBuffer(base64url) {
    return Buffer.from(toBase64(base64url), 'base64');
}
function fromBase64(base64) {
    return base64.replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
}
function base64urlEncode(input, encoding) {
    if (encoding === void 0) {
        encoding = 'utf8';
    }
    if (Buffer.isBuffer(input)) {
        return fromBase64(input.toString('base64'));
    }
    return fromBase64(Buffer.from(input, encoding).toString('base64'));
}
export const amazonS3ExportSettingsSchemaValidation = validate12;
const schema29 = {
    $id: 'urn:wisepipe-common-export:AmazonS3ExportSettings',
    type: 'object',
    properties: {
        prefix: { type: 'string' },
        isExcel: { type: 'boolean' },
        addTimestampSuffix: { type: 'boolean' },
        delimiter: { type: 'string' },
        exportFileType: { type: 'string', enum: ['.csv', '.xlsx', '.txt'] }
    },
    required: ['prefix']
};
function validate12(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-export:AmazonS3ExportSettings" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.prefix === undefined && (missing0 = 'prefix')) {
                validate12.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.prefix !== undefined) {
                    const _errs1 = errors;
                    if (typeof data.prefix !== 'string') {
                        validate12.errors = [
                            {
                                instancePath: instancePath + '/prefix',
                                schemaPath: '#/properties/prefix/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.isExcel !== undefined) {
                        const _errs3 = errors;
                        if (typeof data.isExcel !== 'boolean') {
                            validate12.errors = [
                                {
                                    instancePath: instancePath + '/isExcel',
                                    schemaPath: '#/properties/isExcel/type',
                                    keyword: 'type',
                                    params: { type: 'boolean' },
                                    message: 'must be boolean'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.addTimestampSuffix !== undefined) {
                            const _errs5 = errors;
                            if (typeof data.addTimestampSuffix !== 'boolean') {
                                validate12.errors = [
                                    {
                                        instancePath: instancePath + '/addTimestampSuffix',
                                        schemaPath: '#/properties/addTimestampSuffix/type',
                                        keyword: 'type',
                                        params: { type: 'boolean' },
                                        message: 'must be boolean'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.delimiter !== undefined) {
                                const _errs7 = errors;
                                if (typeof data.delimiter !== 'string') {
                                    validate12.errors = [
                                        {
                                            instancePath: instancePath + '/delimiter',
                                            schemaPath: '#/properties/delimiter/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.exportFileType !== undefined) {
                                    let data4 = data.exportFileType;
                                    const _errs9 = errors;
                                    if (typeof data4 !== 'string') {
                                        validate12.errors = [
                                            {
                                                instancePath: instancePath + '/exportFileType',
                                                schemaPath: '#/properties/exportFileType/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                    if (!(data4 === '.csv' || data4 === '.xlsx' || data4 === '.txt')) {
                                        validate12.errors = [
                                            {
                                                instancePath: instancePath + '/exportFileType',
                                                schemaPath: '#/properties/exportFileType/enum',
                                                keyword: 'enum',
                                                params: { allowedValues: schema29.properties.exportFileType.enum },
                                                message: 'must be equal to one of the allowed values'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate12.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate12.errors = vErrors;
    return errors === 0;
}
export const awsCredentialsSchemaValidation = validate13;
const schema30 = {
    $id: 'urn:wisepipe-common-auth:AwsCredentials',
    type: 'object',
    properties: {
        identityID: { type: 'string', pattern: '[\\w-]+:[0-9a-f-]+' },
        accessKeyID: { type: 'string', minLength: 1, pattern: '[\\w]+' },
        secretKey: { type: 'string', minLength: 1 },
        sessionToken: { type: 'string', minLength: 1 },
        expiration: { type: 'string', format: 'date-time' },
        region: { type: 'string' }
    },
    required: ['identityID', 'accessKeyID', 'secretKey', 'sessionToken', 'expiration', 'region']
};
const pattern0 = new RegExp('[\\w-]+:[0-9a-f-]+', 'u');
const pattern1 = new RegExp('[\\w]+', 'u');
const func2 = ucs2length;
const formats0 = formatWrapper['date-time'];
function validate13(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-auth:AwsCredentials" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.identityID === undefined && (missing0 = 'identityID')) ||
                (data.accessKeyID === undefined && (missing0 = 'accessKeyID')) ||
                (data.secretKey === undefined && (missing0 = 'secretKey')) ||
                (data.sessionToken === undefined && (missing0 = 'sessionToken')) ||
                (data.expiration === undefined && (missing0 = 'expiration')) ||
                (data.region === undefined && (missing0 = 'region'))) {
                validate13.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.identityID !== undefined) {
                    let data0 = data.identityID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (!pattern0.test(data0)) {
                                validate13.errors = [
                                    {
                                        instancePath: instancePath + '/identityID',
                                        schemaPath: '#/properties/identityID/pattern',
                                        keyword: 'pattern',
                                        params: { pattern: '[\\w-]+:[0-9a-f-]+' },
                                        message: 'must match pattern "' + '[\\w-]+:[0-9a-f-]+' + '"'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate13.errors = [
                                {
                                    instancePath: instancePath + '/identityID',
                                    schemaPath: '#/properties/identityID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.accessKeyID !== undefined) {
                        let data1 = data.accessKeyID;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate13.errors = [
                                        {
                                            instancePath: instancePath + '/accessKeyID',
                                            schemaPath: '#/properties/accessKeyID/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    if (!pattern1.test(data1)) {
                                        validate13.errors = [
                                            {
                                                instancePath: instancePath + '/accessKeyID',
                                                schemaPath: '#/properties/accessKeyID/pattern',
                                                keyword: 'pattern',
                                                params: { pattern: '[\\w]+' },
                                                message: 'must match pattern "' + '[\\w]+' + '"'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                            else {
                                validate13.errors = [
                                    {
                                        instancePath: instancePath + '/accessKeyID',
                                        schemaPath: '#/properties/accessKeyID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.secretKey !== undefined) {
                            let data2 = data.secretKey;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    if (func2(data2) < 1) {
                                        validate13.errors = [
                                            {
                                                instancePath: instancePath + '/secretKey',
                                                schemaPath: '#/properties/secretKey/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate13.errors = [
                                        {
                                            instancePath: instancePath + '/secretKey',
                                            schemaPath: '#/properties/secretKey/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.sessionToken !== undefined) {
                                let data3 = data.sessionToken;
                                const _errs7 = errors;
                                if (errors === _errs7) {
                                    if (typeof data3 === 'string') {
                                        if (func2(data3) < 1) {
                                            validate13.errors = [
                                                {
                                                    instancePath: instancePath + '/sessionToken',
                                                    schemaPath: '#/properties/sessionToken/minLength',
                                                    keyword: 'minLength',
                                                    params: { limit: 1 },
                                                    message: 'must NOT have fewer than 1 characters'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate13.errors = [
                                            {
                                                instancePath: instancePath + '/sessionToken',
                                                schemaPath: '#/properties/sessionToken/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.expiration !== undefined) {
                                    let data4 = data.expiration;
                                    const _errs9 = errors;
                                    if (errors === _errs9) {
                                        if (errors === _errs9) {
                                            if (typeof data4 === 'string') {
                                                if (!formats0.validate(data4)) {
                                                    validate13.errors = [
                                                        {
                                                            instancePath: instancePath + '/expiration',
                                                            schemaPath: '#/properties/expiration/format',
                                                            keyword: 'format',
                                                            params: { format: 'date-time' },
                                                            message: 'must match format "' + 'date-time' + '"'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            else {
                                                validate13.errors = [
                                                    {
                                                        instancePath: instancePath + '/expiration',
                                                        schemaPath: '#/properties/expiration/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.region !== undefined) {
                                        const _errs11 = errors;
                                        if (typeof data.region !== 'string') {
                                            validate13.errors = [
                                                {
                                                    instancePath: instancePath + '/region',
                                                    schemaPath: '#/properties/region/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                        var valid0 = _errs11 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate13.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate13.errors = vErrors;
    return errors === 0;
}
export const connectionSchemaValidation = validate14;
const schema31 = {
    $id: 'urn:wisepipe-common-connection:Connection',
    type: 'object',
    properties: {
        connectionID: { type: 'string', uid: 9 },
        connectionType: {
            type: 'string',
            enum: [
                'google',
                'gsheetsImport',
                'gsheetsExport',
                'shopify',
                'salesForce',
                'postgreSql',
                'icm',
                'tq-postgres',
                'mySql',
                'msSql',
                'oracle',
                'amazonRedshift',
                'amazonAurora',
                'amazonS3',
                'amazonS3Export',
                'tqp',
                'hubspot',
                'symon',
                'snowflake',
                'dynamics',
                'agentSync',
                'workday',
                'workdayRaaS',
                'workdayExport',
                'tableau',
                'sftp',
                'powerbi',
                'rest',
                'gong',
                'netSuite',
                'oneDrive',
                'oneDriveExport',
                'sapSuccessFactors',
                'sapCrm',
                'ukg',
                'oracleHcm',
                'Adp',
                'dynamics365Sales',
                'ceridianDayforce',
                'oracleCrm',
                'oracleErpCloud',
                'sageIntacct',
                'bambooHr',
                'sapErp',
                'googleCloudPlatformCloudStorage',
                'sas',
                'dropbox',
                'googleDrive',
                'jira',
                'monday',
                'zuora',
                'adobeAnalytics',
                'zoomInfo',
                'marketo',
                'activeCampaign',
                'mailchimp',
                'infor',
                'cornerstoneOnDemand',
                'gusto',
                'paychexFlex',
                'zendesk',
                'serviceNow',
                'zohoCrm',
                'pipedrive',
                'quickBooks',
                'xero',
                'freshbooks',
                'zohoBooks',
                'waveFinancial'
            ]
        },
        name: { type: 'string', minLength: 1 },
        source: { type: 'string', minLength: 1 },
        failedOnLastTry: { type: 'boolean' },
        isDiscoveryFail: { type: 'boolean' },
        verificationErrorMessage: { type: 'string' }
    },
    required: ['connectionType', 'name']
};
const func5 = ucs2length;
const func6 = base64urlToBuffer;
const func7 = base64urlEncode;
const func8 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate14(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-connection:Connection" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.connectionType === undefined && (missing0 = 'connectionType')) ||
                (data.name === undefined && (missing0 = 'name'))) {
                validate14.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.connectionID !== undefined) {
                    let data0 = data.connectionID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            const b64min0 = Math.ceil((4 * 9) / 3);
                            const b64max0 = Math.ceil((4 * 9) / 3) + 3;
                            if (func5(data0) < b64min0 || func5(data0) > b64max0) {
                                validate14.errors = [
                                    {
                                        instancePath: instancePath + '/connectionID',
                                        schemaPath: '#/properties/connectionID/uid',
                                        keyword: 'uid',
                                        params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func5(data0) },
                                        message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func5(data0)
                                    }
                                ];
                                return false;
                            }
                            else {
                                const decoded0 = func6(data0);
                                if (decoded0.length !== 9) {
                                    validate14.errors = [
                                        {
                                            instancePath: instancePath + '/connectionID',
                                            schemaPath: '#/properties/connectionID/uid',
                                            keyword: 'uid',
                                            params: { error: 'decoded' },
                                            message: 'must decode to 9 bytes'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const encoded0 = func7(decoded0);
                                    if (func8(encoded0) !== func8(data0)) {
                                        validate14.errors = [
                                            {
                                                instancePath: instancePath + '/connectionID',
                                                schemaPath: '#/properties/connectionID/uid',
                                                keyword: 'uid',
                                                params: { error: 'ambiguous' },
                                                message: 'encoding is ambiguous'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                        }
                        else {
                            validate14.errors = [
                                {
                                    instancePath: instancePath + '/connectionID',
                                    schemaPath: '#/properties/connectionID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.connectionType !== undefined) {
                        let data1 = data.connectionType;
                        const _errs3 = errors;
                        if (typeof data1 !== 'string') {
                            validate14.errors = [
                                {
                                    instancePath: instancePath + '/connectionType',
                                    schemaPath: '#/properties/connectionType/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        if (!(data1 === 'google' ||
                            data1 === 'gsheetsImport' ||
                            data1 === 'gsheetsExport' ||
                            data1 === 'shopify' ||
                            data1 === 'salesForce' ||
                            data1 === 'postgreSql' ||
                            data1 === 'icm' ||
                            data1 === 'tq-postgres' ||
                            data1 === 'mySql' ||
                            data1 === 'msSql' ||
                            data1 === 'oracle' ||
                            data1 === 'amazonRedshift' ||
                            data1 === 'amazonAurora' ||
                            data1 === 'amazonS3' ||
                            data1 === 'amazonS3Export' ||
                            data1 === 'tqp' ||
                            data1 === 'hubspot' ||
                            data1 === 'symon' ||
                            data1 === 'snowflake' ||
                            data1 === 'dynamics' ||
                            data1 === 'agentSync' ||
                            data1 === 'workday' ||
                            data1 === 'workdayRaaS' ||
                            data1 === 'workdayExport' ||
                            data1 === 'tableau' ||
                            data1 === 'sftp' ||
                            data1 === 'powerbi' ||
                            data1 === 'rest' ||
                            data1 === 'gong' ||
                            data1 === 'netSuite' ||
                            data1 === 'oneDrive' ||
                            data1 === 'oneDriveExport' ||
                            data1 === 'sapSuccessFactors' ||
                            data1 === 'sapCrm' ||
                            data1 === 'ukg' ||
                            data1 === 'oracleHcm' ||
                            data1 === 'Adp' ||
                            data1 === 'dynamics365Sales' ||
                            data1 === 'ceridianDayforce' ||
                            data1 === 'oracleCrm' ||
                            data1 === 'oracleErpCloud' ||
                            data1 === 'sageIntacct' ||
                            data1 === 'bambooHr' ||
                            data1 === 'sapErp' ||
                            data1 === 'googleCloudPlatformCloudStorage' ||
                            data1 === 'sas' ||
                            data1 === 'dropbox' ||
                            data1 === 'googleDrive' ||
                            data1 === 'jira' ||
                            data1 === 'monday' ||
                            data1 === 'zuora' ||
                            data1 === 'adobeAnalytics' ||
                            data1 === 'zoomInfo' ||
                            data1 === 'marketo' ||
                            data1 === 'activeCampaign' ||
                            data1 === 'mailchimp' ||
                            data1 === 'infor' ||
                            data1 === 'cornerstoneOnDemand' ||
                            data1 === 'gusto' ||
                            data1 === 'paychexFlex' ||
                            data1 === 'zendesk' ||
                            data1 === 'serviceNow' ||
                            data1 === 'zohoCrm' ||
                            data1 === 'pipedrive' ||
                            data1 === 'quickBooks' ||
                            data1 === 'xero' ||
                            data1 === 'freshbooks' ||
                            data1 === 'zohoBooks' ||
                            data1 === 'waveFinancial')) {
                            validate14.errors = [
                                {
                                    instancePath: instancePath + '/connectionType',
                                    schemaPath: '#/properties/connectionType/enum',
                                    keyword: 'enum',
                                    params: { allowedValues: schema31.properties.connectionType.enum },
                                    message: 'must be equal to one of the allowed values'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.name !== undefined) {
                            let data2 = data.name;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    if (func2(data2) < 1) {
                                        validate14.errors = [
                                            {
                                                instancePath: instancePath + '/name',
                                                schemaPath: '#/properties/name/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate14.errors = [
                                        {
                                            instancePath: instancePath + '/name',
                                            schemaPath: '#/properties/name/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.source !== undefined) {
                                let data3 = data.source;
                                const _errs7 = errors;
                                if (errors === _errs7) {
                                    if (typeof data3 === 'string') {
                                        if (func2(data3) < 1) {
                                            validate14.errors = [
                                                {
                                                    instancePath: instancePath + '/source',
                                                    schemaPath: '#/properties/source/minLength',
                                                    keyword: 'minLength',
                                                    params: { limit: 1 },
                                                    message: 'must NOT have fewer than 1 characters'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate14.errors = [
                                            {
                                                instancePath: instancePath + '/source',
                                                schemaPath: '#/properties/source/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.failedOnLastTry !== undefined) {
                                    const _errs9 = errors;
                                    if (typeof data.failedOnLastTry !== 'boolean') {
                                        validate14.errors = [
                                            {
                                                instancePath: instancePath + '/failedOnLastTry',
                                                schemaPath: '#/properties/failedOnLastTry/type',
                                                keyword: 'type',
                                                params: { type: 'boolean' },
                                                message: 'must be boolean'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.isDiscoveryFail !== undefined) {
                                        const _errs11 = errors;
                                        if (typeof data.isDiscoveryFail !== 'boolean') {
                                            validate14.errors = [
                                                {
                                                    instancePath: instancePath + '/isDiscoveryFail',
                                                    schemaPath: '#/properties/isDiscoveryFail/type',
                                                    keyword: 'type',
                                                    params: { type: 'boolean' },
                                                    message: 'must be boolean'
                                                }
                                            ];
                                            return false;
                                        }
                                        var valid0 = _errs11 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                    if (valid0) {
                                        if (data.verificationErrorMessage !== undefined) {
                                            const _errs13 = errors;
                                            if (typeof data.verificationErrorMessage !== 'string') {
                                                validate14.errors = [
                                                    {
                                                        instancePath: instancePath + '/verificationErrorMessage',
                                                        schemaPath: '#/properties/verificationErrorMessage/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                            var valid0 = _errs13 === errors;
                                        }
                                        else {
                                            var valid0 = true;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate14.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate14.errors = vErrors;
    return errors === 0;
}
export const credentialsSchemaValidation = validate15;
const schema32 = {
    $id: 'urn:wisepipe-common:Credentials',
    type: 'object',
    properties: {
        credentialsType: {
            type: 'string',
            enum: [
                'oauth',
                'userPassword',
                's3Credentials',
                'apiKey',
                'symon',
                'awsRoleAssumption',
                'rest',
                'tokenBasedAuthentication'
            ]
        }
    },
    required: ['credentialsType']
};
function validate15(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common:Credentials" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.credentialsType === undefined && (missing0 = 'credentialsType')) {
                validate15.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.credentialsType !== undefined) {
                    let data0 = data.credentialsType;
                    if (typeof data0 !== 'string') {
                        validate15.errors = [
                            {
                                instancePath: instancePath + '/credentialsType',
                                schemaPath: '#/properties/credentialsType/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    if (!(data0 === 'oauth' ||
                        data0 === 'userPassword' ||
                        data0 === 's3Credentials' ||
                        data0 === 'apiKey' ||
                        data0 === 'symon' ||
                        data0 === 'awsRoleAssumption' ||
                        data0 === 'rest' ||
                        data0 === 'tokenBasedAuthentication')) {
                        validate15.errors = [
                            {
                                instancePath: instancePath + '/credentialsType',
                                schemaPath: '#/properties/credentialsType/enum',
                                keyword: 'enum',
                                params: { allowedValues: schema32.properties.credentialsType.enum },
                                message: 'must be equal to one of the allowed values'
                            }
                        ];
                        return false;
                    }
                }
            }
        }
        else {
            validate15.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate15.errors = vErrors;
    return errors === 0;
}
export const csvExtractionSchemaValidation = validate16;
const schema33 = {
    $id: 'urn:wisepipe-common-export:CsvExtraction',
    type: 'object',
    properties: { csvFolder: { $ref: 'urn:wisepipe-common:S3File' } },
    required: ['csvFolder']
};
const schema34 = {
    $id: 'urn:wisepipe-common:S3File',
    type: 'object',
    properties: {
        bucket: { type: 'string', minLength: 1 },
        key: { type: 'string', minLength: 1 },
        uploadID: { type: 'string', uid: 9 }
    },
    required: ['bucket', 'key']
};
const func13 = ucs2length;
const func14 = base64urlToBuffer;
const func15 = base64urlEncode;
const func16 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate16(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-export:CsvExtraction" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.csvFolder === undefined && (missing0 = 'csvFolder')) {
                validate16.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.csvFolder !== undefined) {
                    let data0 = data.csvFolder;
                    const _errs2 = errors;
                    if (errors === _errs2) {
                        if (data0 && typeof data0 == 'object' && !Array.isArray(data0)) {
                            let missing1;
                            if ((data0.bucket === undefined && (missing1 = 'bucket')) ||
                                (data0.key === undefined && (missing1 = 'key'))) {
                                validate16.errors = [
                                    {
                                        instancePath: instancePath + '/csvFolder',
                                        schemaPath: 'urn:wisepipe-common:S3File/required',
                                        keyword: 'required',
                                        params: { missingProperty: missing1 },
                                        message: "must have required property '" + missing1 + "'"
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (data0.bucket !== undefined) {
                                    let data1 = data0.bucket;
                                    const _errs4 = errors;
                                    if (errors === _errs4) {
                                        if (typeof data1 === 'string') {
                                            if (func2(data1) < 1) {
                                                validate16.errors = [
                                                    {
                                                        instancePath: instancePath + '/csvFolder/bucket',
                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/bucket/minLength',
                                                        keyword: 'minLength',
                                                        params: { limit: 1 },
                                                        message: 'must NOT have fewer than 1 characters'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate16.errors = [
                                                {
                                                    instancePath: instancePath + '/csvFolder/bucket',
                                                    schemaPath: 'urn:wisepipe-common:S3File/properties/bucket/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid2 = _errs4 === errors;
                                }
                                else {
                                    var valid2 = true;
                                }
                                if (valid2) {
                                    if (data0.key !== undefined) {
                                        let data2 = data0.key;
                                        const _errs6 = errors;
                                        if (errors === _errs6) {
                                            if (typeof data2 === 'string') {
                                                if (func2(data2) < 1) {
                                                    validate16.errors = [
                                                        {
                                                            instancePath: instancePath + '/csvFolder/key',
                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/key/minLength',
                                                            keyword: 'minLength',
                                                            params: { limit: 1 },
                                                            message: 'must NOT have fewer than 1 characters'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            else {
                                                validate16.errors = [
                                                    {
                                                        instancePath: instancePath + '/csvFolder/key',
                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/key/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid2 = _errs6 === errors;
                                    }
                                    else {
                                        var valid2 = true;
                                    }
                                    if (valid2) {
                                        if (data0.uploadID !== undefined) {
                                            let data3 = data0.uploadID;
                                            const _errs8 = errors;
                                            if (errors === _errs8) {
                                                if (typeof data3 === 'string') {
                                                    const b64min0 = Math.ceil((4 * 9) / 3);
                                                    const b64max0 = Math.ceil((4 * 9) / 3) + 3;
                                                    if (func13(data3) < b64min0 || func13(data3) > b64max0) {
                                                        validate16.errors = [
                                                            {
                                                                instancePath: instancePath + '/csvFolder/uploadID',
                                                                schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                keyword: 'uid',
                                                                params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func13(data3) },
                                                                message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func13(data3)
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    else {
                                                        const decoded0 = func14(data3);
                                                        if (decoded0.length !== 9) {
                                                            validate16.errors = [
                                                                {
                                                                    instancePath: instancePath + '/csvFolder/uploadID',
                                                                    schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                    keyword: 'uid',
                                                                    params: { error: 'decoded' },
                                                                    message: 'must decode to 9 bytes'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        else {
                                                            const encoded0 = func15(decoded0);
                                                            if (func16(encoded0) !== func16(data3)) {
                                                                validate16.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/csvFolder/uploadID',
                                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                        keyword: 'uid',
                                                                        params: { error: 'ambiguous' },
                                                                        message: 'encoding is ambiguous'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                    }
                                                }
                                                else {
                                                    validate16.errors = [
                                                        {
                                                            instancePath: instancePath + '/csvFolder/uploadID',
                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid2 = _errs8 === errors;
                                        }
                                        else {
                                            var valid2 = true;
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            validate16.errors = [
                                {
                                    instancePath: instancePath + '/csvFolder',
                                    schemaPath: 'urn:wisepipe-common:S3File/type',
                                    keyword: 'type',
                                    params: { type: 'object' },
                                    message: 'must be object'
                                }
                            ];
                            return false;
                        }
                    }
                }
            }
        }
        else {
            validate16.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate16.errors = vErrors;
    return errors === 0;
}
export const excelExtractionSchemaValidation = validate17;
const schema35 = {
    $id: 'urn:wisepipe-common-export:ExcelExtraction',
    type: 'object',
    properties: { excelFolder: { $ref: 'urn:wisepipe-common:S3File' } },
    required: ['excelFolder']
};
const func19 = ucs2length;
const func20 = base64urlToBuffer;
const func21 = base64urlEncode;
const func22 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate17(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-export:ExcelExtraction" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.excelFolder === undefined && (missing0 = 'excelFolder')) {
                validate17.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.excelFolder !== undefined) {
                    let data0 = data.excelFolder;
                    const _errs2 = errors;
                    if (errors === _errs2) {
                        if (data0 && typeof data0 == 'object' && !Array.isArray(data0)) {
                            let missing1;
                            if ((data0.bucket === undefined && (missing1 = 'bucket')) ||
                                (data0.key === undefined && (missing1 = 'key'))) {
                                validate17.errors = [
                                    {
                                        instancePath: instancePath + '/excelFolder',
                                        schemaPath: 'urn:wisepipe-common:S3File/required',
                                        keyword: 'required',
                                        params: { missingProperty: missing1 },
                                        message: "must have required property '" + missing1 + "'"
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (data0.bucket !== undefined) {
                                    let data1 = data0.bucket;
                                    const _errs4 = errors;
                                    if (errors === _errs4) {
                                        if (typeof data1 === 'string') {
                                            if (func2(data1) < 1) {
                                                validate17.errors = [
                                                    {
                                                        instancePath: instancePath + '/excelFolder/bucket',
                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/bucket/minLength',
                                                        keyword: 'minLength',
                                                        params: { limit: 1 },
                                                        message: 'must NOT have fewer than 1 characters'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate17.errors = [
                                                {
                                                    instancePath: instancePath + '/excelFolder/bucket',
                                                    schemaPath: 'urn:wisepipe-common:S3File/properties/bucket/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid2 = _errs4 === errors;
                                }
                                else {
                                    var valid2 = true;
                                }
                                if (valid2) {
                                    if (data0.key !== undefined) {
                                        let data2 = data0.key;
                                        const _errs6 = errors;
                                        if (errors === _errs6) {
                                            if (typeof data2 === 'string') {
                                                if (func2(data2) < 1) {
                                                    validate17.errors = [
                                                        {
                                                            instancePath: instancePath + '/excelFolder/key',
                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/key/minLength',
                                                            keyword: 'minLength',
                                                            params: { limit: 1 },
                                                            message: 'must NOT have fewer than 1 characters'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            else {
                                                validate17.errors = [
                                                    {
                                                        instancePath: instancePath + '/excelFolder/key',
                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/key/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid2 = _errs6 === errors;
                                    }
                                    else {
                                        var valid2 = true;
                                    }
                                    if (valid2) {
                                        if (data0.uploadID !== undefined) {
                                            let data3 = data0.uploadID;
                                            const _errs8 = errors;
                                            if (errors === _errs8) {
                                                if (typeof data3 === 'string') {
                                                    const b64min0 = Math.ceil((4 * 9) / 3);
                                                    const b64max0 = Math.ceil((4 * 9) / 3) + 3;
                                                    if (func19(data3) < b64min0 || func19(data3) > b64max0) {
                                                        validate17.errors = [
                                                            {
                                                                instancePath: instancePath + '/excelFolder/uploadID',
                                                                schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                keyword: 'uid',
                                                                params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func19(data3) },
                                                                message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func19(data3)
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    else {
                                                        const decoded0 = func20(data3);
                                                        if (decoded0.length !== 9) {
                                                            validate17.errors = [
                                                                {
                                                                    instancePath: instancePath + '/excelFolder/uploadID',
                                                                    schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                    keyword: 'uid',
                                                                    params: { error: 'decoded' },
                                                                    message: 'must decode to 9 bytes'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        else {
                                                            const encoded0 = func21(decoded0);
                                                            if (func22(encoded0) !== func22(data3)) {
                                                                validate17.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/excelFolder/uploadID',
                                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                        keyword: 'uid',
                                                                        params: { error: 'ambiguous' },
                                                                        message: 'encoding is ambiguous'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                    }
                                                }
                                                else {
                                                    validate17.errors = [
                                                        {
                                                            instancePath: instancePath + '/excelFolder/uploadID',
                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid2 = _errs8 === errors;
                                        }
                                        else {
                                            var valid2 = true;
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            validate17.errors = [
                                {
                                    instancePath: instancePath + '/excelFolder',
                                    schemaPath: 'urn:wisepipe-common:S3File/type',
                                    keyword: 'type',
                                    params: { type: 'object' },
                                    message: 'must be object'
                                }
                            ];
                            return false;
                        }
                    }
                }
            }
        }
        else {
            validate17.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate17.errors = vErrors;
    return errors === 0;
}
export const exportCompletedWarningSchemaValidation = validate18;
const schema37 = {
    $id: 'urn:wisepipe-common-export:ExportCompletedWarning',
    type: 'object',
    properties: {
        code: { type: 'string', enum: ['GSheetsMaxCellLimitReached', 'workdayPayrollPartialFailure'] },
        message: { type: 'string' }
    },
    required: ['code']
};
function validate18(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-export:ExportCompletedWarning" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.code === undefined && (missing0 = 'code')) {
                validate18.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.code !== undefined) {
                    let data0 = data.code;
                    const _errs1 = errors;
                    if (typeof data0 !== 'string') {
                        validate18.errors = [
                            {
                                instancePath: instancePath + '/code',
                                schemaPath: '#/properties/code/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    if (!(data0 === 'GSheetsMaxCellLimitReached' || data0 === 'workdayPayrollPartialFailure')) {
                        validate18.errors = [
                            {
                                instancePath: instancePath + '/code',
                                schemaPath: '#/properties/code/enum',
                                keyword: 'enum',
                                params: { allowedValues: schema37.properties.code.enum },
                                message: 'must be equal to one of the allowed values'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.message !== undefined) {
                        const _errs3 = errors;
                        if (typeof data.message !== 'string') {
                            validate18.errors = [
                                {
                                    instancePath: instancePath + '/message',
                                    schemaPath: '#/properties/message/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate18.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate18.errors = vErrors;
    return errors === 0;
}
export const exportInputSchemaValidation = validate19;
const schema38 = {
    $id: 'urn:wisepipe-common-export:ExportInput',
    type: 'object',
    properties: {
        exportTask: { $ref: 'urn:wisepipe-common-export:ExportTask' },
        exportTaskEnv: { $ref: 'urn:wisepipe-common-export:ExportTaskEnv' }
    },
    required: []
};
const schema39 = {
    $id: 'urn:wisepipe-common-export:ExportTask',
    type: 'object',
    properties: {
        userID: { type: 'string', format: 'uuid' },
        userName: { type: 'string' },
        userEmail: { type: 'string' },
        orgID: { type: 'string', format: 'uuid' },
        orgPlan: { type: 'string', enum: ['Social', 'Enterprise', 'Integration', 'Temp', 'Starter', 'Professional'] },
        exportTaskID: { type: 'string', uid: 9 },
        name: { type: 'string', minLength: 1 },
        exportID: { type: 'string', uid: 9 },
        elementID: { type: 'string', uid: 10 },
        parquetS3File: { $ref: 'urn:wisepipe-common:S3File' },
        pipeID: { type: 'string' },
        runName: { type: 'string' },
        randomSampleLocation: { $ref: 'urn:wisepipe-common:S3File' },
        sampleLocation: { $ref: 'urn:wisepipe-common:S3File' },
        rowCountS3File: { $ref: 'urn:wisepipe-common:S3File' },
        schemaS3File: { $ref: 'urn:wisepipe-common:S3File' },
        status: { type: 'string', enum: ['running', 'completed', 'failed', 'cancelled'] },
        startTime: { type: 'string', format: 'date-time' },
        endTime: { type: 'string', format: 'date-time' },
        warnings: { type: 'array', items: { $ref: 'urn:wisepipe-common-export:ExportCompletedWarning' } },
        transient: { type: 'boolean' },
        error: { type: 'object' }
    },
    if: { properties: { status: { const: 'completed' } } },
    then: { required: ['endTime'] },
    else: {
        if: { properties: { status: { const: 'cancelled' } } },
        then: { required: ['endTime'] },
        else: { if: { properties: { status: { const: 'failed' } } }, then: { required: ['error', 'endTime'] } }
    },
    required: ['userID', 'orgID', 'exportTaskID', 'name', 'exportID', 'parquetS3File', 'status', 'startTime', 'warnings']
};
const formats2 = /^(?:urn:uuid:)?[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}$/i;
const func23 = ucs2length;
const func24 = base64urlToBuffer;
const func25 = base64urlEncode;
const func26 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func28 = ucs2length;
const func29 = base64urlToBuffer;
const func30 = base64urlEncode;
const func31 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func32 = ucs2length;
const func33 = base64urlToBuffer;
const func34 = base64urlEncode;
const func35 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func38 = ucs2length;
const func39 = base64urlToBuffer;
const func40 = base64urlEncode;
const func41 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func44 = ucs2length;
const func45 = base64urlToBuffer;
const func46 = base64urlEncode;
const func47 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func50 = ucs2length;
const func51 = base64urlToBuffer;
const func52 = base64urlEncode;
const func53 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func56 = ucs2length;
const func57 = base64urlToBuffer;
const func58 = base64urlEncode;
const func59 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func62 = ucs2length;
const func63 = base64urlToBuffer;
const func64 = base64urlEncode;
const func65 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate20(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-export:ExportTask" */ let vErrors = null;
    let errors = 0;
    const _errs1 = errors;
    let valid0 = true;
    const _errs2 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        if (data.status !== undefined) {
            if ('completed' !== data.status) {
                const err0 = {};
                if (vErrors === null) {
                    vErrors = [err0];
                }
                else {
                    vErrors.push(err0);
                }
                errors++;
            }
        }
    }
    var _valid0 = _errs2 === errors;
    errors = _errs1;
    if (vErrors !== null) {
        if (_errs1) {
            vErrors.length = _errs1;
        }
        else {
            vErrors = null;
        }
    }
    let ifClause0;
    if (_valid0) {
        const _errs4 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.endTime === undefined && (missing0 = 'endTime')) {
                validate20.errors = [
                    {
                        instancePath,
                        schemaPath: '#/then/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
        }
        var _valid0 = _errs4 === errors;
        valid0 = _valid0;
        ifClause0 = 'then';
    }
    else {
        const _errs5 = errors;
        const _errs6 = errors;
        let valid2 = true;
        const _errs7 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.status !== undefined) {
                if ('cancelled' !== data.status) {
                    const err1 = {};
                    if (vErrors === null) {
                        vErrors = [err1];
                    }
                    else {
                        vErrors.push(err1);
                    }
                    errors++;
                }
            }
        }
        var _valid1 = _errs7 === errors;
        errors = _errs6;
        if (vErrors !== null) {
            if (_errs6) {
                vErrors.length = _errs6;
            }
            else {
                vErrors = null;
            }
        }
        let ifClause1;
        if (_valid1) {
            const _errs9 = errors;
            if (data && typeof data == 'object' && !Array.isArray(data)) {
                let missing1;
                if (data.endTime === undefined && (missing1 = 'endTime')) {
                    validate20.errors = [
                        {
                            instancePath,
                            schemaPath: '#/else/then/required',
                            keyword: 'required',
                            params: { missingProperty: missing1 },
                            message: "must have required property '" + missing1 + "'"
                        }
                    ];
                    return false;
                }
            }
            var _valid1 = _errs9 === errors;
            valid2 = _valid1;
            ifClause1 = 'then';
        }
        else {
            const _errs10 = errors;
            const _errs11 = errors;
            let valid4 = true;
            const _errs12 = errors;
            if (data && typeof data == 'object' && !Array.isArray(data)) {
                if (data.status !== undefined) {
                    if ('failed' !== data.status) {
                        const err2 = {};
                        if (vErrors === null) {
                            vErrors = [err2];
                        }
                        else {
                            vErrors.push(err2);
                        }
                        errors++;
                    }
                }
            }
            var _valid2 = _errs12 === errors;
            errors = _errs11;
            if (vErrors !== null) {
                if (_errs11) {
                    vErrors.length = _errs11;
                }
                else {
                    vErrors = null;
                }
            }
            if (_valid2) {
                const _errs14 = errors;
                if (data && typeof data == 'object' && !Array.isArray(data)) {
                    let missing2;
                    if ((data.error === undefined && (missing2 = 'error')) ||
                        (data.endTime === undefined && (missing2 = 'endTime'))) {
                        validate20.errors = [
                            {
                                instancePath,
                                schemaPath: '#/else/else/then/required',
                                keyword: 'required',
                                params: { missingProperty: missing2 },
                                message: "must have required property '" + missing2 + "'"
                            }
                        ];
                        return false;
                    }
                }
                var _valid2 = _errs14 === errors;
                valid4 = _valid2;
            }
            if (!valid4) {
                const err3 = {
                    instancePath,
                    schemaPath: '#/else/else/if',
                    keyword: 'if',
                    params: { failingKeyword: 'then' },
                    message: 'must match "then" schema'
                };
                if (vErrors === null) {
                    vErrors = [err3];
                }
                else {
                    vErrors.push(err3);
                }
                errors++;
                validate20.errors = vErrors;
                return false;
            }
            var _valid1 = _errs10 === errors;
            valid2 = _valid1;
            ifClause1 = 'else';
        }
        if (!valid2) {
            const err4 = {
                instancePath,
                schemaPath: '#/else/if',
                keyword: 'if',
                params: { failingKeyword: ifClause1 },
                message: 'must match "' + ifClause1 + '" schema'
            };
            if (vErrors === null) {
                vErrors = [err4];
            }
            else {
                vErrors.push(err4);
            }
            errors++;
            validate20.errors = vErrors;
            return false;
        }
        var _valid0 = _errs5 === errors;
        valid0 = _valid0;
        ifClause0 = 'else';
    }
    if (!valid0) {
        const err5 = {
            instancePath,
            schemaPath: '#/if',
            keyword: 'if',
            params: { failingKeyword: ifClause0 },
            message: 'must match "' + ifClause0 + '" schema'
        };
        if (vErrors === null) {
            vErrors = [err5];
        }
        else {
            vErrors.push(err5);
        }
        errors++;
        validate20.errors = vErrors;
        return false;
    }
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing3;
            if ((data.userID === undefined && (missing3 = 'userID')) ||
                (data.orgID === undefined && (missing3 = 'orgID')) ||
                (data.exportTaskID === undefined && (missing3 = 'exportTaskID')) ||
                (data.name === undefined && (missing3 = 'name')) ||
                (data.exportID === undefined && (missing3 = 'exportID')) ||
                (data.parquetS3File === undefined && (missing3 = 'parquetS3File')) ||
                (data.status === undefined && (missing3 = 'status')) ||
                (data.startTime === undefined && (missing3 = 'startTime')) ||
                (data.warnings === undefined && (missing3 = 'warnings'))) {
                validate20.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing3 },
                        message: "must have required property '" + missing3 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.userID !== undefined) {
                    let data3 = data.userID;
                    const _errs15 = errors;
                    if (errors === _errs15) {
                        if (errors === _errs15) {
                            if (typeof data3 === 'string') {
                                if (!formats2.test(data3)) {
                                    validate20.errors = [
                                        {
                                            instancePath: instancePath + '/userID',
                                            schemaPath: '#/properties/userID/format',
                                            keyword: 'format',
                                            params: { format: 'uuid' },
                                            message: 'must match format "' + 'uuid' + '"'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate20.errors = [
                                    {
                                        instancePath: instancePath + '/userID',
                                        schemaPath: '#/properties/userID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                    }
                    var valid6 = _errs15 === errors;
                }
                else {
                    var valid6 = true;
                }
                if (valid6) {
                    if (data.userName !== undefined) {
                        const _errs17 = errors;
                        if (typeof data.userName !== 'string') {
                            validate20.errors = [
                                {
                                    instancePath: instancePath + '/userName',
                                    schemaPath: '#/properties/userName/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        var valid6 = _errs17 === errors;
                    }
                    else {
                        var valid6 = true;
                    }
                    if (valid6) {
                        if (data.userEmail !== undefined) {
                            const _errs19 = errors;
                            if (typeof data.userEmail !== 'string') {
                                validate20.errors = [
                                    {
                                        instancePath: instancePath + '/userEmail',
                                        schemaPath: '#/properties/userEmail/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                            var valid6 = _errs19 === errors;
                        }
                        else {
                            var valid6 = true;
                        }
                        if (valid6) {
                            if (data.orgID !== undefined) {
                                let data6 = data.orgID;
                                const _errs21 = errors;
                                if (errors === _errs21) {
                                    if (errors === _errs21) {
                                        if (typeof data6 === 'string') {
                                            if (!formats2.test(data6)) {
                                                validate20.errors = [
                                                    {
                                                        instancePath: instancePath + '/orgID',
                                                        schemaPath: '#/properties/orgID/format',
                                                        keyword: 'format',
                                                        params: { format: 'uuid' },
                                                        message: 'must match format "' + 'uuid' + '"'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate20.errors = [
                                                {
                                                    instancePath: instancePath + '/orgID',
                                                    schemaPath: '#/properties/orgID/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                                var valid6 = _errs21 === errors;
                            }
                            else {
                                var valid6 = true;
                            }
                            if (valid6) {
                                if (data.orgPlan !== undefined) {
                                    let data7 = data.orgPlan;
                                    const _errs23 = errors;
                                    if (typeof data7 !== 'string') {
                                        validate20.errors = [
                                            {
                                                instancePath: instancePath + '/orgPlan',
                                                schemaPath: '#/properties/orgPlan/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                    if (!(data7 === 'Social' ||
                                        data7 === 'Enterprise' ||
                                        data7 === 'Integration' ||
                                        data7 === 'Temp' ||
                                        data7 === 'Starter' ||
                                        data7 === 'Professional')) {
                                        validate20.errors = [
                                            {
                                                instancePath: instancePath + '/orgPlan',
                                                schemaPath: '#/properties/orgPlan/enum',
                                                keyword: 'enum',
                                                params: { allowedValues: schema39.properties.orgPlan.enum },
                                                message: 'must be equal to one of the allowed values'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid6 = _errs23 === errors;
                                }
                                else {
                                    var valid6 = true;
                                }
                                if (valid6) {
                                    if (data.exportTaskID !== undefined) {
                                        let data8 = data.exportTaskID;
                                        const _errs25 = errors;
                                        if (errors === _errs25) {
                                            if (typeof data8 === 'string') {
                                                const b64min0 = Math.ceil((4 * 9) / 3);
                                                const b64max0 = Math.ceil((4 * 9) / 3) + 3;
                                                if (func23(data8) < b64min0 || func23(data8) > b64max0) {
                                                    validate20.errors = [
                                                        {
                                                            instancePath: instancePath + '/exportTaskID',
                                                            schemaPath: '#/properties/exportTaskID/uid',
                                                            keyword: 'uid',
                                                            params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func23(data8) },
                                                            message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func23(data8)
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                else {
                                                    const decoded0 = func24(data8);
                                                    if (decoded0.length !== 9) {
                                                        validate20.errors = [
                                                            {
                                                                instancePath: instancePath + '/exportTaskID',
                                                                schemaPath: '#/properties/exportTaskID/uid',
                                                                keyword: 'uid',
                                                                params: { error: 'decoded' },
                                                                message: 'must decode to 9 bytes'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    else {
                                                        const encoded0 = func25(decoded0);
                                                        if (func26(encoded0) !== func26(data8)) {
                                                            validate20.errors = [
                                                                {
                                                                    instancePath: instancePath + '/exportTaskID',
                                                                    schemaPath: '#/properties/exportTaskID/uid',
                                                                    keyword: 'uid',
                                                                    params: { error: 'ambiguous' },
                                                                    message: 'encoding is ambiguous'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                }
                                            }
                                            else {
                                                validate20.errors = [
                                                    {
                                                        instancePath: instancePath + '/exportTaskID',
                                                        schemaPath: '#/properties/exportTaskID/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid6 = _errs25 === errors;
                                    }
                                    else {
                                        var valid6 = true;
                                    }
                                    if (valid6) {
                                        if (data.name !== undefined) {
                                            let data9 = data.name;
                                            const _errs27 = errors;
                                            if (errors === _errs27) {
                                                if (typeof data9 === 'string') {
                                                    if (func2(data9) < 1) {
                                                        validate20.errors = [
                                                            {
                                                                instancePath: instancePath + '/name',
                                                                schemaPath: '#/properties/name/minLength',
                                                                keyword: 'minLength',
                                                                params: { limit: 1 },
                                                                message: 'must NOT have fewer than 1 characters'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                else {
                                                    validate20.errors = [
                                                        {
                                                            instancePath: instancePath + '/name',
                                                            schemaPath: '#/properties/name/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid6 = _errs27 === errors;
                                        }
                                        else {
                                            var valid6 = true;
                                        }
                                        if (valid6) {
                                            if (data.exportID !== undefined) {
                                                let data10 = data.exportID;
                                                const _errs29 = errors;
                                                if (errors === _errs29) {
                                                    if (typeof data10 === 'string') {
                                                        const b64min1 = Math.ceil((4 * 9) / 3);
                                                        const b64max1 = Math.ceil((4 * 9) / 3) + 3;
                                                        if (func28(data10) < b64min1 || func28(data10) > b64max1) {
                                                            validate20.errors = [
                                                                {
                                                                    instancePath: instancePath + '/exportID',
                                                                    schemaPath: '#/properties/exportID/uid',
                                                                    keyword: 'uid',
                                                                    params: {
                                                                        error: 'encoded',
                                                                        b64min: b64min1,
                                                                        b64max: b64max1,
                                                                        length: func28(data10)
                                                                    },
                                                                    message: 'length must be between ' +
                                                                        b64min1 +
                                                                        ' and ' +
                                                                        b64max1 +
                                                                        ', but is ' +
                                                                        func28(data10)
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        else {
                                                            const decoded1 = func29(data10);
                                                            if (decoded1.length !== 9) {
                                                                validate20.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/exportID',
                                                                        schemaPath: '#/properties/exportID/uid',
                                                                        keyword: 'uid',
                                                                        params: { error: 'decoded' },
                                                                        message: 'must decode to 9 bytes'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            else {
                                                                const encoded1 = func30(decoded1);
                                                                if (func31(encoded1) !== func31(data10)) {
                                                                    validate20.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/exportID',
                                                                            schemaPath: '#/properties/exportID/uid',
                                                                            keyword: 'uid',
                                                                            params: { error: 'ambiguous' },
                                                                            message: 'encoding is ambiguous'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                        }
                                                    }
                                                    else {
                                                        validate20.errors = [
                                                            {
                                                                instancePath: instancePath + '/exportID',
                                                                schemaPath: '#/properties/exportID/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                var valid6 = _errs29 === errors;
                                            }
                                            else {
                                                var valid6 = true;
                                            }
                                            if (valid6) {
                                                if (data.elementID !== undefined) {
                                                    let data11 = data.elementID;
                                                    const _errs31 = errors;
                                                    if (errors === _errs31) {
                                                        if (typeof data11 === 'string') {
                                                            const b64min2 = Math.ceil((4 * 10) / 3);
                                                            const b64max2 = Math.ceil((4 * 10) / 3) + 3;
                                                            if (func32(data11) < b64min2 || func32(data11) > b64max2) {
                                                                validate20.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/elementID',
                                                                        schemaPath: '#/properties/elementID/uid',
                                                                        keyword: 'uid',
                                                                        params: {
                                                                            error: 'encoded',
                                                                            b64min: b64min2,
                                                                            b64max: b64max2,
                                                                            length: func32(data11)
                                                                        },
                                                                        message: 'length must be between ' +
                                                                            b64min2 +
                                                                            ' and ' +
                                                                            b64max2 +
                                                                            ', but is ' +
                                                                            func32(data11)
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            else {
                                                                const decoded2 = func33(data11);
                                                                if (decoded2.length !== 10) {
                                                                    validate20.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/elementID',
                                                                            schemaPath: '#/properties/elementID/uid',
                                                                            keyword: 'uid',
                                                                            params: { error: 'decoded' },
                                                                            message: 'must decode to 10 bytes'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                                else {
                                                                    const encoded2 = func34(decoded2);
                                                                    if (func35(encoded2) !== func35(data11)) {
                                                                        validate20.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/elementID',
                                                                                schemaPath: '#/properties/elementID/uid',
                                                                                keyword: 'uid',
                                                                                params: { error: 'ambiguous' },
                                                                                message: 'encoding is ambiguous'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                            }
                                                        }
                                                        else {
                                                            validate20.errors = [
                                                                {
                                                                    instancePath: instancePath + '/elementID',
                                                                    schemaPath: '#/properties/elementID/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    var valid6 = _errs31 === errors;
                                                }
                                                else {
                                                    var valid6 = true;
                                                }
                                                if (valid6) {
                                                    if (data.parquetS3File !== undefined) {
                                                        let data12 = data.parquetS3File;
                                                        const _errs33 = errors;
                                                        const _errs34 = errors;
                                                        if (errors === _errs34) {
                                                            if (data12 && typeof data12 == 'object' && !Array.isArray(data12)) {
                                                                let missing4;
                                                                if ((data12.bucket === undefined && (missing4 = 'bucket')) ||
                                                                    (data12.key === undefined && (missing4 = 'key'))) {
                                                                    validate20.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/parquetS3File',
                                                                            schemaPath: 'urn:wisepipe-common:S3File/required',
                                                                            keyword: 'required',
                                                                            params: { missingProperty: missing4 },
                                                                            message: "must have required property '" + missing4 + "'"
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                                else {
                                                                    if (data12.bucket !== undefined) {
                                                                        let data13 = data12.bucket;
                                                                        const _errs36 = errors;
                                                                        if (errors === _errs36) {
                                                                            if (typeof data13 === 'string') {
                                                                                if (func2(data13) < 1) {
                                                                                    validate20.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/parquetS3File/bucket',
                                                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/bucket/minLength',
                                                                                            keyword: 'minLength',
                                                                                            params: { limit: 1 },
                                                                                            message: 'must NOT have fewer than 1 characters'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                            }
                                                                            else {
                                                                                validate20.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/parquetS3File/bucket',
                                                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/bucket/type',
                                                                                        keyword: 'type',
                                                                                        params: { type: 'string' },
                                                                                        message: 'must be string'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                        }
                                                                        var valid11 = _errs36 === errors;
                                                                    }
                                                                    else {
                                                                        var valid11 = true;
                                                                    }
                                                                    if (valid11) {
                                                                        if (data12.key !== undefined) {
                                                                            let data14 = data12.key;
                                                                            const _errs38 = errors;
                                                                            if (errors === _errs38) {
                                                                                if (typeof data14 === 'string') {
                                                                                    if (func2(data14) < 1) {
                                                                                        validate20.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/parquetS3File/key',
                                                                                                schemaPath: 'urn:wisepipe-common:S3File/properties/key/minLength',
                                                                                                keyword: 'minLength',
                                                                                                params: { limit: 1 },
                                                                                                message: 'must NOT have fewer than 1 characters'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                }
                                                                                else {
                                                                                    validate20.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/parquetS3File/key',
                                                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/key/type',
                                                                                            keyword: 'type',
                                                                                            params: { type: 'string' },
                                                                                            message: 'must be string'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                            }
                                                                            var valid11 = _errs38 === errors;
                                                                        }
                                                                        else {
                                                                            var valid11 = true;
                                                                        }
                                                                        if (valid11) {
                                                                            if (data12.uploadID !== undefined) {
                                                                                let data15 = data12.uploadID;
                                                                                const _errs40 = errors;
                                                                                if (errors === _errs40) {
                                                                                    if (typeof data15 === 'string') {
                                                                                        const b64min3 = Math.ceil((4 * 9) / 3);
                                                                                        const b64max3 = Math.ceil((4 * 9) / 3) + 3;
                                                                                        if (func38(data15) < b64min3 || func38(data15) > b64max3) {
                                                                                            validate20.errors = [
                                                                                                {
                                                                                                    instancePath: instancePath + '/parquetS3File/uploadID',
                                                                                                    schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                                                    keyword: 'uid',
                                                                                                    params: {
                                                                                                        error: 'encoded',
                                                                                                        b64min: b64min3,
                                                                                                        b64max: b64max3,
                                                                                                        length: func38(data15)
                                                                                                    },
                                                                                                    message: 'length must be between ' +
                                                                                                        b64min3 +
                                                                                                        ' and ' +
                                                                                                        b64max3 +
                                                                                                        ', but is ' +
                                                                                                        func38(data15)
                                                                                                }
                                                                                            ];
                                                                                            return false;
                                                                                        }
                                                                                        else {
                                                                                            const decoded3 = func39(data15);
                                                                                            if (decoded3.length !== 9) {
                                                                                                validate20.errors = [
                                                                                                    {
                                                                                                        instancePath: instancePath + '/parquetS3File/uploadID',
                                                                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                                                        keyword: 'uid',
                                                                                                        params: { error: 'decoded' },
                                                                                                        message: 'must decode to 9 bytes'
                                                                                                    }
                                                                                                ];
                                                                                                return false;
                                                                                            }
                                                                                            else {
                                                                                                const encoded3 = func40(decoded3);
                                                                                                if (func41(encoded3) !== func41(data15)) {
                                                                                                    validate20.errors = [
                                                                                                        {
                                                                                                            instancePath: instancePath + '/parquetS3File/uploadID',
                                                                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                                                            keyword: 'uid',
                                                                                                            params: { error: 'ambiguous' },
                                                                                                            message: 'encoding is ambiguous'
                                                                                                        }
                                                                                                    ];
                                                                                                    return false;
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                    else {
                                                                                        validate20.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/parquetS3File/uploadID',
                                                                                                schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/type',
                                                                                                keyword: 'type',
                                                                                                params: { type: 'string' },
                                                                                                message: 'must be string'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                }
                                                                                var valid11 = _errs40 === errors;
                                                                            }
                                                                            else {
                                                                                var valid11 = true;
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                            else {
                                                                validate20.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/parquetS3File',
                                                                        schemaPath: 'urn:wisepipe-common:S3File/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'object' },
                                                                        message: 'must be object'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        var valid6 = _errs33 === errors;
                                                    }
                                                    else {
                                                        var valid6 = true;
                                                    }
                                                    if (valid6) {
                                                        if (data.pipeID !== undefined) {
                                                            const _errs42 = errors;
                                                            if (typeof data.pipeID !== 'string') {
                                                                validate20.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/pipeID',
                                                                        schemaPath: '#/properties/pipeID/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'string' },
                                                                        message: 'must be string'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            var valid6 = _errs42 === errors;
                                                        }
                                                        else {
                                                            var valid6 = true;
                                                        }
                                                        if (valid6) {
                                                            if (data.runName !== undefined) {
                                                                const _errs44 = errors;
                                                                if (typeof data.runName !== 'string') {
                                                                    validate20.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/runName',
                                                                            schemaPath: '#/properties/runName/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'string' },
                                                                            message: 'must be string'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                                var valid6 = _errs44 === errors;
                                                            }
                                                            else {
                                                                var valid6 = true;
                                                            }
                                                            if (valid6) {
                                                                if (data.randomSampleLocation !== undefined) {
                                                                    let data18 = data.randomSampleLocation;
                                                                    const _errs46 = errors;
                                                                    const _errs47 = errors;
                                                                    if (errors === _errs47) {
                                                                        if (data18 && typeof data18 == 'object' && !Array.isArray(data18)) {
                                                                            let missing5;
                                                                            if ((data18.bucket === undefined && (missing5 = 'bucket')) ||
                                                                                (data18.key === undefined && (missing5 = 'key'))) {
                                                                                validate20.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/randomSampleLocation',
                                                                                        schemaPath: 'urn:wisepipe-common:S3File/required',
                                                                                        keyword: 'required',
                                                                                        params: { missingProperty: missing5 },
                                                                                        message: "must have required property '" + missing5 + "'"
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                            else {
                                                                                if (data18.bucket !== undefined) {
                                                                                    let data19 = data18.bucket;
                                                                                    const _errs49 = errors;
                                                                                    if (errors === _errs49) {
                                                                                        if (typeof data19 === 'string') {
                                                                                            if (func2(data19) < 1) {
                                                                                                validate20.errors = [
                                                                                                    {
                                                                                                        instancePath: instancePath + '/randomSampleLocation/bucket',
                                                                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/bucket/minLength',
                                                                                                        keyword: 'minLength',
                                                                                                        params: { limit: 1 },
                                                                                                        message: 'must NOT have fewer than 1 characters'
                                                                                                    }
                                                                                                ];
                                                                                                return false;
                                                                                            }
                                                                                        }
                                                                                        else {
                                                                                            validate20.errors = [
                                                                                                {
                                                                                                    instancePath: instancePath + '/randomSampleLocation/bucket',
                                                                                                    schemaPath: 'urn:wisepipe-common:S3File/properties/bucket/type',
                                                                                                    keyword: 'type',
                                                                                                    params: { type: 'string' },
                                                                                                    message: 'must be string'
                                                                                                }
                                                                                            ];
                                                                                            return false;
                                                                                        }
                                                                                    }
                                                                                    var valid14 = _errs49 === errors;
                                                                                }
                                                                                else {
                                                                                    var valid14 = true;
                                                                                }
                                                                                if (valid14) {
                                                                                    if (data18.key !== undefined) {
                                                                                        let data20 = data18.key;
                                                                                        const _errs51 = errors;
                                                                                        if (errors === _errs51) {
                                                                                            if (typeof data20 === 'string') {
                                                                                                if (func2(data20) < 1) {
                                                                                                    validate20.errors = [
                                                                                                        {
                                                                                                            instancePath: instancePath + '/randomSampleLocation/key',
                                                                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/key/minLength',
                                                                                                            keyword: 'minLength',
                                                                                                            params: { limit: 1 },
                                                                                                            message: 'must NOT have fewer than 1 characters'
                                                                                                        }
                                                                                                    ];
                                                                                                    return false;
                                                                                                }
                                                                                            }
                                                                                            else {
                                                                                                validate20.errors = [
                                                                                                    {
                                                                                                        instancePath: instancePath + '/randomSampleLocation/key',
                                                                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/key/type',
                                                                                                        keyword: 'type',
                                                                                                        params: { type: 'string' },
                                                                                                        message: 'must be string'
                                                                                                    }
                                                                                                ];
                                                                                                return false;
                                                                                            }
                                                                                        }
                                                                                        var valid14 = _errs51 === errors;
                                                                                    }
                                                                                    else {
                                                                                        var valid14 = true;
                                                                                    }
                                                                                    if (valid14) {
                                                                                        if (data18.uploadID !== undefined) {
                                                                                            let data21 = data18.uploadID;
                                                                                            const _errs53 = errors;
                                                                                            if (errors === _errs53) {
                                                                                                if (typeof data21 === 'string') {
                                                                                                    const b64min4 = Math.ceil((4 * 9) / 3);
                                                                                                    const b64max4 = Math.ceil((4 * 9) / 3) + 3;
                                                                                                    if (func44(data21) < b64min4 || func44(data21) > b64max4) {
                                                                                                        validate20.errors = [
                                                                                                            {
                                                                                                                instancePath: instancePath + '/randomSampleLocation/uploadID',
                                                                                                                schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                                                                keyword: 'uid',
                                                                                                                params: {
                                                                                                                    error: 'encoded',
                                                                                                                    b64min: b64min4,
                                                                                                                    b64max: b64max4,
                                                                                                                    length: func44(data21)
                                                                                                                },
                                                                                                                message: 'length must be between ' +
                                                                                                                    b64min4 +
                                                                                                                    ' and ' +
                                                                                                                    b64max4 +
                                                                                                                    ', but is ' +
                                                                                                                    func44(data21)
                                                                                                            }
                                                                                                        ];
                                                                                                        return false;
                                                                                                    }
                                                                                                    else {
                                                                                                        const decoded4 = func45(data21);
                                                                                                        if (decoded4.length !== 9) {
                                                                                                            validate20.errors = [
                                                                                                                {
                                                                                                                    instancePath: instancePath + '/randomSampleLocation/uploadID',
                                                                                                                    schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                                                                    keyword: 'uid',
                                                                                                                    params: { error: 'decoded' },
                                                                                                                    message: 'must decode to 9 bytes'
                                                                                                                }
                                                                                                            ];
                                                                                                            return false;
                                                                                                        }
                                                                                                        else {
                                                                                                            const encoded4 = func46(decoded4);
                                                                                                            if (func47(encoded4) !== func47(data21)) {
                                                                                                                validate20.errors = [
                                                                                                                    {
                                                                                                                        instancePath: instancePath + '/randomSampleLocation/uploadID',
                                                                                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                                                                        keyword: 'uid',
                                                                                                                        params: { error: 'ambiguous' },
                                                                                                                        message: 'encoding is ambiguous'
                                                                                                                    }
                                                                                                                ];
                                                                                                                return false;
                                                                                                            }
                                                                                                        }
                                                                                                    }
                                                                                                }
                                                                                                else {
                                                                                                    validate20.errors = [
                                                                                                        {
                                                                                                            instancePath: instancePath + '/randomSampleLocation/uploadID',
                                                                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/type',
                                                                                                            keyword: 'type',
                                                                                                            params: { type: 'string' },
                                                                                                            message: 'must be string'
                                                                                                        }
                                                                                                    ];
                                                                                                    return false;
                                                                                                }
                                                                                            }
                                                                                            var valid14 = _errs53 === errors;
                                                                                        }
                                                                                        else {
                                                                                            var valid14 = true;
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                        else {
                                                                            validate20.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/randomSampleLocation',
                                                                                    schemaPath: 'urn:wisepipe-common:S3File/type',
                                                                                    keyword: 'type',
                                                                                    params: { type: 'object' },
                                                                                    message: 'must be object'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                    }
                                                                    var valid6 = _errs46 === errors;
                                                                }
                                                                else {
                                                                    var valid6 = true;
                                                                }
                                                                if (valid6) {
                                                                    if (data.sampleLocation !== undefined) {
                                                                        let data22 = data.sampleLocation;
                                                                        const _errs55 = errors;
                                                                        const _errs56 = errors;
                                                                        if (errors === _errs56) {
                                                                            if (data22 && typeof data22 == 'object' && !Array.isArray(data22)) {
                                                                                let missing6;
                                                                                if ((data22.bucket === undefined && (missing6 = 'bucket')) ||
                                                                                    (data22.key === undefined && (missing6 = 'key'))) {
                                                                                    validate20.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/sampleLocation',
                                                                                            schemaPath: 'urn:wisepipe-common:S3File/required',
                                                                                            keyword: 'required',
                                                                                            params: { missingProperty: missing6 },
                                                                                            message: "must have required property '" + missing6 + "'"
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                                else {
                                                                                    if (data22.bucket !== undefined) {
                                                                                        let data23 = data22.bucket;
                                                                                        const _errs58 = errors;
                                                                                        if (errors === _errs58) {
                                                                                            if (typeof data23 === 'string') {
                                                                                                if (func2(data23) < 1) {
                                                                                                    validate20.errors = [
                                                                                                        {
                                                                                                            instancePath: instancePath + '/sampleLocation/bucket',
                                                                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/bucket/minLength',
                                                                                                            keyword: 'minLength',
                                                                                                            params: { limit: 1 },
                                                                                                            message: 'must NOT have fewer than 1 characters'
                                                                                                        }
                                                                                                    ];
                                                                                                    return false;
                                                                                                }
                                                                                            }
                                                                                            else {
                                                                                                validate20.errors = [
                                                                                                    {
                                                                                                        instancePath: instancePath + '/sampleLocation/bucket',
                                                                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/bucket/type',
                                                                                                        keyword: 'type',
                                                                                                        params: { type: 'string' },
                                                                                                        message: 'must be string'
                                                                                                    }
                                                                                                ];
                                                                                                return false;
                                                                                            }
                                                                                        }
                                                                                        var valid17 = _errs58 === errors;
                                                                                    }
                                                                                    else {
                                                                                        var valid17 = true;
                                                                                    }
                                                                                    if (valid17) {
                                                                                        if (data22.key !== undefined) {
                                                                                            let data24 = data22.key;
                                                                                            const _errs60 = errors;
                                                                                            if (errors === _errs60) {
                                                                                                if (typeof data24 === 'string') {
                                                                                                    if (func2(data24) < 1) {
                                                                                                        validate20.errors = [
                                                                                                            {
                                                                                                                instancePath: instancePath + '/sampleLocation/key',
                                                                                                                schemaPath: 'urn:wisepipe-common:S3File/properties/key/minLength',
                                                                                                                keyword: 'minLength',
                                                                                                                params: { limit: 1 },
                                                                                                                message: 'must NOT have fewer than 1 characters'
                                                                                                            }
                                                                                                        ];
                                                                                                        return false;
                                                                                                    }
                                                                                                }
                                                                                                else {
                                                                                                    validate20.errors = [
                                                                                                        {
                                                                                                            instancePath: instancePath + '/sampleLocation/key',
                                                                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/key/type',
                                                                                                            keyword: 'type',
                                                                                                            params: { type: 'string' },
                                                                                                            message: 'must be string'
                                                                                                        }
                                                                                                    ];
                                                                                                    return false;
                                                                                                }
                                                                                            }
                                                                                            var valid17 = _errs60 === errors;
                                                                                        }
                                                                                        else {
                                                                                            var valid17 = true;
                                                                                        }
                                                                                        if (valid17) {
                                                                                            if (data22.uploadID !== undefined) {
                                                                                                let data25 = data22.uploadID;
                                                                                                const _errs62 = errors;
                                                                                                if (errors === _errs62) {
                                                                                                    if (typeof data25 === 'string') {
                                                                                                        const b64min5 = Math.ceil((4 * 9) / 3);
                                                                                                        const b64max5 = Math.ceil((4 * 9) / 3) + 3;
                                                                                                        if (func50(data25) < b64min5 || func50(data25) > b64max5) {
                                                                                                            validate20.errors = [
                                                                                                                {
                                                                                                                    instancePath: instancePath + '/sampleLocation/uploadID',
                                                                                                                    schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                                                                    keyword: 'uid',
                                                                                                                    params: {
                                                                                                                        error: 'encoded',
                                                                                                                        b64min: b64min5,
                                                                                                                        b64max: b64max5,
                                                                                                                        length: func50(data25)
                                                                                                                    },
                                                                                                                    message: 'length must be between ' +
                                                                                                                        b64min5 +
                                                                                                                        ' and ' +
                                                                                                                        b64max5 +
                                                                                                                        ', but is ' +
                                                                                                                        func50(data25)
                                                                                                                }
                                                                                                            ];
                                                                                                            return false;
                                                                                                        }
                                                                                                        else {
                                                                                                            const decoded5 = func51(data25);
                                                                                                            if (decoded5.length !== 9) {
                                                                                                                validate20.errors = [
                                                                                                                    {
                                                                                                                        instancePath: instancePath + '/sampleLocation/uploadID',
                                                                                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                                                                        keyword: 'uid',
                                                                                                                        params: { error: 'decoded' },
                                                                                                                        message: 'must decode to 9 bytes'
                                                                                                                    }
                                                                                                                ];
                                                                                                                return false;
                                                                                                            }
                                                                                                            else {
                                                                                                                const encoded5 = func52(decoded5);
                                                                                                                if (func53(encoded5) !== func53(data25)) {
                                                                                                                    validate20.errors = [
                                                                                                                        {
                                                                                                                            instancePath: instancePath + '/sampleLocation/uploadID',
                                                                                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                                                                            keyword: 'uid',
                                                                                                                            params: { error: 'ambiguous' },
                                                                                                                            message: 'encoding is ambiguous'
                                                                                                                        }
                                                                                                                    ];
                                                                                                                    return false;
                                                                                                                }
                                                                                                            }
                                                                                                        }
                                                                                                    }
                                                                                                    else {
                                                                                                        validate20.errors = [
                                                                                                            {
                                                                                                                instancePath: instancePath + '/sampleLocation/uploadID',
                                                                                                                schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/type',
                                                                                                                keyword: 'type',
                                                                                                                params: { type: 'string' },
                                                                                                                message: 'must be string'
                                                                                                            }
                                                                                                        ];
                                                                                                        return false;
                                                                                                    }
                                                                                                }
                                                                                                var valid17 = _errs62 === errors;
                                                                                            }
                                                                                            else {
                                                                                                var valid17 = true;
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                            else {
                                                                                validate20.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/sampleLocation',
                                                                                        schemaPath: 'urn:wisepipe-common:S3File/type',
                                                                                        keyword: 'type',
                                                                                        params: { type: 'object' },
                                                                                        message: 'must be object'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                        }
                                                                        var valid6 = _errs55 === errors;
                                                                    }
                                                                    else {
                                                                        var valid6 = true;
                                                                    }
                                                                    if (valid6) {
                                                                        if (data.rowCountS3File !== undefined) {
                                                                            let data26 = data.rowCountS3File;
                                                                            const _errs64 = errors;
                                                                            const _errs65 = errors;
                                                                            if (errors === _errs65) {
                                                                                if (data26 && typeof data26 == 'object' && !Array.isArray(data26)) {
                                                                                    let missing7;
                                                                                    if ((data26.bucket === undefined && (missing7 = 'bucket')) ||
                                                                                        (data26.key === undefined && (missing7 = 'key'))) {
                                                                                        validate20.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/rowCountS3File',
                                                                                                schemaPath: 'urn:wisepipe-common:S3File/required',
                                                                                                keyword: 'required',
                                                                                                params: { missingProperty: missing7 },
                                                                                                message: "must have required property '" + missing7 + "'"
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                    else {
                                                                                        if (data26.bucket !== undefined) {
                                                                                            let data27 = data26.bucket;
                                                                                            const _errs67 = errors;
                                                                                            if (errors === _errs67) {
                                                                                                if (typeof data27 === 'string') {
                                                                                                    if (func2(data27) < 1) {
                                                                                                        validate20.errors = [
                                                                                                            {
                                                                                                                instancePath: instancePath + '/rowCountS3File/bucket',
                                                                                                                schemaPath: 'urn:wisepipe-common:S3File/properties/bucket/minLength',
                                                                                                                keyword: 'minLength',
                                                                                                                params: { limit: 1 },
                                                                                                                message: 'must NOT have fewer than 1 characters'
                                                                                                            }
                                                                                                        ];
                                                                                                        return false;
                                                                                                    }
                                                                                                }
                                                                                                else {
                                                                                                    validate20.errors = [
                                                                                                        {
                                                                                                            instancePath: instancePath + '/rowCountS3File/bucket',
                                                                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/bucket/type',
                                                                                                            keyword: 'type',
                                                                                                            params: { type: 'string' },
                                                                                                            message: 'must be string'
                                                                                                        }
                                                                                                    ];
                                                                                                    return false;
                                                                                                }
                                                                                            }
                                                                                            var valid20 = _errs67 === errors;
                                                                                        }
                                                                                        else {
                                                                                            var valid20 = true;
                                                                                        }
                                                                                        if (valid20) {
                                                                                            if (data26.key !== undefined) {
                                                                                                let data28 = data26.key;
                                                                                                const _errs69 = errors;
                                                                                                if (errors === _errs69) {
                                                                                                    if (typeof data28 === 'string') {
                                                                                                        if (func2(data28) < 1) {
                                                                                                            validate20.errors = [
                                                                                                                {
                                                                                                                    instancePath: instancePath + '/rowCountS3File/key',
                                                                                                                    schemaPath: 'urn:wisepipe-common:S3File/properties/key/minLength',
                                                                                                                    keyword: 'minLength',
                                                                                                                    params: { limit: 1 },
                                                                                                                    message: 'must NOT have fewer than 1 characters'
                                                                                                                }
                                                                                                            ];
                                                                                                            return false;
                                                                                                        }
                                                                                                    }
                                                                                                    else {
                                                                                                        validate20.errors = [
                                                                                                            {
                                                                                                                instancePath: instancePath + '/rowCountS3File/key',
                                                                                                                schemaPath: 'urn:wisepipe-common:S3File/properties/key/type',
                                                                                                                keyword: 'type',
                                                                                                                params: { type: 'string' },
                                                                                                                message: 'must be string'
                                                                                                            }
                                                                                                        ];
                                                                                                        return false;
                                                                                                    }
                                                                                                }
                                                                                                var valid20 = _errs69 === errors;
                                                                                            }
                                                                                            else {
                                                                                                var valid20 = true;
                                                                                            }
                                                                                            if (valid20) {
                                                                                                if (data26.uploadID !== undefined) {
                                                                                                    let data29 = data26.uploadID;
                                                                                                    const _errs71 = errors;
                                                                                                    if (errors === _errs71) {
                                                                                                        if (typeof data29 === 'string') {
                                                                                                            const b64min6 = Math.ceil((4 * 9) / 3);
                                                                                                            const b64max6 = Math.ceil((4 * 9) / 3) + 3;
                                                                                                            if (func56(data29) < b64min6 || func56(data29) > b64max6) {
                                                                                                                validate20.errors = [
                                                                                                                    {
                                                                                                                        instancePath: instancePath + '/rowCountS3File/uploadID',
                                                                                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                                                                        keyword: 'uid',
                                                                                                                        params: {
                                                                                                                            error: 'encoded',
                                                                                                                            b64min: b64min6,
                                                                                                                            b64max: b64max6,
                                                                                                                            length: func56(data29)
                                                                                                                        },
                                                                                                                        message: 'length must be between ' +
                                                                                                                            b64min6 +
                                                                                                                            ' and ' +
                                                                                                                            b64max6 +
                                                                                                                            ', but is ' +
                                                                                                                            func56(data29)
                                                                                                                    }
                                                                                                                ];
                                                                                                                return false;
                                                                                                            }
                                                                                                            else {
                                                                                                                const decoded6 = func57(data29);
                                                                                                                if (decoded6.length !== 9) {
                                                                                                                    validate20.errors = [
                                                                                                                        {
                                                                                                                            instancePath: instancePath + '/rowCountS3File/uploadID',
                                                                                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                                                                            keyword: 'uid',
                                                                                                                            params: { error: 'decoded' },
                                                                                                                            message: 'must decode to 9 bytes'
                                                                                                                        }
                                                                                                                    ];
                                                                                                                    return false;
                                                                                                                }
                                                                                                                else {
                                                                                                                    const encoded6 = func58(decoded6);
                                                                                                                    if (func59(encoded6) !== func59(data29)) {
                                                                                                                        validate20.errors = [
                                                                                                                            {
                                                                                                                                instancePath: instancePath + '/rowCountS3File/uploadID',
                                                                                                                                schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                                                                                keyword: 'uid',
                                                                                                                                params: { error: 'ambiguous' },
                                                                                                                                message: 'encoding is ambiguous'
                                                                                                                            }
                                                                                                                        ];
                                                                                                                        return false;
                                                                                                                    }
                                                                                                                }
                                                                                                            }
                                                                                                        }
                                                                                                        else {
                                                                                                            validate20.errors = [
                                                                                                                {
                                                                                                                    instancePath: instancePath + '/rowCountS3File/uploadID',
                                                                                                                    schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/type',
                                                                                                                    keyword: 'type',
                                                                                                                    params: { type: 'string' },
                                                                                                                    message: 'must be string'
                                                                                                                }
                                                                                                            ];
                                                                                                            return false;
                                                                                                        }
                                                                                                    }
                                                                                                    var valid20 = _errs71 === errors;
                                                                                                }
                                                                                                else {
                                                                                                    var valid20 = true;
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                                else {
                                                                                    validate20.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/rowCountS3File',
                                                                                            schemaPath: 'urn:wisepipe-common:S3File/type',
                                                                                            keyword: 'type',
                                                                                            params: { type: 'object' },
                                                                                            message: 'must be object'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                            }
                                                                            var valid6 = _errs64 === errors;
                                                                        }
                                                                        else {
                                                                            var valid6 = true;
                                                                        }
                                                                        if (valid6) {
                                                                            if (data.schemaS3File !== undefined) {
                                                                                let data30 = data.schemaS3File;
                                                                                const _errs73 = errors;
                                                                                const _errs74 = errors;
                                                                                if (errors === _errs74) {
                                                                                    if (data30 && typeof data30 == 'object' && !Array.isArray(data30)) {
                                                                                        let missing8;
                                                                                        if ((data30.bucket === undefined && (missing8 = 'bucket')) ||
                                                                                            (data30.key === undefined && (missing8 = 'key'))) {
                                                                                            validate20.errors = [
                                                                                                {
                                                                                                    instancePath: instancePath + '/schemaS3File',
                                                                                                    schemaPath: 'urn:wisepipe-common:S3File/required',
                                                                                                    keyword: 'required',
                                                                                                    params: { missingProperty: missing8 },
                                                                                                    message: "must have required property '" + missing8 + "'"
                                                                                                }
                                                                                            ];
                                                                                            return false;
                                                                                        }
                                                                                        else {
                                                                                            if (data30.bucket !== undefined) {
                                                                                                let data31 = data30.bucket;
                                                                                                const _errs76 = errors;
                                                                                                if (errors === _errs76) {
                                                                                                    if (typeof data31 === 'string') {
                                                                                                        if (func2(data31) < 1) {
                                                                                                            validate20.errors = [
                                                                                                                {
                                                                                                                    instancePath: instancePath + '/schemaS3File/bucket',
                                                                                                                    schemaPath: 'urn:wisepipe-common:S3File/properties/bucket/minLength',
                                                                                                                    keyword: 'minLength',
                                                                                                                    params: { limit: 1 },
                                                                                                                    message: 'must NOT have fewer than 1 characters'
                                                                                                                }
                                                                                                            ];
                                                                                                            return false;
                                                                                                        }
                                                                                                    }
                                                                                                    else {
                                                                                                        validate20.errors = [
                                                                                                            {
                                                                                                                instancePath: instancePath + '/schemaS3File/bucket',
                                                                                                                schemaPath: 'urn:wisepipe-common:S3File/properties/bucket/type',
                                                                                                                keyword: 'type',
                                                                                                                params: { type: 'string' },
                                                                                                                message: 'must be string'
                                                                                                            }
                                                                                                        ];
                                                                                                        return false;
                                                                                                    }
                                                                                                }
                                                                                                var valid23 = _errs76 === errors;
                                                                                            }
                                                                                            else {
                                                                                                var valid23 = true;
                                                                                            }
                                                                                            if (valid23) {
                                                                                                if (data30.key !== undefined) {
                                                                                                    let data32 = data30.key;
                                                                                                    const _errs78 = errors;
                                                                                                    if (errors === _errs78) {
                                                                                                        if (typeof data32 === 'string') {
                                                                                                            if (func2(data32) < 1) {
                                                                                                                validate20.errors = [
                                                                                                                    {
                                                                                                                        instancePath: instancePath + '/schemaS3File/key',
                                                                                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/key/minLength',
                                                                                                                        keyword: 'minLength',
                                                                                                                        params: { limit: 1 },
                                                                                                                        message: 'must NOT have fewer than 1 characters'
                                                                                                                    }
                                                                                                                ];
                                                                                                                return false;
                                                                                                            }
                                                                                                        }
                                                                                                        else {
                                                                                                            validate20.errors = [
                                                                                                                {
                                                                                                                    instancePath: instancePath + '/schemaS3File/key',
                                                                                                                    schemaPath: 'urn:wisepipe-common:S3File/properties/key/type',
                                                                                                                    keyword: 'type',
                                                                                                                    params: { type: 'string' },
                                                                                                                    message: 'must be string'
                                                                                                                }
                                                                                                            ];
                                                                                                            return false;
                                                                                                        }
                                                                                                    }
                                                                                                    var valid23 = _errs78 === errors;
                                                                                                }
                                                                                                else {
                                                                                                    var valid23 = true;
                                                                                                }
                                                                                                if (valid23) {
                                                                                                    if (data30.uploadID !== undefined) {
                                                                                                        let data33 = data30.uploadID;
                                                                                                        const _errs80 = errors;
                                                                                                        if (errors === _errs80) {
                                                                                                            if (typeof data33 === 'string') {
                                                                                                                const b64min7 = Math.ceil((4 * 9) / 3);
                                                                                                                const b64max7 = Math.ceil((4 * 9) / 3) + 3;
                                                                                                                if (func62(data33) < b64min7 || func62(data33) > b64max7) {
                                                                                                                    validate20.errors = [
                                                                                                                        {
                                                                                                                            instancePath: instancePath + '/schemaS3File/uploadID',
                                                                                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                                                                            keyword: 'uid',
                                                                                                                            params: {
                                                                                                                                error: 'encoded',
                                                                                                                                b64min: b64min7,
                                                                                                                                b64max: b64max7,
                                                                                                                                length: func62(data33)
                                                                                                                            },
                                                                                                                            message: 'length must be between ' +
                                                                                                                                b64min7 +
                                                                                                                                ' and ' +
                                                                                                                                b64max7 +
                                                                                                                                ', but is ' +
                                                                                                                                func62(data33)
                                                                                                                        }
                                                                                                                    ];
                                                                                                                    return false;
                                                                                                                }
                                                                                                                else {
                                                                                                                    const decoded7 = func63(data33);
                                                                                                                    if (decoded7.length !== 9) {
                                                                                                                        validate20.errors = [
                                                                                                                            {
                                                                                                                                instancePath: instancePath + '/schemaS3File/uploadID',
                                                                                                                                schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                                                                                keyword: 'uid',
                                                                                                                                params: { error: 'decoded' },
                                                                                                                                message: 'must decode to 9 bytes'
                                                                                                                            }
                                                                                                                        ];
                                                                                                                        return false;
                                                                                                                    }
                                                                                                                    else {
                                                                                                                        const encoded7 = func64(decoded7);
                                                                                                                        if (func65(encoded7) !== func65(data33)) {
                                                                                                                            validate20.errors = [
                                                                                                                                {
                                                                                                                                    instancePath: instancePath + '/schemaS3File/uploadID',
                                                                                                                                    schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                                                                                    keyword: 'uid',
                                                                                                                                    params: { error: 'ambiguous' },
                                                                                                                                    message: 'encoding is ambiguous'
                                                                                                                                }
                                                                                                                            ];
                                                                                                                            return false;
                                                                                                                        }
                                                                                                                    }
                                                                                                                }
                                                                                                            }
                                                                                                            else {
                                                                                                                validate20.errors = [
                                                                                                                    {
                                                                                                                        instancePath: instancePath + '/schemaS3File/uploadID',
                                                                                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/type',
                                                                                                                        keyword: 'type',
                                                                                                                        params: { type: 'string' },
                                                                                                                        message: 'must be string'
                                                                                                                    }
                                                                                                                ];
                                                                                                                return false;
                                                                                                            }
                                                                                                        }
                                                                                                        var valid23 = _errs80 === errors;
                                                                                                    }
                                                                                                    else {
                                                                                                        var valid23 = true;
                                                                                                    }
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                    else {
                                                                                        validate20.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/schemaS3File',
                                                                                                schemaPath: 'urn:wisepipe-common:S3File/type',
                                                                                                keyword: 'type',
                                                                                                params: { type: 'object' },
                                                                                                message: 'must be object'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                }
                                                                                var valid6 = _errs73 === errors;
                                                                            }
                                                                            else {
                                                                                var valid6 = true;
                                                                            }
                                                                            if (valid6) {
                                                                                if (data.status !== undefined) {
                                                                                    let data34 = data.status;
                                                                                    const _errs82 = errors;
                                                                                    if (typeof data34 !== 'string') {
                                                                                        validate20.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/status',
                                                                                                schemaPath: '#/properties/status/type',
                                                                                                keyword: 'type',
                                                                                                params: { type: 'string' },
                                                                                                message: 'must be string'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                    if (!(data34 === 'running' ||
                                                                                        data34 === 'completed' ||
                                                                                        data34 === 'failed' ||
                                                                                        data34 === 'cancelled')) {
                                                                                        validate20.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/status',
                                                                                                schemaPath: '#/properties/status/enum',
                                                                                                keyword: 'enum',
                                                                                                params: { allowedValues: schema39.properties.status.enum },
                                                                                                message: 'must be equal to one of the allowed values'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                    var valid6 = _errs82 === errors;
                                                                                }
                                                                                else {
                                                                                    var valid6 = true;
                                                                                }
                                                                                if (valid6) {
                                                                                    if (data.startTime !== undefined) {
                                                                                        let data35 = data.startTime;
                                                                                        const _errs84 = errors;
                                                                                        if (errors === _errs84) {
                                                                                            if (errors === _errs84) {
                                                                                                if (typeof data35 === 'string') {
                                                                                                    if (!formats0.validate(data35)) {
                                                                                                        validate20.errors = [
                                                                                                            {
                                                                                                                instancePath: instancePath + '/startTime',
                                                                                                                schemaPath: '#/properties/startTime/format',
                                                                                                                keyword: 'format',
                                                                                                                params: { format: 'date-time' },
                                                                                                                message: 'must match format "' + 'date-time' + '"'
                                                                                                            }
                                                                                                        ];
                                                                                                        return false;
                                                                                                    }
                                                                                                }
                                                                                                else {
                                                                                                    validate20.errors = [
                                                                                                        {
                                                                                                            instancePath: instancePath + '/startTime',
                                                                                                            schemaPath: '#/properties/startTime/type',
                                                                                                            keyword: 'type',
                                                                                                            params: { type: 'string' },
                                                                                                            message: 'must be string'
                                                                                                        }
                                                                                                    ];
                                                                                                    return false;
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                        var valid6 = _errs84 === errors;
                                                                                    }
                                                                                    else {
                                                                                        var valid6 = true;
                                                                                    }
                                                                                    if (valid6) {
                                                                                        if (data.endTime !== undefined) {
                                                                                            let data36 = data.endTime;
                                                                                            const _errs86 = errors;
                                                                                            if (errors === _errs86) {
                                                                                                if (errors === _errs86) {
                                                                                                    if (typeof data36 === 'string') {
                                                                                                        if (!formats0.validate(data36)) {
                                                                                                            validate20.errors = [
                                                                                                                {
                                                                                                                    instancePath: instancePath + '/endTime',
                                                                                                                    schemaPath: '#/properties/endTime/format',
                                                                                                                    keyword: 'format',
                                                                                                                    params: { format: 'date-time' },
                                                                                                                    message: 'must match format "' + 'date-time' + '"'
                                                                                                                }
                                                                                                            ];
                                                                                                            return false;
                                                                                                        }
                                                                                                    }
                                                                                                    else {
                                                                                                        validate20.errors = [
                                                                                                            {
                                                                                                                instancePath: instancePath + '/endTime',
                                                                                                                schemaPath: '#/properties/endTime/type',
                                                                                                                keyword: 'type',
                                                                                                                params: { type: 'string' },
                                                                                                                message: 'must be string'
                                                                                                            }
                                                                                                        ];
                                                                                                        return false;
                                                                                                    }
                                                                                                }
                                                                                            }
                                                                                            var valid6 = _errs86 === errors;
                                                                                        }
                                                                                        else {
                                                                                            var valid6 = true;
                                                                                        }
                                                                                        if (valid6) {
                                                                                            if (data.warnings !== undefined) {
                                                                                                let data37 = data.warnings;
                                                                                                const _errs88 = errors;
                                                                                                if (errors === _errs88) {
                                                                                                    if (Array.isArray(data37)) {
                                                                                                        var valid25 = true;
                                                                                                        const len0 = data37.length;
                                                                                                        for (let i0 = 0; i0 < len0; i0++) {
                                                                                                            let data38 = data37[i0];
                                                                                                            const _errs90 = errors;
                                                                                                            const _errs91 = errors;
                                                                                                            if (errors === _errs91) {
                                                                                                                if (data38 &&
                                                                                                                    typeof data38 == 'object' &&
                                                                                                                    !Array.isArray(data38)) {
                                                                                                                    let missing9;
                                                                                                                    if (data38.code === undefined && (missing9 = 'code')) {
                                                                                                                        validate20.errors = [
                                                                                                                            {
                                                                                                                                instancePath: instancePath + '/warnings/' + i0,
                                                                                                                                schemaPath: 'urn:wisepipe-common-export:ExportCompletedWarning/required',
                                                                                                                                keyword: 'required',
                                                                                                                                params: { missingProperty: missing9 },
                                                                                                                                message: "must have required property '" + missing9 + "'"
                                                                                                                            }
                                                                                                                        ];
                                                                                                                        return false;
                                                                                                                    }
                                                                                                                    else {
                                                                                                                        if (data38.code !== undefined) {
                                                                                                                            let data39 = data38.code;
                                                                                                                            const _errs93 = errors;
                                                                                                                            if (typeof data39 !== 'string') {
                                                                                                                                validate20.errors = [
                                                                                                                                    {
                                                                                                                                        instancePath: instancePath + '/warnings/' + i0 + '/code',
                                                                                                                                        schemaPath: 'urn:wisepipe-common-export:ExportCompletedWarning/properties/code/type',
                                                                                                                                        keyword: 'type',
                                                                                                                                        params: { type: 'string' },
                                                                                                                                        message: 'must be string'
                                                                                                                                    }
                                                                                                                                ];
                                                                                                                                return false;
                                                                                                                            }
                                                                                                                            if (!(data39 === 'GSheetsMaxCellLimitReached' ||
                                                                                                                                data39 === 'workdayPayrollPartialFailure')) {
                                                                                                                                validate20.errors = [
                                                                                                                                    {
                                                                                                                                        instancePath: instancePath + '/warnings/' + i0 + '/code',
                                                                                                                                        schemaPath: 'urn:wisepipe-common-export:ExportCompletedWarning/properties/code/enum',
                                                                                                                                        keyword: 'enum',
                                                                                                                                        params: {
                                                                                                                                            allowedValues: schema37.properties.code.enum
                                                                                                                                        },
                                                                                                                                        message: 'must be equal to one of the allowed values'
                                                                                                                                    }
                                                                                                                                ];
                                                                                                                                return false;
                                                                                                                            }
                                                                                                                            var valid27 = _errs93 === errors;
                                                                                                                        }
                                                                                                                        else {
                                                                                                                            var valid27 = true;
                                                                                                                        }
                                                                                                                        if (valid27) {
                                                                                                                            if (data38.message !== undefined) {
                                                                                                                                const _errs95 = errors;
                                                                                                                                if (typeof data38.message !== 'string') {
                                                                                                                                    validate20.errors = [
                                                                                                                                        {
                                                                                                                                            instancePath: instancePath + '/warnings/' + i0 + '/message',
                                                                                                                                            schemaPath: 'urn:wisepipe-common-export:ExportCompletedWarning/properties/message/type',
                                                                                                                                            keyword: 'type',
                                                                                                                                            params: { type: 'string' },
                                                                                                                                            message: 'must be string'
                                                                                                                                        }
                                                                                                                                    ];
                                                                                                                                    return false;
                                                                                                                                }
                                                                                                                                var valid27 = _errs95 === errors;
                                                                                                                            }
                                                                                                                            else {
                                                                                                                                var valid27 = true;
                                                                                                                            }
                                                                                                                        }
                                                                                                                    }
                                                                                                                }
                                                                                                                else {
                                                                                                                    validate20.errors = [
                                                                                                                        {
                                                                                                                            instancePath: instancePath + '/warnings/' + i0,
                                                                                                                            schemaPath: 'urn:wisepipe-common-export:ExportCompletedWarning/type',
                                                                                                                            keyword: 'type',
                                                                                                                            params: { type: 'object' },
                                                                                                                            message: 'must be object'
                                                                                                                        }
                                                                                                                    ];
                                                                                                                    return false;
                                                                                                                }
                                                                                                            }
                                                                                                            var valid25 = _errs90 === errors;
                                                                                                            if (!valid25) {
                                                                                                                break;
                                                                                                            }
                                                                                                        }
                                                                                                    }
                                                                                                    else {
                                                                                                        validate20.errors = [
                                                                                                            {
                                                                                                                instancePath: instancePath + '/warnings',
                                                                                                                schemaPath: '#/properties/warnings/type',
                                                                                                                keyword: 'type',
                                                                                                                params: { type: 'array' },
                                                                                                                message: 'must be array'
                                                                                                            }
                                                                                                        ];
                                                                                                        return false;
                                                                                                    }
                                                                                                }
                                                                                                var valid6 = _errs88 === errors;
                                                                                            }
                                                                                            else {
                                                                                                var valid6 = true;
                                                                                            }
                                                                                            if (valid6) {
                                                                                                if (data.transient !== undefined) {
                                                                                                    const _errs97 = errors;
                                                                                                    if (typeof data.transient !== 'boolean') {
                                                                                                        validate20.errors = [
                                                                                                            {
                                                                                                                instancePath: instancePath + '/transient',
                                                                                                                schemaPath: '#/properties/transient/type',
                                                                                                                keyword: 'type',
                                                                                                                params: { type: 'boolean' },
                                                                                                                message: 'must be boolean'
                                                                                                            }
                                                                                                        ];
                                                                                                        return false;
                                                                                                    }
                                                                                                    var valid6 = _errs97 === errors;
                                                                                                }
                                                                                                else {
                                                                                                    var valid6 = true;
                                                                                                }
                                                                                                if (valid6) {
                                                                                                    if (data.error !== undefined) {
                                                                                                        let data42 = data.error;
                                                                                                        const _errs99 = errors;
                                                                                                        if (!(data42 && typeof data42 == 'object' && !Array.isArray(data42))) {
                                                                                                            validate20.errors = [
                                                                                                                {
                                                                                                                    instancePath: instancePath + '/error',
                                                                                                                    schemaPath: '#/properties/error/type',
                                                                                                                    keyword: 'type',
                                                                                                                    params: { type: 'object' },
                                                                                                                    message: 'must be object'
                                                                                                                }
                                                                                                            ];
                                                                                                            return false;
                                                                                                        }
                                                                                                        var valid6 = _errs99 === errors;
                                                                                                    }
                                                                                                    else {
                                                                                                        var valid6 = true;
                                                                                                    }
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate20.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate20.errors = vErrors;
    return errors === 0;
}
const schema46 = {
    $id: 'urn:wisepipe-common-export:ExportTaskEnv',
    type: 'object',
    properties: {
        stage: { type: 'string', minLength: 1 },
        googleClientIDParam: { type: 'string', minLength: 1 },
        googleClientSecretParam: { type: 'string', minLength: 1 },
        googleSheetsExportClientIDParam: { type: 'string', minLength: 1 },
        googleSheetsExportClientSecretParam: { type: 'string', minLength: 1 },
        salesforceClientIDParam: { type: 'string', minLength: 1 },
        salesforceClientSecretParam: { type: 'string', minLength: 1 },
        powerbiClientIDParam: { type: 'string', minLength: 1 },
        powerbiClientSecretParam: { type: 'string', minLength: 1 },
        oneDriveClientIDParam: { type: 'string', minLength: 1 },
        oneDriveClientSecretParam: { type: 'string', minLength: 1 },
        connection: { $ref: 'urn:wisepipe-common-connection:Connection' },
        credentials: { $ref: 'urn:wisepipe-common:Credentials' },
        awsS3credentials: { $ref: 'urn:wisepipe-common-auth:AwsCredentials' },
        tempS3ExportsFolder: { $ref: 'urn:wisepipe-common:S3File' },
        taskAuthInfo: { $ref: 'urn:wisepipe-common-auth:TaskAuthInfo' },
        exportObj: { $ref: 'urn:wisepipe-common-export:Export' }
    },
    required: [
        'stage',
        'googleClientIDParam',
        'googleClientSecretParam',
        'googleSheetsExportClientIDParam',
        'googleSheetsExportClientSecretParam',
        'salesforceClientIDParam',
        'salesforceClientSecretParam',
        'powerbiClientIDParam',
        'powerbiClientSecretParam',
        'connection',
        'credentials',
        'exportObj'
    ]
};
const schema51 = {
    $id: 'urn:wisepipe-common-auth:TaskAuthInfo',
    type: 'object',
    properties: {
        orgID: { type: 'string', format: 'uuid' },
        userID: { type: 'string', format: 'uuid' },
        taskID: { type: 'string' },
        taskAuthToken: { type: 'string' },
        expiration: { type: 'integer' },
        endpoint: { type: 'string' }
    },
    required: ['orgID', 'userID', 'taskID', 'taskAuthToken', 'expiration']
};
const func77 = ucs2length;
const func78 = base64urlToBuffer;
const func79 = base64urlEncode;
const func80 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func88 = ucs2length;
const func89 = base64urlToBuffer;
const func90 = base64urlEncode;
const func91 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const schema52 = {
    $id: 'urn:wisepipe-common-export:Export',
    type: 'object',
    properties: {
        exportID: { type: 'string', uid: 9 },
        name: { type: 'string', minLength: 1 },
        connectionID: { type: 'string', uid: 9 },
        connectionType: {
            type: 'string',
            enum: [
                'google',
                'gsheetsImport',
                'gsheetsExport',
                'shopify',
                'salesForce',
                'postgreSql',
                'icm',
                'tq-postgres',
                'mySql',
                'msSql',
                'oracle',
                'amazonRedshift',
                'amazonAurora',
                'amazonS3',
                'amazonS3Export',
                'tqp',
                'hubspot',
                'symon',
                'snowflake',
                'dynamics',
                'agentSync',
                'workday',
                'workdayRaaS',
                'workdayExport',
                'tableau',
                'sftp',
                'powerbi',
                'rest',
                'gong',
                'netSuite',
                'oneDrive',
                'oneDriveExport',
                'sapSuccessFactors',
                'sapCrm',
                'ukg',
                'oracleHcm',
                'Adp',
                'dynamics365Sales',
                'ceridianDayforce',
                'oracleCrm',
                'oracleErpCloud',
                'sageIntacct',
                'bambooHr',
                'sapErp',
                'googleCloudPlatformCloudStorage',
                'sas',
                'dropbox',
                'googleDrive',
                'jira',
                'monday',
                'zuora',
                'adobeAnalytics',
                'zoomInfo',
                'marketo',
                'activeCampaign',
                'mailchimp',
                'infor',
                'cornerstoneOnDemand',
                'gusto',
                'paychexFlex',
                'zendesk',
                'serviceNow',
                'zohoCrm',
                'pipedrive',
                'quickBooks',
                'xero',
                'freshbooks',
                'zohoBooks',
                'waveFinancial'
            ]
        },
        exportSettings: { $ref: 'urn:wisepipe-common-export:ExportSettings' }
    },
    required: ['exportID', 'exportSettings']
};
const schema53 = {
    $id: 'urn:wisepipe-common-export:ExportSettings',
    type: 'object',
    properties: {
        exportType: {
            type: 'string',
            enum: [
                'gsheets',
                'icm',
                'postgres',
                'tq-postgres',
                'powerbi',
                'symon',
                'salesForce',
                'workday-payroll',
                'tableau',
                'tqp',
                'sftp',
                's3-csv',
                'snowflake',
                's3parquet',
                'msSql',
                'oneDrive'
            ]
        }
    },
    required: ['exportType']
};
const func92 = ucs2length;
const func93 = base64urlToBuffer;
const func94 = base64urlEncode;
const func95 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func97 = ucs2length;
const func98 = base64urlToBuffer;
const func99 = base64urlEncode;
const func100 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate23(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-export:Export" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.exportID === undefined && (missing0 = 'exportID')) ||
                (data.exportSettings === undefined && (missing0 = 'exportSettings'))) {
                validate23.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.exportID !== undefined) {
                    let data0 = data.exportID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            const b64min0 = Math.ceil((4 * 9) / 3);
                            const b64max0 = Math.ceil((4 * 9) / 3) + 3;
                            if (func92(data0) < b64min0 || func92(data0) > b64max0) {
                                validate23.errors = [
                                    {
                                        instancePath: instancePath + '/exportID',
                                        schemaPath: '#/properties/exportID/uid',
                                        keyword: 'uid',
                                        params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func92(data0) },
                                        message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func92(data0)
                                    }
                                ];
                                return false;
                            }
                            else {
                                const decoded0 = func93(data0);
                                if (decoded0.length !== 9) {
                                    validate23.errors = [
                                        {
                                            instancePath: instancePath + '/exportID',
                                            schemaPath: '#/properties/exportID/uid',
                                            keyword: 'uid',
                                            params: { error: 'decoded' },
                                            message: 'must decode to 9 bytes'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const encoded0 = func94(decoded0);
                                    if (func95(encoded0) !== func95(data0)) {
                                        validate23.errors = [
                                            {
                                                instancePath: instancePath + '/exportID',
                                                schemaPath: '#/properties/exportID/uid',
                                                keyword: 'uid',
                                                params: { error: 'ambiguous' },
                                                message: 'encoding is ambiguous'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                        }
                        else {
                            validate23.errors = [
                                {
                                    instancePath: instancePath + '/exportID',
                                    schemaPath: '#/properties/exportID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.name !== undefined) {
                        let data1 = data.name;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate23.errors = [
                                        {
                                            instancePath: instancePath + '/name',
                                            schemaPath: '#/properties/name/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate23.errors = [
                                    {
                                        instancePath: instancePath + '/name',
                                        schemaPath: '#/properties/name/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.connectionID !== undefined) {
                            let data2 = data.connectionID;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    const b64min1 = Math.ceil((4 * 9) / 3);
                                    const b64max1 = Math.ceil((4 * 9) / 3) + 3;
                                    if (func97(data2) < b64min1 || func97(data2) > b64max1) {
                                        validate23.errors = [
                                            {
                                                instancePath: instancePath + '/connectionID',
                                                schemaPath: '#/properties/connectionID/uid',
                                                keyword: 'uid',
                                                params: { error: 'encoded', b64min: b64min1, b64max: b64max1, length: func97(data2) },
                                                message: 'length must be between ' + b64min1 + ' and ' + b64max1 + ', but is ' + func97(data2)
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        const decoded1 = func98(data2);
                                        if (decoded1.length !== 9) {
                                            validate23.errors = [
                                                {
                                                    instancePath: instancePath + '/connectionID',
                                                    schemaPath: '#/properties/connectionID/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'decoded' },
                                                    message: 'must decode to 9 bytes'
                                                }
                                            ];
                                            return false;
                                        }
                                        else {
                                            const encoded1 = func99(decoded1);
                                            if (func100(encoded1) !== func100(data2)) {
                                                validate23.errors = [
                                                    {
                                                        instancePath: instancePath + '/connectionID',
                                                        schemaPath: '#/properties/connectionID/uid',
                                                        keyword: 'uid',
                                                        params: { error: 'ambiguous' },
                                                        message: 'encoding is ambiguous'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                    }
                                }
                                else {
                                    validate23.errors = [
                                        {
                                            instancePath: instancePath + '/connectionID',
                                            schemaPath: '#/properties/connectionID/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.connectionType !== undefined) {
                                let data3 = data.connectionType;
                                const _errs7 = errors;
                                if (typeof data3 !== 'string') {
                                    validate23.errors = [
                                        {
                                            instancePath: instancePath + '/connectionType',
                                            schemaPath: '#/properties/connectionType/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                                if (!(data3 === 'google' ||
                                    data3 === 'gsheetsImport' ||
                                    data3 === 'gsheetsExport' ||
                                    data3 === 'shopify' ||
                                    data3 === 'salesForce' ||
                                    data3 === 'postgreSql' ||
                                    data3 === 'icm' ||
                                    data3 === 'tq-postgres' ||
                                    data3 === 'mySql' ||
                                    data3 === 'msSql' ||
                                    data3 === 'oracle' ||
                                    data3 === 'amazonRedshift' ||
                                    data3 === 'amazonAurora' ||
                                    data3 === 'amazonS3' ||
                                    data3 === 'amazonS3Export' ||
                                    data3 === 'tqp' ||
                                    data3 === 'hubspot' ||
                                    data3 === 'symon' ||
                                    data3 === 'snowflake' ||
                                    data3 === 'dynamics' ||
                                    data3 === 'agentSync' ||
                                    data3 === 'workday' ||
                                    data3 === 'workdayRaaS' ||
                                    data3 === 'workdayExport' ||
                                    data3 === 'tableau' ||
                                    data3 === 'sftp' ||
                                    data3 === 'powerbi' ||
                                    data3 === 'rest' ||
                                    data3 === 'gong' ||
                                    data3 === 'netSuite' ||
                                    data3 === 'oneDrive' ||
                                    data3 === 'oneDriveExport' ||
                                    data3 === 'sapSuccessFactors' ||
                                    data3 === 'sapCrm' ||
                                    data3 === 'ukg' ||
                                    data3 === 'oracleHcm' ||
                                    data3 === 'Adp' ||
                                    data3 === 'dynamics365Sales' ||
                                    data3 === 'ceridianDayforce' ||
                                    data3 === 'oracleCrm' ||
                                    data3 === 'oracleErpCloud' ||
                                    data3 === 'sageIntacct' ||
                                    data3 === 'bambooHr' ||
                                    data3 === 'sapErp' ||
                                    data3 === 'googleCloudPlatformCloudStorage' ||
                                    data3 === 'sas' ||
                                    data3 === 'dropbox' ||
                                    data3 === 'googleDrive' ||
                                    data3 === 'jira' ||
                                    data3 === 'monday' ||
                                    data3 === 'zuora' ||
                                    data3 === 'adobeAnalytics' ||
                                    data3 === 'zoomInfo' ||
                                    data3 === 'marketo' ||
                                    data3 === 'activeCampaign' ||
                                    data3 === 'mailchimp' ||
                                    data3 === 'infor' ||
                                    data3 === 'cornerstoneOnDemand' ||
                                    data3 === 'gusto' ||
                                    data3 === 'paychexFlex' ||
                                    data3 === 'zendesk' ||
                                    data3 === 'serviceNow' ||
                                    data3 === 'zohoCrm' ||
                                    data3 === 'pipedrive' ||
                                    data3 === 'quickBooks' ||
                                    data3 === 'xero' ||
                                    data3 === 'freshbooks' ||
                                    data3 === 'zohoBooks' ||
                                    data3 === 'waveFinancial')) {
                                    validate23.errors = [
                                        {
                                            instancePath: instancePath + '/connectionType',
                                            schemaPath: '#/properties/connectionType/enum',
                                            keyword: 'enum',
                                            params: { allowedValues: schema52.properties.connectionType.enum },
                                            message: 'must be equal to one of the allowed values'
                                        }
                                    ];
                                    return false;
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.exportSettings !== undefined) {
                                    let data4 = data.exportSettings;
                                    const _errs9 = errors;
                                    const _errs10 = errors;
                                    if (errors === _errs10) {
                                        if (data4 && typeof data4 == 'object' && !Array.isArray(data4)) {
                                            let missing1;
                                            if (data4.exportType === undefined && (missing1 = 'exportType')) {
                                                validate23.errors = [
                                                    {
                                                        instancePath: instancePath + '/exportSettings',
                                                        schemaPath: 'urn:wisepipe-common-export:ExportSettings/required',
                                                        keyword: 'required',
                                                        params: { missingProperty: missing1 },
                                                        message: "must have required property '" + missing1 + "'"
                                                    }
                                                ];
                                                return false;
                                            }
                                            else {
                                                if (data4.exportType !== undefined) {
                                                    let data5 = data4.exportType;
                                                    if (typeof data5 !== 'string') {
                                                        validate23.errors = [
                                                            {
                                                                instancePath: instancePath + '/exportSettings/exportType',
                                                                schemaPath: 'urn:wisepipe-common-export:ExportSettings/properties/exportType/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    if (!(data5 === 'gsheets' ||
                                                        data5 === 'icm' ||
                                                        data5 === 'postgres' ||
                                                        data5 === 'tq-postgres' ||
                                                        data5 === 'powerbi' ||
                                                        data5 === 'symon' ||
                                                        data5 === 'salesForce' ||
                                                        data5 === 'workday-payroll' ||
                                                        data5 === 'tableau' ||
                                                        data5 === 'tqp' ||
                                                        data5 === 'sftp' ||
                                                        data5 === 's3-csv' ||
                                                        data5 === 'snowflake' ||
                                                        data5 === 's3parquet' ||
                                                        data5 === 'msSql' ||
                                                        data5 === 'oneDrive')) {
                                                        validate23.errors = [
                                                            {
                                                                instancePath: instancePath + '/exportSettings/exportType',
                                                                schemaPath: 'urn:wisepipe-common-export:ExportSettings/properties/exportType/enum',
                                                                keyword: 'enum',
                                                                params: { allowedValues: schema53.properties.exportType.enum },
                                                                message: 'must be equal to one of the allowed values'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                            }
                                        }
                                        else {
                                            validate23.errors = [
                                                {
                                                    instancePath: instancePath + '/exportSettings',
                                                    schemaPath: 'urn:wisepipe-common-export:ExportSettings/type',
                                                    keyword: 'type',
                                                    params: { type: 'object' },
                                                    message: 'must be object'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate23.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate23.errors = vErrors;
    return errors === 0;
}
function validate22(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-export:ExportTaskEnv" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.stage === undefined && (missing0 = 'stage')) ||
                (data.googleClientIDParam === undefined && (missing0 = 'googleClientIDParam')) ||
                (data.googleClientSecretParam === undefined && (missing0 = 'googleClientSecretParam')) ||
                (data.googleSheetsExportClientIDParam === undefined && (missing0 = 'googleSheetsExportClientIDParam')) ||
                (data.googleSheetsExportClientSecretParam === undefined &&
                    (missing0 = 'googleSheetsExportClientSecretParam')) ||
                (data.salesforceClientIDParam === undefined && (missing0 = 'salesforceClientIDParam')) ||
                (data.salesforceClientSecretParam === undefined && (missing0 = 'salesforceClientSecretParam')) ||
                (data.powerbiClientIDParam === undefined && (missing0 = 'powerbiClientIDParam')) ||
                (data.powerbiClientSecretParam === undefined && (missing0 = 'powerbiClientSecretParam')) ||
                (data.connection === undefined && (missing0 = 'connection')) ||
                (data.credentials === undefined && (missing0 = 'credentials')) ||
                (data.exportObj === undefined && (missing0 = 'exportObj'))) {
                validate22.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.stage !== undefined) {
                    let data0 = data.stage;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate22.errors = [
                                    {
                                        instancePath: instancePath + '/stage',
                                        schemaPath: '#/properties/stage/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate22.errors = [
                                {
                                    instancePath: instancePath + '/stage',
                                    schemaPath: '#/properties/stage/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.googleClientIDParam !== undefined) {
                        let data1 = data.googleClientIDParam;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate22.errors = [
                                        {
                                            instancePath: instancePath + '/googleClientIDParam',
                                            schemaPath: '#/properties/googleClientIDParam/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate22.errors = [
                                    {
                                        instancePath: instancePath + '/googleClientIDParam',
                                        schemaPath: '#/properties/googleClientIDParam/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.googleClientSecretParam !== undefined) {
                            let data2 = data.googleClientSecretParam;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    if (func2(data2) < 1) {
                                        validate22.errors = [
                                            {
                                                instancePath: instancePath + '/googleClientSecretParam',
                                                schemaPath: '#/properties/googleClientSecretParam/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate22.errors = [
                                        {
                                            instancePath: instancePath + '/googleClientSecretParam',
                                            schemaPath: '#/properties/googleClientSecretParam/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.googleSheetsExportClientIDParam !== undefined) {
                                let data3 = data.googleSheetsExportClientIDParam;
                                const _errs7 = errors;
                                if (errors === _errs7) {
                                    if (typeof data3 === 'string') {
                                        if (func2(data3) < 1) {
                                            validate22.errors = [
                                                {
                                                    instancePath: instancePath + '/googleSheetsExportClientIDParam',
                                                    schemaPath: '#/properties/googleSheetsExportClientIDParam/minLength',
                                                    keyword: 'minLength',
                                                    params: { limit: 1 },
                                                    message: 'must NOT have fewer than 1 characters'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate22.errors = [
                                            {
                                                instancePath: instancePath + '/googleSheetsExportClientIDParam',
                                                schemaPath: '#/properties/googleSheetsExportClientIDParam/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.googleSheetsExportClientSecretParam !== undefined) {
                                    let data4 = data.googleSheetsExportClientSecretParam;
                                    const _errs9 = errors;
                                    if (errors === _errs9) {
                                        if (typeof data4 === 'string') {
                                            if (func2(data4) < 1) {
                                                validate22.errors = [
                                                    {
                                                        instancePath: instancePath + '/googleSheetsExportClientSecretParam',
                                                        schemaPath: '#/properties/googleSheetsExportClientSecretParam/minLength',
                                                        keyword: 'minLength',
                                                        params: { limit: 1 },
                                                        message: 'must NOT have fewer than 1 characters'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate22.errors = [
                                                {
                                                    instancePath: instancePath + '/googleSheetsExportClientSecretParam',
                                                    schemaPath: '#/properties/googleSheetsExportClientSecretParam/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.salesforceClientIDParam !== undefined) {
                                        let data5 = data.salesforceClientIDParam;
                                        const _errs11 = errors;
                                        if (errors === _errs11) {
                                            if (typeof data5 === 'string') {
                                                if (func2(data5) < 1) {
                                                    validate22.errors = [
                                                        {
                                                            instancePath: instancePath + '/salesforceClientIDParam',
                                                            schemaPath: '#/properties/salesforceClientIDParam/minLength',
                                                            keyword: 'minLength',
                                                            params: { limit: 1 },
                                                            message: 'must NOT have fewer than 1 characters'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            else {
                                                validate22.errors = [
                                                    {
                                                        instancePath: instancePath + '/salesforceClientIDParam',
                                                        schemaPath: '#/properties/salesforceClientIDParam/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid0 = _errs11 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                    if (valid0) {
                                        if (data.salesforceClientSecretParam !== undefined) {
                                            let data6 = data.salesforceClientSecretParam;
                                            const _errs13 = errors;
                                            if (errors === _errs13) {
                                                if (typeof data6 === 'string') {
                                                    if (func2(data6) < 1) {
                                                        validate22.errors = [
                                                            {
                                                                instancePath: instancePath + '/salesforceClientSecretParam',
                                                                schemaPath: '#/properties/salesforceClientSecretParam/minLength',
                                                                keyword: 'minLength',
                                                                params: { limit: 1 },
                                                                message: 'must NOT have fewer than 1 characters'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                else {
                                                    validate22.errors = [
                                                        {
                                                            instancePath: instancePath + '/salesforceClientSecretParam',
                                                            schemaPath: '#/properties/salesforceClientSecretParam/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid0 = _errs13 === errors;
                                        }
                                        else {
                                            var valid0 = true;
                                        }
                                        if (valid0) {
                                            if (data.powerbiClientIDParam !== undefined) {
                                                let data7 = data.powerbiClientIDParam;
                                                const _errs15 = errors;
                                                if (errors === _errs15) {
                                                    if (typeof data7 === 'string') {
                                                        if (func2(data7) < 1) {
                                                            validate22.errors = [
                                                                {
                                                                    instancePath: instancePath + '/powerbiClientIDParam',
                                                                    schemaPath: '#/properties/powerbiClientIDParam/minLength',
                                                                    keyword: 'minLength',
                                                                    params: { limit: 1 },
                                                                    message: 'must NOT have fewer than 1 characters'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    else {
                                                        validate22.errors = [
                                                            {
                                                                instancePath: instancePath + '/powerbiClientIDParam',
                                                                schemaPath: '#/properties/powerbiClientIDParam/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                var valid0 = _errs15 === errors;
                                            }
                                            else {
                                                var valid0 = true;
                                            }
                                            if (valid0) {
                                                if (data.powerbiClientSecretParam !== undefined) {
                                                    let data8 = data.powerbiClientSecretParam;
                                                    const _errs17 = errors;
                                                    if (errors === _errs17) {
                                                        if (typeof data8 === 'string') {
                                                            if (func2(data8) < 1) {
                                                                validate22.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/powerbiClientSecretParam',
                                                                        schemaPath: '#/properties/powerbiClientSecretParam/minLength',
                                                                        keyword: 'minLength',
                                                                        params: { limit: 1 },
                                                                        message: 'must NOT have fewer than 1 characters'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        else {
                                                            validate22.errors = [
                                                                {
                                                                    instancePath: instancePath + '/powerbiClientSecretParam',
                                                                    schemaPath: '#/properties/powerbiClientSecretParam/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    var valid0 = _errs17 === errors;
                                                }
                                                else {
                                                    var valid0 = true;
                                                }
                                                if (valid0) {
                                                    if (data.oneDriveClientIDParam !== undefined) {
                                                        let data9 = data.oneDriveClientIDParam;
                                                        const _errs19 = errors;
                                                        if (errors === _errs19) {
                                                            if (typeof data9 === 'string') {
                                                                if (func2(data9) < 1) {
                                                                    validate22.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/oneDriveClientIDParam',
                                                                            schemaPath: '#/properties/oneDriveClientIDParam/minLength',
                                                                            keyword: 'minLength',
                                                                            params: { limit: 1 },
                                                                            message: 'must NOT have fewer than 1 characters'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                            else {
                                                                validate22.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/oneDriveClientIDParam',
                                                                        schemaPath: '#/properties/oneDriveClientIDParam/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'string' },
                                                                        message: 'must be string'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        var valid0 = _errs19 === errors;
                                                    }
                                                    else {
                                                        var valid0 = true;
                                                    }
                                                    if (valid0) {
                                                        if (data.oneDriveClientSecretParam !== undefined) {
                                                            let data10 = data.oneDriveClientSecretParam;
                                                            const _errs21 = errors;
                                                            if (errors === _errs21) {
                                                                if (typeof data10 === 'string') {
                                                                    if (func2(data10) < 1) {
                                                                        validate22.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/oneDriveClientSecretParam',
                                                                                schemaPath: '#/properties/oneDriveClientSecretParam/minLength',
                                                                                keyword: 'minLength',
                                                                                params: { limit: 1 },
                                                                                message: 'must NOT have fewer than 1 characters'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                                else {
                                                                    validate22.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/oneDriveClientSecretParam',
                                                                            schemaPath: '#/properties/oneDriveClientSecretParam/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'string' },
                                                                            message: 'must be string'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                            var valid0 = _errs21 === errors;
                                                        }
                                                        else {
                                                            var valid0 = true;
                                                        }
                                                        if (valid0) {
                                                            if (data.connection !== undefined) {
                                                                let data11 = data.connection;
                                                                const _errs23 = errors;
                                                                const _errs24 = errors;
                                                                if (errors === _errs24) {
                                                                    if (data11 && typeof data11 == 'object' && !Array.isArray(data11)) {
                                                                        let missing1;
                                                                        if ((data11.connectionType === undefined && (missing1 = 'connectionType')) ||
                                                                            (data11.name === undefined && (missing1 = 'name'))) {
                                                                            validate22.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/connection',
                                                                                    schemaPath: 'urn:wisepipe-common-connection:Connection/required',
                                                                                    keyword: 'required',
                                                                                    params: { missingProperty: missing1 },
                                                                                    message: "must have required property '" + missing1 + "'"
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                        else {
                                                                            if (data11.connectionID !== undefined) {
                                                                                let data12 = data11.connectionID;
                                                                                const _errs26 = errors;
                                                                                if (errors === _errs26) {
                                                                                    if (typeof data12 === 'string') {
                                                                                        const b64min0 = Math.ceil((4 * 9) / 3);
                                                                                        const b64max0 = Math.ceil((4 * 9) / 3) + 3;
                                                                                        if (func77(data12) < b64min0 || func77(data12) > b64max0) {
                                                                                            validate22.errors = [
                                                                                                {
                                                                                                    instancePath: instancePath + '/connection/connectionID',
                                                                                                    schemaPath: 'urn:wisepipe-common-connection:Connection/properties/connectionID/uid',
                                                                                                    keyword: 'uid',
                                                                                                    params: {
                                                                                                        error: 'encoded',
                                                                                                        b64min: b64min0,
                                                                                                        b64max: b64max0,
                                                                                                        length: func77(data12)
                                                                                                    },
                                                                                                    message: 'length must be between ' +
                                                                                                        b64min0 +
                                                                                                        ' and ' +
                                                                                                        b64max0 +
                                                                                                        ', but is ' +
                                                                                                        func77(data12)
                                                                                                }
                                                                                            ];
                                                                                            return false;
                                                                                        }
                                                                                        else {
                                                                                            const decoded0 = func78(data12);
                                                                                            if (decoded0.length !== 9) {
                                                                                                validate22.errors = [
                                                                                                    {
                                                                                                        instancePath: instancePath + '/connection/connectionID',
                                                                                                        schemaPath: 'urn:wisepipe-common-connection:Connection/properties/connectionID/uid',
                                                                                                        keyword: 'uid',
                                                                                                        params: { error: 'decoded' },
                                                                                                        message: 'must decode to 9 bytes'
                                                                                                    }
                                                                                                ];
                                                                                                return false;
                                                                                            }
                                                                                            else {
                                                                                                const encoded0 = func79(decoded0);
                                                                                                if (func80(encoded0) !== func80(data12)) {
                                                                                                    validate22.errors = [
                                                                                                        {
                                                                                                            instancePath: instancePath + '/connection/connectionID',
                                                                                                            schemaPath: 'urn:wisepipe-common-connection:Connection/properties/connectionID/uid',
                                                                                                            keyword: 'uid',
                                                                                                            params: { error: 'ambiguous' },
                                                                                                            message: 'encoding is ambiguous'
                                                                                                        }
                                                                                                    ];
                                                                                                    return false;
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                    else {
                                                                                        validate22.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/connection/connectionID',
                                                                                                schemaPath: 'urn:wisepipe-common-connection:Connection/properties/connectionID/type',
                                                                                                keyword: 'type',
                                                                                                params: { type: 'string' },
                                                                                                message: 'must be string'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                }
                                                                                var valid2 = _errs26 === errors;
                                                                            }
                                                                            else {
                                                                                var valid2 = true;
                                                                            }
                                                                            if (valid2) {
                                                                                if (data11.connectionType !== undefined) {
                                                                                    let data13 = data11.connectionType;
                                                                                    const _errs28 = errors;
                                                                                    if (typeof data13 !== 'string') {
                                                                                        validate22.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/connection/connectionType',
                                                                                                schemaPath: 'urn:wisepipe-common-connection:Connection/properties/connectionType/type',
                                                                                                keyword: 'type',
                                                                                                params: { type: 'string' },
                                                                                                message: 'must be string'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                    if (!(data13 === 'google' ||
                                                                                        data13 === 'gsheetsImport' ||
                                                                                        data13 === 'gsheetsExport' ||
                                                                                        data13 === 'shopify' ||
                                                                                        data13 === 'salesForce' ||
                                                                                        data13 === 'postgreSql' ||
                                                                                        data13 === 'icm' ||
                                                                                        data13 === 'tq-postgres' ||
                                                                                        data13 === 'mySql' ||
                                                                                        data13 === 'msSql' ||
                                                                                        data13 === 'oracle' ||
                                                                                        data13 === 'amazonRedshift' ||
                                                                                        data13 === 'amazonAurora' ||
                                                                                        data13 === 'amazonS3' ||
                                                                                        data13 === 'amazonS3Export' ||
                                                                                        data13 === 'tqp' ||
                                                                                        data13 === 'hubspot' ||
                                                                                        data13 === 'symon' ||
                                                                                        data13 === 'snowflake' ||
                                                                                        data13 === 'dynamics' ||
                                                                                        data13 === 'agentSync' ||
                                                                                        data13 === 'workday' ||
                                                                                        data13 === 'workdayRaaS' ||
                                                                                        data13 === 'workdayExport' ||
                                                                                        data13 === 'tableau' ||
                                                                                        data13 === 'sftp' ||
                                                                                        data13 === 'powerbi' ||
                                                                                        data13 === 'rest' ||
                                                                                        data13 === 'gong' ||
                                                                                        data13 === 'netSuite' ||
                                                                                        data13 === 'oneDrive' ||
                                                                                        data13 === 'oneDriveExport' ||
                                                                                        data13 === 'sapSuccessFactors' ||
                                                                                        data13 === 'sapCrm' ||
                                                                                        data13 === 'ukg' ||
                                                                                        data13 === 'oracleHcm' ||
                                                                                        data13 === 'Adp' ||
                                                                                        data13 === 'dynamics365Sales' ||
                                                                                        data13 === 'ceridianDayforce' ||
                                                                                        data13 === 'oracleCrm' ||
                                                                                        data13 === 'oracleErpCloud' ||
                                                                                        data13 === 'sageIntacct' ||
                                                                                        data13 === 'bambooHr' ||
                                                                                        data13 === 'sapErp' ||
                                                                                        data13 === 'googleCloudPlatformCloudStorage' ||
                                                                                        data13 === 'sas' ||
                                                                                        data13 === 'dropbox' ||
                                                                                        data13 === 'googleDrive' ||
                                                                                        data13 === 'jira' ||
                                                                                        data13 === 'monday' ||
                                                                                        data13 === 'zuora' ||
                                                                                        data13 === 'adobeAnalytics' ||
                                                                                        data13 === 'zoomInfo' ||
                                                                                        data13 === 'marketo' ||
                                                                                        data13 === 'activeCampaign' ||
                                                                                        data13 === 'mailchimp' ||
                                                                                        data13 === 'infor' ||
                                                                                        data13 === 'cornerstoneOnDemand' ||
                                                                                        data13 === 'gusto' ||
                                                                                        data13 === 'paychexFlex' ||
                                                                                        data13 === 'zendesk' ||
                                                                                        data13 === 'serviceNow' ||
                                                                                        data13 === 'zohoCrm' ||
                                                                                        data13 === 'pipedrive' ||
                                                                                        data13 === 'quickBooks' ||
                                                                                        data13 === 'xero' ||
                                                                                        data13 === 'freshbooks' ||
                                                                                        data13 === 'zohoBooks' ||
                                                                                        data13 === 'waveFinancial')) {
                                                                                        validate22.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/connection/connectionType',
                                                                                                schemaPath: 'urn:wisepipe-common-connection:Connection/properties/connectionType/enum',
                                                                                                keyword: 'enum',
                                                                                                params: { allowedValues: schema31.properties.connectionType.enum },
                                                                                                message: 'must be equal to one of the allowed values'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                    var valid2 = _errs28 === errors;
                                                                                }
                                                                                else {
                                                                                    var valid2 = true;
                                                                                }
                                                                                if (valid2) {
                                                                                    if (data11.name !== undefined) {
                                                                                        let data14 = data11.name;
                                                                                        const _errs30 = errors;
                                                                                        if (errors === _errs30) {
                                                                                            if (typeof data14 === 'string') {
                                                                                                if (func2(data14) < 1) {
                                                                                                    validate22.errors = [
                                                                                                        {
                                                                                                            instancePath: instancePath + '/connection/name',
                                                                                                            schemaPath: 'urn:wisepipe-common-connection:Connection/properties/name/minLength',
                                                                                                            keyword: 'minLength',
                                                                                                            params: { limit: 1 },
                                                                                                            message: 'must NOT have fewer than 1 characters'
                                                                                                        }
                                                                                                    ];
                                                                                                    return false;
                                                                                                }
                                                                                            }
                                                                                            else {
                                                                                                validate22.errors = [
                                                                                                    {
                                                                                                        instancePath: instancePath + '/connection/name',
                                                                                                        schemaPath: 'urn:wisepipe-common-connection:Connection/properties/name/type',
                                                                                                        keyword: 'type',
                                                                                                        params: { type: 'string' },
                                                                                                        message: 'must be string'
                                                                                                    }
                                                                                                ];
                                                                                                return false;
                                                                                            }
                                                                                        }
                                                                                        var valid2 = _errs30 === errors;
                                                                                    }
                                                                                    else {
                                                                                        var valid2 = true;
                                                                                    }
                                                                                    if (valid2) {
                                                                                        if (data11.source !== undefined) {
                                                                                            let data15 = data11.source;
                                                                                            const _errs32 = errors;
                                                                                            if (errors === _errs32) {
                                                                                                if (typeof data15 === 'string') {
                                                                                                    if (func2(data15) < 1) {
                                                                                                        validate22.errors = [
                                                                                                            {
                                                                                                                instancePath: instancePath + '/connection/source',
                                                                                                                schemaPath: 'urn:wisepipe-common-connection:Connection/properties/source/minLength',
                                                                                                                keyword: 'minLength',
                                                                                                                params: { limit: 1 },
                                                                                                                message: 'must NOT have fewer than 1 characters'
                                                                                                            }
                                                                                                        ];
                                                                                                        return false;
                                                                                                    }
                                                                                                }
                                                                                                else {
                                                                                                    validate22.errors = [
                                                                                                        {
                                                                                                            instancePath: instancePath + '/connection/source',
                                                                                                            schemaPath: 'urn:wisepipe-common-connection:Connection/properties/source/type',
                                                                                                            keyword: 'type',
                                                                                                            params: { type: 'string' },
                                                                                                            message: 'must be string'
                                                                                                        }
                                                                                                    ];
                                                                                                    return false;
                                                                                                }
                                                                                            }
                                                                                            var valid2 = _errs32 === errors;
                                                                                        }
                                                                                        else {
                                                                                            var valid2 = true;
                                                                                        }
                                                                                        if (valid2) {
                                                                                            if (data11.failedOnLastTry !== undefined) {
                                                                                                const _errs34 = errors;
                                                                                                if (typeof data11.failedOnLastTry !== 'boolean') {
                                                                                                    validate22.errors = [
                                                                                                        {
                                                                                                            instancePath: instancePath + '/connection/failedOnLastTry',
                                                                                                            schemaPath: 'urn:wisepipe-common-connection:Connection/properties/failedOnLastTry/type',
                                                                                                            keyword: 'type',
                                                                                                            params: { type: 'boolean' },
                                                                                                            message: 'must be boolean'
                                                                                                        }
                                                                                                    ];
                                                                                                    return false;
                                                                                                }
                                                                                                var valid2 = _errs34 === errors;
                                                                                            }
                                                                                            else {
                                                                                                var valid2 = true;
                                                                                            }
                                                                                            if (valid2) {
                                                                                                if (data11.isDiscoveryFail !== undefined) {
                                                                                                    const _errs36 = errors;
                                                                                                    if (typeof data11.isDiscoveryFail !== 'boolean') {
                                                                                                        validate22.errors = [
                                                                                                            {
                                                                                                                instancePath: instancePath + '/connection/isDiscoveryFail',
                                                                                                                schemaPath: 'urn:wisepipe-common-connection:Connection/properties/isDiscoveryFail/type',
                                                                                                                keyword: 'type',
                                                                                                                params: { type: 'boolean' },
                                                                                                                message: 'must be boolean'
                                                                                                            }
                                                                                                        ];
                                                                                                        return false;
                                                                                                    }
                                                                                                    var valid2 = _errs36 === errors;
                                                                                                }
                                                                                                else {
                                                                                                    var valid2 = true;
                                                                                                }
                                                                                                if (valid2) {
                                                                                                    if (data11.verificationErrorMessage !== undefined) {
                                                                                                        const _errs38 = errors;
                                                                                                        if (typeof data11.verificationErrorMessage !== 'string') {
                                                                                                            validate22.errors = [
                                                                                                                {
                                                                                                                    instancePath: instancePath + '/connection/verificationErrorMessage',
                                                                                                                    schemaPath: 'urn:wisepipe-common-connection:Connection/properties/verificationErrorMessage/type',
                                                                                                                    keyword: 'type',
                                                                                                                    params: { type: 'string' },
                                                                                                                    message: 'must be string'
                                                                                                                }
                                                                                                            ];
                                                                                                            return false;
                                                                                                        }
                                                                                                        var valid2 = _errs38 === errors;
                                                                                                    }
                                                                                                    else {
                                                                                                        var valid2 = true;
                                                                                                    }
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                    else {
                                                                        validate22.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/connection',
                                                                                schemaPath: 'urn:wisepipe-common-connection:Connection/type',
                                                                                keyword: 'type',
                                                                                params: { type: 'object' },
                                                                                message: 'must be object'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                                var valid0 = _errs23 === errors;
                                                            }
                                                            else {
                                                                var valid0 = true;
                                                            }
                                                            if (valid0) {
                                                                if (data.credentials !== undefined) {
                                                                    let data19 = data.credentials;
                                                                    const _errs40 = errors;
                                                                    const _errs41 = errors;
                                                                    if (errors === _errs41) {
                                                                        if (data19 && typeof data19 == 'object' && !Array.isArray(data19)) {
                                                                            let missing2;
                                                                            if (data19.credentialsType === undefined && (missing2 = 'credentialsType')) {
                                                                                validate22.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/credentials',
                                                                                        schemaPath: 'urn:wisepipe-common:Credentials/required',
                                                                                        keyword: 'required',
                                                                                        params: { missingProperty: missing2 },
                                                                                        message: "must have required property '" + missing2 + "'"
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                            else {
                                                                                if (data19.credentialsType !== undefined) {
                                                                                    let data20 = data19.credentialsType;
                                                                                    if (typeof data20 !== 'string') {
                                                                                        validate22.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/credentials/credentialsType',
                                                                                                schemaPath: 'urn:wisepipe-common:Credentials/properties/credentialsType/type',
                                                                                                keyword: 'type',
                                                                                                params: { type: 'string' },
                                                                                                message: 'must be string'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                    if (!(data20 === 'oauth' ||
                                                                                        data20 === 'userPassword' ||
                                                                                        data20 === 's3Credentials' ||
                                                                                        data20 === 'apiKey' ||
                                                                                        data20 === 'symon' ||
                                                                                        data20 === 'awsRoleAssumption' ||
                                                                                        data20 === 'rest' ||
                                                                                        data20 === 'tokenBasedAuthentication')) {
                                                                                        validate22.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/credentials/credentialsType',
                                                                                                schemaPath: 'urn:wisepipe-common:Credentials/properties/credentialsType/enum',
                                                                                                keyword: 'enum',
                                                                                                params: { allowedValues: schema32.properties.credentialsType.enum },
                                                                                                message: 'must be equal to one of the allowed values'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                        else {
                                                                            validate22.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/credentials',
                                                                                    schemaPath: 'urn:wisepipe-common:Credentials/type',
                                                                                    keyword: 'type',
                                                                                    params: { type: 'object' },
                                                                                    message: 'must be object'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                    }
                                                                    var valid0 = _errs40 === errors;
                                                                }
                                                                else {
                                                                    var valid0 = true;
                                                                }
                                                                if (valid0) {
                                                                    if (data.awsS3credentials !== undefined) {
                                                                        let data21 = data.awsS3credentials;
                                                                        const _errs45 = errors;
                                                                        const _errs46 = errors;
                                                                        if (errors === _errs46) {
                                                                            if (data21 && typeof data21 == 'object' && !Array.isArray(data21)) {
                                                                                let missing3;
                                                                                if ((data21.identityID === undefined && (missing3 = 'identityID')) ||
                                                                                    (data21.accessKeyID === undefined && (missing3 = 'accessKeyID')) ||
                                                                                    (data21.secretKey === undefined && (missing3 = 'secretKey')) ||
                                                                                    (data21.sessionToken === undefined && (missing3 = 'sessionToken')) ||
                                                                                    (data21.expiration === undefined && (missing3 = 'expiration')) ||
                                                                                    (data21.region === undefined && (missing3 = 'region'))) {
                                                                                    validate22.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/awsS3credentials',
                                                                                            schemaPath: 'urn:wisepipe-common-auth:AwsCredentials/required',
                                                                                            keyword: 'required',
                                                                                            params: { missingProperty: missing3 },
                                                                                            message: "must have required property '" + missing3 + "'"
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                                else {
                                                                                    if (data21.identityID !== undefined) {
                                                                                        let data22 = data21.identityID;
                                                                                        const _errs48 = errors;
                                                                                        if (errors === _errs48) {
                                                                                            if (typeof data22 === 'string') {
                                                                                                if (!pattern0.test(data22)) {
                                                                                                    validate22.errors = [
                                                                                                        {
                                                                                                            instancePath: instancePath + '/awsS3credentials/identityID',
                                                                                                            schemaPath: 'urn:wisepipe-common-auth:AwsCredentials/properties/identityID/pattern',
                                                                                                            keyword: 'pattern',
                                                                                                            params: { pattern: '[\\w-]+:[0-9a-f-]+' },
                                                                                                            message: 'must match pattern "' + '[\\w-]+:[0-9a-f-]+' + '"'
                                                                                                        }
                                                                                                    ];
                                                                                                    return false;
                                                                                                }
                                                                                            }
                                                                                            else {
                                                                                                validate22.errors = [
                                                                                                    {
                                                                                                        instancePath: instancePath + '/awsS3credentials/identityID',
                                                                                                        schemaPath: 'urn:wisepipe-common-auth:AwsCredentials/properties/identityID/type',
                                                                                                        keyword: 'type',
                                                                                                        params: { type: 'string' },
                                                                                                        message: 'must be string'
                                                                                                    }
                                                                                                ];
                                                                                                return false;
                                                                                            }
                                                                                        }
                                                                                        var valid7 = _errs48 === errors;
                                                                                    }
                                                                                    else {
                                                                                        var valid7 = true;
                                                                                    }
                                                                                    if (valid7) {
                                                                                        if (data21.accessKeyID !== undefined) {
                                                                                            let data23 = data21.accessKeyID;
                                                                                            const _errs50 = errors;
                                                                                            if (errors === _errs50) {
                                                                                                if (typeof data23 === 'string') {
                                                                                                    if (func2(data23) < 1) {
                                                                                                        validate22.errors = [
                                                                                                            {
                                                                                                                instancePath: instancePath + '/awsS3credentials/accessKeyID',
                                                                                                                schemaPath: 'urn:wisepipe-common-auth:AwsCredentials/properties/accessKeyID/minLength',
                                                                                                                keyword: 'minLength',
                                                                                                                params: { limit: 1 },
                                                                                                                message: 'must NOT have fewer than 1 characters'
                                                                                                            }
                                                                                                        ];
                                                                                                        return false;
                                                                                                    }
                                                                                                    else {
                                                                                                        if (!pattern1.test(data23)) {
                                                                                                            validate22.errors = [
                                                                                                                {
                                                                                                                    instancePath: instancePath + '/awsS3credentials/accessKeyID',
                                                                                                                    schemaPath: 'urn:wisepipe-common-auth:AwsCredentials/properties/accessKeyID/pattern',
                                                                                                                    keyword: 'pattern',
                                                                                                                    params: { pattern: '[\\w]+' },
                                                                                                                    message: 'must match pattern "' + '[\\w]+' + '"'
                                                                                                                }
                                                                                                            ];
                                                                                                            return false;
                                                                                                        }
                                                                                                    }
                                                                                                }
                                                                                                else {
                                                                                                    validate22.errors = [
                                                                                                        {
                                                                                                            instancePath: instancePath + '/awsS3credentials/accessKeyID',
                                                                                                            schemaPath: 'urn:wisepipe-common-auth:AwsCredentials/properties/accessKeyID/type',
                                                                                                            keyword: 'type',
                                                                                                            params: { type: 'string' },
                                                                                                            message: 'must be string'
                                                                                                        }
                                                                                                    ];
                                                                                                    return false;
                                                                                                }
                                                                                            }
                                                                                            var valid7 = _errs50 === errors;
                                                                                        }
                                                                                        else {
                                                                                            var valid7 = true;
                                                                                        }
                                                                                        if (valid7) {
                                                                                            if (data21.secretKey !== undefined) {
                                                                                                let data24 = data21.secretKey;
                                                                                                const _errs52 = errors;
                                                                                                if (errors === _errs52) {
                                                                                                    if (typeof data24 === 'string') {
                                                                                                        if (func2(data24) < 1) {
                                                                                                            validate22.errors = [
                                                                                                                {
                                                                                                                    instancePath: instancePath + '/awsS3credentials/secretKey',
                                                                                                                    schemaPath: 'urn:wisepipe-common-auth:AwsCredentials/properties/secretKey/minLength',
                                                                                                                    keyword: 'minLength',
                                                                                                                    params: { limit: 1 },
                                                                                                                    message: 'must NOT have fewer than 1 characters'
                                                                                                                }
                                                                                                            ];
                                                                                                            return false;
                                                                                                        }
                                                                                                    }
                                                                                                    else {
                                                                                                        validate22.errors = [
                                                                                                            {
                                                                                                                instancePath: instancePath + '/awsS3credentials/secretKey',
                                                                                                                schemaPath: 'urn:wisepipe-common-auth:AwsCredentials/properties/secretKey/type',
                                                                                                                keyword: 'type',
                                                                                                                params: { type: 'string' },
                                                                                                                message: 'must be string'
                                                                                                            }
                                                                                                        ];
                                                                                                        return false;
                                                                                                    }
                                                                                                }
                                                                                                var valid7 = _errs52 === errors;
                                                                                            }
                                                                                            else {
                                                                                                var valid7 = true;
                                                                                            }
                                                                                            if (valid7) {
                                                                                                if (data21.sessionToken !== undefined) {
                                                                                                    let data25 = data21.sessionToken;
                                                                                                    const _errs54 = errors;
                                                                                                    if (errors === _errs54) {
                                                                                                        if (typeof data25 === 'string') {
                                                                                                            if (func2(data25) < 1) {
                                                                                                                validate22.errors = [
                                                                                                                    {
                                                                                                                        instancePath: instancePath + '/awsS3credentials/sessionToken',
                                                                                                                        schemaPath: 'urn:wisepipe-common-auth:AwsCredentials/properties/sessionToken/minLength',
                                                                                                                        keyword: 'minLength',
                                                                                                                        params: { limit: 1 },
                                                                                                                        message: 'must NOT have fewer than 1 characters'
                                                                                                                    }
                                                                                                                ];
                                                                                                                return false;
                                                                                                            }
                                                                                                        }
                                                                                                        else {
                                                                                                            validate22.errors = [
                                                                                                                {
                                                                                                                    instancePath: instancePath + '/awsS3credentials/sessionToken',
                                                                                                                    schemaPath: 'urn:wisepipe-common-auth:AwsCredentials/properties/sessionToken/type',
                                                                                                                    keyword: 'type',
                                                                                                                    params: { type: 'string' },
                                                                                                                    message: 'must be string'
                                                                                                                }
                                                                                                            ];
                                                                                                            return false;
                                                                                                        }
                                                                                                    }
                                                                                                    var valid7 = _errs54 === errors;
                                                                                                }
                                                                                                else {
                                                                                                    var valid7 = true;
                                                                                                }
                                                                                                if (valid7) {
                                                                                                    if (data21.expiration !== undefined) {
                                                                                                        let data26 = data21.expiration;
                                                                                                        const _errs56 = errors;
                                                                                                        if (errors === _errs56) {
                                                                                                            if (errors === _errs56) {
                                                                                                                if (typeof data26 === 'string') {
                                                                                                                    if (!formats0.validate(data26)) {
                                                                                                                        validate22.errors = [
                                                                                                                            {
                                                                                                                                instancePath: instancePath + '/awsS3credentials/expiration',
                                                                                                                                schemaPath: 'urn:wisepipe-common-auth:AwsCredentials/properties/expiration/format',
                                                                                                                                keyword: 'format',
                                                                                                                                params: { format: 'date-time' },
                                                                                                                                message: 'must match format "' + 'date-time' + '"'
                                                                                                                            }
                                                                                                                        ];
                                                                                                                        return false;
                                                                                                                    }
                                                                                                                }
                                                                                                                else {
                                                                                                                    validate22.errors = [
                                                                                                                        {
                                                                                                                            instancePath: instancePath + '/awsS3credentials/expiration',
                                                                                                                            schemaPath: 'urn:wisepipe-common-auth:AwsCredentials/properties/expiration/type',
                                                                                                                            keyword: 'type',
                                                                                                                            params: { type: 'string' },
                                                                                                                            message: 'must be string'
                                                                                                                        }
                                                                                                                    ];
                                                                                                                    return false;
                                                                                                                }
                                                                                                            }
                                                                                                        }
                                                                                                        var valid7 = _errs56 === errors;
                                                                                                    }
                                                                                                    else {
                                                                                                        var valid7 = true;
                                                                                                    }
                                                                                                    if (valid7) {
                                                                                                        if (data21.region !== undefined) {
                                                                                                            const _errs58 = errors;
                                                                                                            if (typeof data21.region !== 'string') {
                                                                                                                validate22.errors = [
                                                                                                                    {
                                                                                                                        instancePath: instancePath + '/awsS3credentials/region',
                                                                                                                        schemaPath: 'urn:wisepipe-common-auth:AwsCredentials/properties/region/type',
                                                                                                                        keyword: 'type',
                                                                                                                        params: { type: 'string' },
                                                                                                                        message: 'must be string'
                                                                                                                    }
                                                                                                                ];
                                                                                                                return false;
                                                                                                            }
                                                                                                            var valid7 = _errs58 === errors;
                                                                                                        }
                                                                                                        else {
                                                                                                            var valid7 = true;
                                                                                                        }
                                                                                                    }
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                            else {
                                                                                validate22.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/awsS3credentials',
                                                                                        schemaPath: 'urn:wisepipe-common-auth:AwsCredentials/type',
                                                                                        keyword: 'type',
                                                                                        params: { type: 'object' },
                                                                                        message: 'must be object'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                        }
                                                                        var valid0 = _errs45 === errors;
                                                                    }
                                                                    else {
                                                                        var valid0 = true;
                                                                    }
                                                                    if (valid0) {
                                                                        if (data.tempS3ExportsFolder !== undefined) {
                                                                            let data28 = data.tempS3ExportsFolder;
                                                                            const _errs60 = errors;
                                                                            const _errs61 = errors;
                                                                            if (errors === _errs61) {
                                                                                if (data28 && typeof data28 == 'object' && !Array.isArray(data28)) {
                                                                                    let missing4;
                                                                                    if ((data28.bucket === undefined && (missing4 = 'bucket')) ||
                                                                                        (data28.key === undefined && (missing4 = 'key'))) {
                                                                                        validate22.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/tempS3ExportsFolder',
                                                                                                schemaPath: 'urn:wisepipe-common:S3File/required',
                                                                                                keyword: 'required',
                                                                                                params: { missingProperty: missing4 },
                                                                                                message: "must have required property '" + missing4 + "'"
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                    else {
                                                                                        if (data28.bucket !== undefined) {
                                                                                            let data29 = data28.bucket;
                                                                                            const _errs63 = errors;
                                                                                            if (errors === _errs63) {
                                                                                                if (typeof data29 === 'string') {
                                                                                                    if (func2(data29) < 1) {
                                                                                                        validate22.errors = [
                                                                                                            {
                                                                                                                instancePath: instancePath + '/tempS3ExportsFolder/bucket',
                                                                                                                schemaPath: 'urn:wisepipe-common:S3File/properties/bucket/minLength',
                                                                                                                keyword: 'minLength',
                                                                                                                params: { limit: 1 },
                                                                                                                message: 'must NOT have fewer than 1 characters'
                                                                                                            }
                                                                                                        ];
                                                                                                        return false;
                                                                                                    }
                                                                                                }
                                                                                                else {
                                                                                                    validate22.errors = [
                                                                                                        {
                                                                                                            instancePath: instancePath + '/tempS3ExportsFolder/bucket',
                                                                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/bucket/type',
                                                                                                            keyword: 'type',
                                                                                                            params: { type: 'string' },
                                                                                                            message: 'must be string'
                                                                                                        }
                                                                                                    ];
                                                                                                    return false;
                                                                                                }
                                                                                            }
                                                                                            var valid9 = _errs63 === errors;
                                                                                        }
                                                                                        else {
                                                                                            var valid9 = true;
                                                                                        }
                                                                                        if (valid9) {
                                                                                            if (data28.key !== undefined) {
                                                                                                let data30 = data28.key;
                                                                                                const _errs65 = errors;
                                                                                                if (errors === _errs65) {
                                                                                                    if (typeof data30 === 'string') {
                                                                                                        if (func2(data30) < 1) {
                                                                                                            validate22.errors = [
                                                                                                                {
                                                                                                                    instancePath: instancePath + '/tempS3ExportsFolder/key',
                                                                                                                    schemaPath: 'urn:wisepipe-common:S3File/properties/key/minLength',
                                                                                                                    keyword: 'minLength',
                                                                                                                    params: { limit: 1 },
                                                                                                                    message: 'must NOT have fewer than 1 characters'
                                                                                                                }
                                                                                                            ];
                                                                                                            return false;
                                                                                                        }
                                                                                                    }
                                                                                                    else {
                                                                                                        validate22.errors = [
                                                                                                            {
                                                                                                                instancePath: instancePath + '/tempS3ExportsFolder/key',
                                                                                                                schemaPath: 'urn:wisepipe-common:S3File/properties/key/type',
                                                                                                                keyword: 'type',
                                                                                                                params: { type: 'string' },
                                                                                                                message: 'must be string'
                                                                                                            }
                                                                                                        ];
                                                                                                        return false;
                                                                                                    }
                                                                                                }
                                                                                                var valid9 = _errs65 === errors;
                                                                                            }
                                                                                            else {
                                                                                                var valid9 = true;
                                                                                            }
                                                                                            if (valid9) {
                                                                                                if (data28.uploadID !== undefined) {
                                                                                                    let data31 = data28.uploadID;
                                                                                                    const _errs67 = errors;
                                                                                                    if (errors === _errs67) {
                                                                                                        if (typeof data31 === 'string') {
                                                                                                            const b64min1 = Math.ceil((4 * 9) / 3);
                                                                                                            const b64max1 = Math.ceil((4 * 9) / 3) + 3;
                                                                                                            if (func88(data31) < b64min1 || func88(data31) > b64max1) {
                                                                                                                validate22.errors = [
                                                                                                                    {
                                                                                                                        instancePath: instancePath + '/tempS3ExportsFolder/uploadID',
                                                                                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                                                                        keyword: 'uid',
                                                                                                                        params: {
                                                                                                                            error: 'encoded',
                                                                                                                            b64min: b64min1,
                                                                                                                            b64max: b64max1,
                                                                                                                            length: func88(data31)
                                                                                                                        },
                                                                                                                        message: 'length must be between ' +
                                                                                                                            b64min1 +
                                                                                                                            ' and ' +
                                                                                                                            b64max1 +
                                                                                                                            ', but is ' +
                                                                                                                            func88(data31)
                                                                                                                    }
                                                                                                                ];
                                                                                                                return false;
                                                                                                            }
                                                                                                            else {
                                                                                                                const decoded1 = func89(data31);
                                                                                                                if (decoded1.length !== 9) {
                                                                                                                    validate22.errors = [
                                                                                                                        {
                                                                                                                            instancePath: instancePath + '/tempS3ExportsFolder/uploadID',
                                                                                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                                                                            keyword: 'uid',
                                                                                                                            params: { error: 'decoded' },
                                                                                                                            message: 'must decode to 9 bytes'
                                                                                                                        }
                                                                                                                    ];
                                                                                                                    return false;
                                                                                                                }
                                                                                                                else {
                                                                                                                    const encoded1 = func90(decoded1);
                                                                                                                    if (func91(encoded1) !== func91(data31)) {
                                                                                                                        validate22.errors = [
                                                                                                                            {
                                                                                                                                instancePath: instancePath + '/tempS3ExportsFolder/uploadID',
                                                                                                                                schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                                                                                keyword: 'uid',
                                                                                                                                params: { error: 'ambiguous' },
                                                                                                                                message: 'encoding is ambiguous'
                                                                                                                            }
                                                                                                                        ];
                                                                                                                        return false;
                                                                                                                    }
                                                                                                                }
                                                                                                            }
                                                                                                        }
                                                                                                        else {
                                                                                                            validate22.errors = [
                                                                                                                {
                                                                                                                    instancePath: instancePath + '/tempS3ExportsFolder/uploadID',
                                                                                                                    schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/type',
                                                                                                                    keyword: 'type',
                                                                                                                    params: { type: 'string' },
                                                                                                                    message: 'must be string'
                                                                                                                }
                                                                                                            ];
                                                                                                            return false;
                                                                                                        }
                                                                                                    }
                                                                                                    var valid9 = _errs67 === errors;
                                                                                                }
                                                                                                else {
                                                                                                    var valid9 = true;
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                                else {
                                                                                    validate22.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/tempS3ExportsFolder',
                                                                                            schemaPath: 'urn:wisepipe-common:S3File/type',
                                                                                            keyword: 'type',
                                                                                            params: { type: 'object' },
                                                                                            message: 'must be object'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                            }
                                                                            var valid0 = _errs60 === errors;
                                                                        }
                                                                        else {
                                                                            var valid0 = true;
                                                                        }
                                                                        if (valid0) {
                                                                            if (data.taskAuthInfo !== undefined) {
                                                                                let data32 = data.taskAuthInfo;
                                                                                const _errs69 = errors;
                                                                                const _errs70 = errors;
                                                                                if (errors === _errs70) {
                                                                                    if (data32 && typeof data32 == 'object' && !Array.isArray(data32)) {
                                                                                        let missing5;
                                                                                        if ((data32.orgID === undefined && (missing5 = 'orgID')) ||
                                                                                            (data32.userID === undefined && (missing5 = 'userID')) ||
                                                                                            (data32.taskID === undefined && (missing5 = 'taskID')) ||
                                                                                            (data32.taskAuthToken === undefined && (missing5 = 'taskAuthToken')) ||
                                                                                            (data32.expiration === undefined && (missing5 = 'expiration'))) {
                                                                                            validate22.errors = [
                                                                                                {
                                                                                                    instancePath: instancePath + '/taskAuthInfo',
                                                                                                    schemaPath: 'urn:wisepipe-common-auth:TaskAuthInfo/required',
                                                                                                    keyword: 'required',
                                                                                                    params: { missingProperty: missing5 },
                                                                                                    message: "must have required property '" + missing5 + "'"
                                                                                                }
                                                                                            ];
                                                                                            return false;
                                                                                        }
                                                                                        else {
                                                                                            if (data32.orgID !== undefined) {
                                                                                                let data33 = data32.orgID;
                                                                                                const _errs72 = errors;
                                                                                                if (errors === _errs72) {
                                                                                                    if (errors === _errs72) {
                                                                                                        if (typeof data33 === 'string') {
                                                                                                            if (!formats2.test(data33)) {
                                                                                                                validate22.errors = [
                                                                                                                    {
                                                                                                                        instancePath: instancePath + '/taskAuthInfo/orgID',
                                                                                                                        schemaPath: 'urn:wisepipe-common-auth:TaskAuthInfo/properties/orgID/format',
                                                                                                                        keyword: 'format',
                                                                                                                        params: { format: 'uuid' },
                                                                                                                        message: 'must match format "' + 'uuid' + '"'
                                                                                                                    }
                                                                                                                ];
                                                                                                                return false;
                                                                                                            }
                                                                                                        }
                                                                                                        else {
                                                                                                            validate22.errors = [
                                                                                                                {
                                                                                                                    instancePath: instancePath + '/taskAuthInfo/orgID',
                                                                                                                    schemaPath: 'urn:wisepipe-common-auth:TaskAuthInfo/properties/orgID/type',
                                                                                                                    keyword: 'type',
                                                                                                                    params: { type: 'string' },
                                                                                                                    message: 'must be string'
                                                                                                                }
                                                                                                            ];
                                                                                                            return false;
                                                                                                        }
                                                                                                    }
                                                                                                }
                                                                                                var valid12 = _errs72 === errors;
                                                                                            }
                                                                                            else {
                                                                                                var valid12 = true;
                                                                                            }
                                                                                            if (valid12) {
                                                                                                if (data32.userID !== undefined) {
                                                                                                    let data34 = data32.userID;
                                                                                                    const _errs74 = errors;
                                                                                                    if (errors === _errs74) {
                                                                                                        if (errors === _errs74) {
                                                                                                            if (typeof data34 === 'string') {
                                                                                                                if (!formats2.test(data34)) {
                                                                                                                    validate22.errors = [
                                                                                                                        {
                                                                                                                            instancePath: instancePath + '/taskAuthInfo/userID',
                                                                                                                            schemaPath: 'urn:wisepipe-common-auth:TaskAuthInfo/properties/userID/format',
                                                                                                                            keyword: 'format',
                                                                                                                            params: { format: 'uuid' },
                                                                                                                            message: 'must match format "' + 'uuid' + '"'
                                                                                                                        }
                                                                                                                    ];
                                                                                                                    return false;
                                                                                                                }
                                                                                                            }
                                                                                                            else {
                                                                                                                validate22.errors = [
                                                                                                                    {
                                                                                                                        instancePath: instancePath + '/taskAuthInfo/userID',
                                                                                                                        schemaPath: 'urn:wisepipe-common-auth:TaskAuthInfo/properties/userID/type',
                                                                                                                        keyword: 'type',
                                                                                                                        params: { type: 'string' },
                                                                                                                        message: 'must be string'
                                                                                                                    }
                                                                                                                ];
                                                                                                                return false;
                                                                                                            }
                                                                                                        }
                                                                                                    }
                                                                                                    var valid12 = _errs74 === errors;
                                                                                                }
                                                                                                else {
                                                                                                    var valid12 = true;
                                                                                                }
                                                                                                if (valid12) {
                                                                                                    if (data32.taskID !== undefined) {
                                                                                                        const _errs76 = errors;
                                                                                                        if (typeof data32.taskID !== 'string') {
                                                                                                            validate22.errors = [
                                                                                                                {
                                                                                                                    instancePath: instancePath + '/taskAuthInfo/taskID',
                                                                                                                    schemaPath: 'urn:wisepipe-common-auth:TaskAuthInfo/properties/taskID/type',
                                                                                                                    keyword: 'type',
                                                                                                                    params: { type: 'string' },
                                                                                                                    message: 'must be string'
                                                                                                                }
                                                                                                            ];
                                                                                                            return false;
                                                                                                        }
                                                                                                        var valid12 = _errs76 === errors;
                                                                                                    }
                                                                                                    else {
                                                                                                        var valid12 = true;
                                                                                                    }
                                                                                                    if (valid12) {
                                                                                                        if (data32.taskAuthToken !== undefined) {
                                                                                                            const _errs78 = errors;
                                                                                                            if (typeof data32.taskAuthToken !== 'string') {
                                                                                                                validate22.errors = [
                                                                                                                    {
                                                                                                                        instancePath: instancePath + '/taskAuthInfo/taskAuthToken',
                                                                                                                        schemaPath: 'urn:wisepipe-common-auth:TaskAuthInfo/properties/taskAuthToken/type',
                                                                                                                        keyword: 'type',
                                                                                                                        params: { type: 'string' },
                                                                                                                        message: 'must be string'
                                                                                                                    }
                                                                                                                ];
                                                                                                                return false;
                                                                                                            }
                                                                                                            var valid12 = _errs78 === errors;
                                                                                                        }
                                                                                                        else {
                                                                                                            var valid12 = true;
                                                                                                        }
                                                                                                        if (valid12) {
                                                                                                            if (data32.expiration !== undefined) {
                                                                                                                let data37 = data32.expiration;
                                                                                                                const _errs80 = errors;
                                                                                                                if (!(typeof data37 == 'number' &&
                                                                                                                    !(data37 % 1) &&
                                                                                                                    !isNaN(data37))) {
                                                                                                                    validate22.errors = [
                                                                                                                        {
                                                                                                                            instancePath: instancePath + '/taskAuthInfo/expiration',
                                                                                                                            schemaPath: 'urn:wisepipe-common-auth:TaskAuthInfo/properties/expiration/type',
                                                                                                                            keyword: 'type',
                                                                                                                            params: { type: 'integer' },
                                                                                                                            message: 'must be integer'
                                                                                                                        }
                                                                                                                    ];
                                                                                                                    return false;
                                                                                                                }
                                                                                                                var valid12 = _errs80 === errors;
                                                                                                            }
                                                                                                            else {
                                                                                                                var valid12 = true;
                                                                                                            }
                                                                                                            if (valid12) {
                                                                                                                if (data32.endpoint !== undefined) {
                                                                                                                    const _errs82 = errors;
                                                                                                                    if (typeof data32.endpoint !== 'string') {
                                                                                                                        validate22.errors = [
                                                                                                                            {
                                                                                                                                instancePath: instancePath + '/taskAuthInfo/endpoint',
                                                                                                                                schemaPath: 'urn:wisepipe-common-auth:TaskAuthInfo/properties/endpoint/type',
                                                                                                                                keyword: 'type',
                                                                                                                                params: { type: 'string' },
                                                                                                                                message: 'must be string'
                                                                                                                            }
                                                                                                                        ];
                                                                                                                        return false;
                                                                                                                    }
                                                                                                                    var valid12 = _errs82 === errors;
                                                                                                                }
                                                                                                                else {
                                                                                                                    var valid12 = true;
                                                                                                                }
                                                                                                            }
                                                                                                        }
                                                                                                    }
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                    else {
                                                                                        validate22.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/taskAuthInfo',
                                                                                                schemaPath: 'urn:wisepipe-common-auth:TaskAuthInfo/type',
                                                                                                keyword: 'type',
                                                                                                params: { type: 'object' },
                                                                                                message: 'must be object'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                }
                                                                                var valid0 = _errs69 === errors;
                                                                            }
                                                                            else {
                                                                                var valid0 = true;
                                                                            }
                                                                            if (valid0) {
                                                                                if (data.exportObj !== undefined) {
                                                                                    const _errs84 = errors;
                                                                                    if (!validate23(data.exportObj, {
                                                                                        instancePath: instancePath + '/exportObj',
                                                                                        parentData: data,
                                                                                        parentDataProperty: 'exportObj',
                                                                                        rootData
                                                                                    })) {
                                                                                        vErrors =
                                                                                            vErrors === null ? validate23.errors : vErrors.concat(validate23.errors);
                                                                                        errors = vErrors.length;
                                                                                    }
                                                                                    var valid0 = _errs84 === errors;
                                                                                }
                                                                                else {
                                                                                    var valid0 = true;
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate22.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate22.errors = vErrors;
    return errors === 0;
}
function validate19(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-export:ExportInput" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.exportTask !== undefined) {
                const _errs1 = errors;
                if (!validate20(data.exportTask, {
                    instancePath: instancePath + '/exportTask',
                    parentData: data,
                    parentDataProperty: 'exportTask',
                    rootData
                })) {
                    vErrors = vErrors === null ? validate20.errors : vErrors.concat(validate20.errors);
                    errors = vErrors.length;
                }
                var valid0 = _errs1 === errors;
            }
            else {
                var valid0 = true;
            }
            if (valid0) {
                if (data.exportTaskEnv !== undefined) {
                    const _errs2 = errors;
                    if (!validate22(data.exportTaskEnv, {
                        instancePath: instancePath + '/exportTaskEnv',
                        parentData: data,
                        parentDataProperty: 'exportTaskEnv',
                        rootData
                    })) {
                        vErrors = vErrors === null ? validate22.errors : vErrors.concat(validate22.errors);
                        errors = vErrors.length;
                    }
                    var valid0 = _errs2 === errors;
                }
                else {
                    var valid0 = true;
                }
            }
        }
        else {
            validate19.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate19.errors = vErrors;
    return errors === 0;
}
export const exportSchemaValidation = validate23;
export const exportSettingsSchemaValidation = validate26;
function validate26(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-export:ExportSettings" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.exportType === undefined && (missing0 = 'exportType')) {
                validate26.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.exportType !== undefined) {
                    let data0 = data.exportType;
                    if (typeof data0 !== 'string') {
                        validate26.errors = [
                            {
                                instancePath: instancePath + '/exportType',
                                schemaPath: '#/properties/exportType/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    if (!(data0 === 'gsheets' ||
                        data0 === 'icm' ||
                        data0 === 'postgres' ||
                        data0 === 'tq-postgres' ||
                        data0 === 'powerbi' ||
                        data0 === 'symon' ||
                        data0 === 'salesForce' ||
                        data0 === 'workday-payroll' ||
                        data0 === 'tableau' ||
                        data0 === 'tqp' ||
                        data0 === 'sftp' ||
                        data0 === 's3-csv' ||
                        data0 === 'snowflake' ||
                        data0 === 's3parquet' ||
                        data0 === 'msSql' ||
                        data0 === 'oneDrive')) {
                        validate26.errors = [
                            {
                                instancePath: instancePath + '/exportType',
                                schemaPath: '#/properties/exportType/enum',
                                keyword: 'enum',
                                params: { allowedValues: schema53.properties.exportType.enum },
                                message: 'must be equal to one of the allowed values'
                            }
                        ];
                        return false;
                    }
                }
            }
        }
        else {
            validate26.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate26.errors = vErrors;
    return errors === 0;
}
export const exportTaskEnvSchemaValidation = validate22;
export const exportTaskSchemaValidation = validate20;
export const extractionSchemaValidation = validate27;
const schema55 = {
    $id: 'urn:wisepipe-common-export:Extraction',
    type: 'object',
    properties: {
        extractionType: { type: 'string', enum: ['parquet', 'csv', 'excel'] },
        extractionMethod: { type: 'string', enum: ['parquet', 'csv_regular', 'csv_large', 'excel_regular'] }
    },
    required: ['extractionType', 'extractionMethod']
};
function validate27(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-export:Extraction" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.extractionType === undefined && (missing0 = 'extractionType')) ||
                (data.extractionMethod === undefined && (missing0 = 'extractionMethod'))) {
                validate27.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.extractionType !== undefined) {
                    let data0 = data.extractionType;
                    const _errs1 = errors;
                    if (typeof data0 !== 'string') {
                        validate27.errors = [
                            {
                                instancePath: instancePath + '/extractionType',
                                schemaPath: '#/properties/extractionType/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    if (!(data0 === 'parquet' || data0 === 'csv' || data0 === 'excel')) {
                        validate27.errors = [
                            {
                                instancePath: instancePath + '/extractionType',
                                schemaPath: '#/properties/extractionType/enum',
                                keyword: 'enum',
                                params: { allowedValues: schema55.properties.extractionType.enum },
                                message: 'must be equal to one of the allowed values'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.extractionMethod !== undefined) {
                        let data1 = data.extractionMethod;
                        const _errs3 = errors;
                        if (typeof data1 !== 'string') {
                            validate27.errors = [
                                {
                                    instancePath: instancePath + '/extractionMethod',
                                    schemaPath: '#/properties/extractionMethod/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        if (!(data1 === 'parquet' || data1 === 'csv_regular' || data1 === 'csv_large' || data1 === 'excel_regular')) {
                            validate27.errors = [
                                {
                                    instancePath: instancePath + '/extractionMethod',
                                    schemaPath: '#/properties/extractionMethod/enum',
                                    keyword: 'enum',
                                    params: { allowedValues: schema55.properties.extractionMethod.enum },
                                    message: 'must be equal to one of the allowed values'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate27.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate27.errors = vErrors;
    return errors === 0;
}
export const gSheetsExportSettingsSchemaValidation = validate28;
const schema56 = {
    $id: 'urn:wisepipe-common-export:GSheetsExportSettings',
    type: 'object',
    properties: { spreadsheetName: { type: 'string', minLength: 1 } },
    required: ['spreadsheetName']
};
function validate28(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-export:GSheetsExportSettings" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.spreadsheetName === undefined && (missing0 = 'spreadsheetName')) {
                validate28.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.spreadsheetName !== undefined) {
                    let data0 = data.spreadsheetName;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate28.errors = [
                                    {
                                        instancePath: instancePath + '/spreadsheetName',
                                        schemaPath: '#/properties/spreadsheetName/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate28.errors = [
                                {
                                    instancePath: instancePath + '/spreadsheetName',
                                    schemaPath: '#/properties/spreadsheetName/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                }
            }
        }
        else {
            validate28.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate28.errors = vErrors;
    return errors === 0;
}
export const icmExportSettingsSchemaValidation = validate29;
const schema57 = {
    $id: 'urn:wisepipe-common-export:IcmExportSettings',
    type: 'object',
    properties: {
        tableName: { type: 'string', minLength: 1 },
        keyColumns: {
            type: 'array',
            items: { type: 'string', minLength: 1 },
            uniqueItems: true,
            minItems: 1,
            maxItems: 25
        },
        updateExistingRows: { type: 'boolean' },
        addMembers: { type: 'boolean' },
        cancelOnUpdates: { type: 'boolean' }
    },
    required: ['keyColumns']
};
function validate29(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-export:IcmExportSettings" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.keyColumns === undefined && (missing0 = 'keyColumns')) {
                validate29.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.tableName !== undefined) {
                    let data0 = data.tableName;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate29.errors = [
                                    {
                                        instancePath: instancePath + '/tableName',
                                        schemaPath: '#/properties/tableName/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate29.errors = [
                                {
                                    instancePath: instancePath + '/tableName',
                                    schemaPath: '#/properties/tableName/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.keyColumns !== undefined) {
                        let data1 = data.keyColumns;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (Array.isArray(data1)) {
                                if (data1.length > 25) {
                                    validate29.errors = [
                                        {
                                            instancePath: instancePath + '/keyColumns',
                                            schemaPath: '#/properties/keyColumns/maxItems',
                                            keyword: 'maxItems',
                                            params: { limit: 25 },
                                            message: 'must NOT have more than 25 items'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    if (data1.length < 1) {
                                        validate29.errors = [
                                            {
                                                instancePath: instancePath + '/keyColumns',
                                                schemaPath: '#/properties/keyColumns/minItems',
                                                keyword: 'minItems',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 items'
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        var valid1 = true;
                                        const len0 = data1.length;
                                        for (let i0 = 0; i0 < len0; i0++) {
                                            let data2 = data1[i0];
                                            const _errs5 = errors;
                                            if (errors === _errs5) {
                                                if (typeof data2 === 'string') {
                                                    if (func2(data2) < 1) {
                                                        validate29.errors = [
                                                            {
                                                                instancePath: instancePath + '/keyColumns/' + i0,
                                                                schemaPath: '#/properties/keyColumns/items/minLength',
                                                                keyword: 'minLength',
                                                                params: { limit: 1 },
                                                                message: 'must NOT have fewer than 1 characters'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                else {
                                                    validate29.errors = [
                                                        {
                                                            instancePath: instancePath + '/keyColumns/' + i0,
                                                            schemaPath: '#/properties/keyColumns/items/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid1 = _errs5 === errors;
                                            if (!valid1) {
                                                break;
                                            }
                                        }
                                        if (valid1) {
                                            let i1 = data1.length;
                                            let j0;
                                            if (i1 > 1) {
                                                const indices0 = {};
                                                for (; i1--;) {
                                                    let item0 = data1[i1];
                                                    if (typeof item0 !== 'string') {
                                                        continue;
                                                    }
                                                    if (typeof indices0[item0] == 'number') {
                                                        j0 = indices0[item0];
                                                        validate29.errors = [
                                                            {
                                                                instancePath: instancePath + '/keyColumns',
                                                                schemaPath: '#/properties/keyColumns/uniqueItems',
                                                                keyword: 'uniqueItems',
                                                                params: { i: i1, j: j0 },
                                                                message: 'must NOT have duplicate items (items ## ' + j0 + ' and ' + i1 + ' are identical)'
                                                            }
                                                        ];
                                                        return false;
                                                        break;
                                                    }
                                                    indices0[item0] = i1;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            else {
                                validate29.errors = [
                                    {
                                        instancePath: instancePath + '/keyColumns',
                                        schemaPath: '#/properties/keyColumns/type',
                                        keyword: 'type',
                                        params: { type: 'array' },
                                        message: 'must be array'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.updateExistingRows !== undefined) {
                            const _errs7 = errors;
                            if (typeof data.updateExistingRows !== 'boolean') {
                                validate29.errors = [
                                    {
                                        instancePath: instancePath + '/updateExistingRows',
                                        schemaPath: '#/properties/updateExistingRows/type',
                                        keyword: 'type',
                                        params: { type: 'boolean' },
                                        message: 'must be boolean'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs7 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.addMembers !== undefined) {
                                const _errs9 = errors;
                                if (typeof data.addMembers !== 'boolean') {
                                    validate29.errors = [
                                        {
                                            instancePath: instancePath + '/addMembers',
                                            schemaPath: '#/properties/addMembers/type',
                                            keyword: 'type',
                                            params: { type: 'boolean' },
                                            message: 'must be boolean'
                                        }
                                    ];
                                    return false;
                                }
                                var valid0 = _errs9 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.cancelOnUpdates !== undefined) {
                                    const _errs11 = errors;
                                    if (typeof data.cancelOnUpdates !== 'boolean') {
                                        validate29.errors = [
                                            {
                                                instancePath: instancePath + '/cancelOnUpdates',
                                                schemaPath: '#/properties/cancelOnUpdates/type',
                                                keyword: 'type',
                                                params: { type: 'boolean' },
                                                message: 'must be boolean'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid0 = _errs11 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate29.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate29.errors = vErrors;
    return errors === 0;
}
export const msSqlExportSettingsSchemaValidation = validate30;
const schema58 = {
    $id: 'urn:wisepipe-common-export:MsSqlExportSettings',
    type: 'object',
    properties: { tableName: { type: 'string', minLength: 1, maxLength: 127 } },
    required: ['tableName']
};
function validate30(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-export:MsSqlExportSettings" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.tableName === undefined && (missing0 = 'tableName')) {
                validate30.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.tableName !== undefined) {
                    let data0 = data.tableName;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) > 127) {
                                validate30.errors = [
                                    {
                                        instancePath: instancePath + '/tableName',
                                        schemaPath: '#/properties/tableName/maxLength',
                                        keyword: 'maxLength',
                                        params: { limit: 127 },
                                        message: 'must NOT have more than 127 characters'
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (func2(data0) < 1) {
                                    validate30.errors = [
                                        {
                                            instancePath: instancePath + '/tableName',
                                            schemaPath: '#/properties/tableName/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        else {
                            validate30.errors = [
                                {
                                    instancePath: instancePath + '/tableName',
                                    schemaPath: '#/properties/tableName/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                }
            }
        }
        else {
            validate30.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate30.errors = vErrors;
    return errors === 0;
}
export const oneDriveExportSettingsSchemaValidation = validate31;
const schema59 = {
    $id: 'urn:wisepipe-common-export:OneDriveExportSettings',
    type: 'object',
    properties: {
        filename: { type: 'string', minLength: 1 },
        itemPath: { type: 'string', minLength: 1 },
        addTimestampSuffix: { type: 'boolean' },
        s3StagingLoc: { $ref: 'urn:wisepipe-common:S3File' },
        isExcel: { type: 'boolean' },
        delimiter: { type: 'string' },
        exportFileType: { type: 'string', enum: ['.csv', '.xlsx', '.txt'] }
    },
    required: ['filename', 'itemPath']
};
const func110 = ucs2length;
const func111 = base64urlToBuffer;
const func112 = base64urlEncode;
const func113 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate31(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-export:OneDriveExportSettings" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.filename === undefined && (missing0 = 'filename')) ||
                (data.itemPath === undefined && (missing0 = 'itemPath'))) {
                validate31.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.filename !== undefined) {
                    let data0 = data.filename;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate31.errors = [
                                    {
                                        instancePath: instancePath + '/filename',
                                        schemaPath: '#/properties/filename/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate31.errors = [
                                {
                                    instancePath: instancePath + '/filename',
                                    schemaPath: '#/properties/filename/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.itemPath !== undefined) {
                        let data1 = data.itemPath;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate31.errors = [
                                        {
                                            instancePath: instancePath + '/itemPath',
                                            schemaPath: '#/properties/itemPath/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate31.errors = [
                                    {
                                        instancePath: instancePath + '/itemPath',
                                        schemaPath: '#/properties/itemPath/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.addTimestampSuffix !== undefined) {
                            const _errs5 = errors;
                            if (typeof data.addTimestampSuffix !== 'boolean') {
                                validate31.errors = [
                                    {
                                        instancePath: instancePath + '/addTimestampSuffix',
                                        schemaPath: '#/properties/addTimestampSuffix/type',
                                        keyword: 'type',
                                        params: { type: 'boolean' },
                                        message: 'must be boolean'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.s3StagingLoc !== undefined) {
                                let data3 = data.s3StagingLoc;
                                const _errs7 = errors;
                                const _errs8 = errors;
                                if (errors === _errs8) {
                                    if (data3 && typeof data3 == 'object' && !Array.isArray(data3)) {
                                        let missing1;
                                        if ((data3.bucket === undefined && (missing1 = 'bucket')) ||
                                            (data3.key === undefined && (missing1 = 'key'))) {
                                            validate31.errors = [
                                                {
                                                    instancePath: instancePath + '/s3StagingLoc',
                                                    schemaPath: 'urn:wisepipe-common:S3File/required',
                                                    keyword: 'required',
                                                    params: { missingProperty: missing1 },
                                                    message: "must have required property '" + missing1 + "'"
                                                }
                                            ];
                                            return false;
                                        }
                                        else {
                                            if (data3.bucket !== undefined) {
                                                let data4 = data3.bucket;
                                                const _errs10 = errors;
                                                if (errors === _errs10) {
                                                    if (typeof data4 === 'string') {
                                                        if (func2(data4) < 1) {
                                                            validate31.errors = [
                                                                {
                                                                    instancePath: instancePath + '/s3StagingLoc/bucket',
                                                                    schemaPath: 'urn:wisepipe-common:S3File/properties/bucket/minLength',
                                                                    keyword: 'minLength',
                                                                    params: { limit: 1 },
                                                                    message: 'must NOT have fewer than 1 characters'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    else {
                                                        validate31.errors = [
                                                            {
                                                                instancePath: instancePath + '/s3StagingLoc/bucket',
                                                                schemaPath: 'urn:wisepipe-common:S3File/properties/bucket/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                var valid2 = _errs10 === errors;
                                            }
                                            else {
                                                var valid2 = true;
                                            }
                                            if (valid2) {
                                                if (data3.key !== undefined) {
                                                    let data5 = data3.key;
                                                    const _errs12 = errors;
                                                    if (errors === _errs12) {
                                                        if (typeof data5 === 'string') {
                                                            if (func2(data5) < 1) {
                                                                validate31.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/s3StagingLoc/key',
                                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/key/minLength',
                                                                        keyword: 'minLength',
                                                                        params: { limit: 1 },
                                                                        message: 'must NOT have fewer than 1 characters'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        else {
                                                            validate31.errors = [
                                                                {
                                                                    instancePath: instancePath + '/s3StagingLoc/key',
                                                                    schemaPath: 'urn:wisepipe-common:S3File/properties/key/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    var valid2 = _errs12 === errors;
                                                }
                                                else {
                                                    var valid2 = true;
                                                }
                                                if (valid2) {
                                                    if (data3.uploadID !== undefined) {
                                                        let data6 = data3.uploadID;
                                                        const _errs14 = errors;
                                                        if (errors === _errs14) {
                                                            if (typeof data6 === 'string') {
                                                                const b64min0 = Math.ceil((4 * 9) / 3);
                                                                const b64max0 = Math.ceil((4 * 9) / 3) + 3;
                                                                if (func110(data6) < b64min0 || func110(data6) > b64max0) {
                                                                    validate31.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/s3StagingLoc/uploadID',
                                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                            keyword: 'uid',
                                                                            params: {
                                                                                error: 'encoded',
                                                                                b64min: b64min0,
                                                                                b64max: b64max0,
                                                                                length: func110(data6)
                                                                            },
                                                                            message: 'length must be between ' +
                                                                                b64min0 +
                                                                                ' and ' +
                                                                                b64max0 +
                                                                                ', but is ' +
                                                                                func110(data6)
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                                else {
                                                                    const decoded0 = func111(data6);
                                                                    if (decoded0.length !== 9) {
                                                                        validate31.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/s3StagingLoc/uploadID',
                                                                                schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                                keyword: 'uid',
                                                                                params: { error: 'decoded' },
                                                                                message: 'must decode to 9 bytes'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                    else {
                                                                        const encoded0 = func112(decoded0);
                                                                        if (func113(encoded0) !== func113(data6)) {
                                                                            validate31.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/s3StagingLoc/uploadID',
                                                                                    schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                                    keyword: 'uid',
                                                                                    params: { error: 'ambiguous' },
                                                                                    message: 'encoding is ambiguous'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                            else {
                                                                validate31.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/s3StagingLoc/uploadID',
                                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'string' },
                                                                        message: 'must be string'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        var valid2 = _errs14 === errors;
                                                    }
                                                    else {
                                                        var valid2 = true;
                                                    }
                                                }
                                            }
                                        }
                                    }
                                    else {
                                        validate31.errors = [
                                            {
                                                instancePath: instancePath + '/s3StagingLoc',
                                                schemaPath: 'urn:wisepipe-common:S3File/type',
                                                keyword: 'type',
                                                params: { type: 'object' },
                                                message: 'must be object'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.isExcel !== undefined) {
                                    const _errs16 = errors;
                                    if (typeof data.isExcel !== 'boolean') {
                                        validate31.errors = [
                                            {
                                                instancePath: instancePath + '/isExcel',
                                                schemaPath: '#/properties/isExcel/type',
                                                keyword: 'type',
                                                params: { type: 'boolean' },
                                                message: 'must be boolean'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid0 = _errs16 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.delimiter !== undefined) {
                                        const _errs18 = errors;
                                        if (typeof data.delimiter !== 'string') {
                                            validate31.errors = [
                                                {
                                                    instancePath: instancePath + '/delimiter',
                                                    schemaPath: '#/properties/delimiter/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                        var valid0 = _errs18 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                    if (valid0) {
                                        if (data.exportFileType !== undefined) {
                                            let data9 = data.exportFileType;
                                            const _errs20 = errors;
                                            if (typeof data9 !== 'string') {
                                                validate31.errors = [
                                                    {
                                                        instancePath: instancePath + '/exportFileType',
                                                        schemaPath: '#/properties/exportFileType/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                            if (!(data9 === '.csv' || data9 === '.xlsx' || data9 === '.txt')) {
                                                validate31.errors = [
                                                    {
                                                        instancePath: instancePath + '/exportFileType',
                                                        schemaPath: '#/properties/exportFileType/enum',
                                                        keyword: 'enum',
                                                        params: { allowedValues: schema59.properties.exportFileType.enum },
                                                        message: 'must be equal to one of the allowed values'
                                                    }
                                                ];
                                                return false;
                                            }
                                            var valid0 = _errs20 === errors;
                                        }
                                        else {
                                            var valid0 = true;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate31.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate31.errors = vErrors;
    return errors === 0;
}
export const parquetExtractionSchemaValidation = validate32;
const schema61 = {
    $id: 'urn:wisepipe-common-export:ParquetExtraction',
    type: 'object',
    properties: { parquetFile: { $ref: 'urn:wisepipe-common:S3File' }, totalFileSizeBytes: { type: 'number' } },
    required: ['parquetFile']
};
const func116 = ucs2length;
const func117 = base64urlToBuffer;
const func118 = base64urlEncode;
const func119 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate32(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-export:ParquetExtraction" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.parquetFile === undefined && (missing0 = 'parquetFile')) {
                validate32.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.parquetFile !== undefined) {
                    let data0 = data.parquetFile;
                    const _errs1 = errors;
                    const _errs2 = errors;
                    if (errors === _errs2) {
                        if (data0 && typeof data0 == 'object' && !Array.isArray(data0)) {
                            let missing1;
                            if ((data0.bucket === undefined && (missing1 = 'bucket')) ||
                                (data0.key === undefined && (missing1 = 'key'))) {
                                validate32.errors = [
                                    {
                                        instancePath: instancePath + '/parquetFile',
                                        schemaPath: 'urn:wisepipe-common:S3File/required',
                                        keyword: 'required',
                                        params: { missingProperty: missing1 },
                                        message: "must have required property '" + missing1 + "'"
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (data0.bucket !== undefined) {
                                    let data1 = data0.bucket;
                                    const _errs4 = errors;
                                    if (errors === _errs4) {
                                        if (typeof data1 === 'string') {
                                            if (func2(data1) < 1) {
                                                validate32.errors = [
                                                    {
                                                        instancePath: instancePath + '/parquetFile/bucket',
                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/bucket/minLength',
                                                        keyword: 'minLength',
                                                        params: { limit: 1 },
                                                        message: 'must NOT have fewer than 1 characters'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate32.errors = [
                                                {
                                                    instancePath: instancePath + '/parquetFile/bucket',
                                                    schemaPath: 'urn:wisepipe-common:S3File/properties/bucket/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid2 = _errs4 === errors;
                                }
                                else {
                                    var valid2 = true;
                                }
                                if (valid2) {
                                    if (data0.key !== undefined) {
                                        let data2 = data0.key;
                                        const _errs6 = errors;
                                        if (errors === _errs6) {
                                            if (typeof data2 === 'string') {
                                                if (func2(data2) < 1) {
                                                    validate32.errors = [
                                                        {
                                                            instancePath: instancePath + '/parquetFile/key',
                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/key/minLength',
                                                            keyword: 'minLength',
                                                            params: { limit: 1 },
                                                            message: 'must NOT have fewer than 1 characters'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            else {
                                                validate32.errors = [
                                                    {
                                                        instancePath: instancePath + '/parquetFile/key',
                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/key/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid2 = _errs6 === errors;
                                    }
                                    else {
                                        var valid2 = true;
                                    }
                                    if (valid2) {
                                        if (data0.uploadID !== undefined) {
                                            let data3 = data0.uploadID;
                                            const _errs8 = errors;
                                            if (errors === _errs8) {
                                                if (typeof data3 === 'string') {
                                                    const b64min0 = Math.ceil((4 * 9) / 3);
                                                    const b64max0 = Math.ceil((4 * 9) / 3) + 3;
                                                    if (func116(data3) < b64min0 || func116(data3) > b64max0) {
                                                        validate32.errors = [
                                                            {
                                                                instancePath: instancePath + '/parquetFile/uploadID',
                                                                schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                keyword: 'uid',
                                                                params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func116(data3) },
                                                                message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func116(data3)
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    else {
                                                        const decoded0 = func117(data3);
                                                        if (decoded0.length !== 9) {
                                                            validate32.errors = [
                                                                {
                                                                    instancePath: instancePath + '/parquetFile/uploadID',
                                                                    schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                    keyword: 'uid',
                                                                    params: { error: 'decoded' },
                                                                    message: 'must decode to 9 bytes'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        else {
                                                            const encoded0 = func118(decoded0);
                                                            if (func119(encoded0) !== func119(data3)) {
                                                                validate32.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/parquetFile/uploadID',
                                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                        keyword: 'uid',
                                                                        params: { error: 'ambiguous' },
                                                                        message: 'encoding is ambiguous'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                    }
                                                }
                                                else {
                                                    validate32.errors = [
                                                        {
                                                            instancePath: instancePath + '/parquetFile/uploadID',
                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid2 = _errs8 === errors;
                                        }
                                        else {
                                            var valid2 = true;
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            validate32.errors = [
                                {
                                    instancePath: instancePath + '/parquetFile',
                                    schemaPath: 'urn:wisepipe-common:S3File/type',
                                    keyword: 'type',
                                    params: { type: 'object' },
                                    message: 'must be object'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.totalFileSizeBytes !== undefined) {
                        const _errs10 = errors;
                        if (!(typeof data.totalFileSizeBytes == 'number')) {
                            validate32.errors = [
                                {
                                    instancePath: instancePath + '/totalFileSizeBytes',
                                    schemaPath: '#/properties/totalFileSizeBytes/type',
                                    keyword: 'type',
                                    params: { type: 'number' },
                                    message: 'must be number'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs10 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate32.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate32.errors = vErrors;
    return errors === 0;
}
export const postgresExportSettingsSchemaValidation = validate33;
const schema63 = {
    $id: 'urn:wisepipe-common-export:PostgresExportSettings',
    type: 'object',
    properties: {
        tableName: { type: 'string', minLength: 1, maxLength: 63 },
        schema: { type: 'string', minLength: 1, maxLength: 63 }
    },
    required: ['tableName', 'schema']
};
function validate33(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-export:PostgresExportSettings" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.tableName === undefined && (missing0 = 'tableName')) ||
                (data.schema === undefined && (missing0 = 'schema'))) {
                validate33.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.tableName !== undefined) {
                    let data0 = data.tableName;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) > 63) {
                                validate33.errors = [
                                    {
                                        instancePath: instancePath + '/tableName',
                                        schemaPath: '#/properties/tableName/maxLength',
                                        keyword: 'maxLength',
                                        params: { limit: 63 },
                                        message: 'must NOT have more than 63 characters'
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (func2(data0) < 1) {
                                    validate33.errors = [
                                        {
                                            instancePath: instancePath + '/tableName',
                                            schemaPath: '#/properties/tableName/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        else {
                            validate33.errors = [
                                {
                                    instancePath: instancePath + '/tableName',
                                    schemaPath: '#/properties/tableName/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.schema !== undefined) {
                        let data1 = data.schema;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) > 63) {
                                    validate33.errors = [
                                        {
                                            instancePath: instancePath + '/schema',
                                            schemaPath: '#/properties/schema/maxLength',
                                            keyword: 'maxLength',
                                            params: { limit: 63 },
                                            message: 'must NOT have more than 63 characters'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    if (func2(data1) < 1) {
                                        validate33.errors = [
                                            {
                                                instancePath: instancePath + '/schema',
                                                schemaPath: '#/properties/schema/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                            else {
                                validate33.errors = [
                                    {
                                        instancePath: instancePath + '/schema',
                                        schemaPath: '#/properties/schema/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate33.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate33.errors = vErrors;
    return errors === 0;
}
export const powerBIExportSettingsSchemaValidation = validate34;
const schema64 = {
    $id: 'urn:wisepipe-common-export:PowerBIExportSettings',
    type: 'object',
    properties: { workspaceName: { type: 'string', minLength: 1 }, datasetName: { type: 'string', minLength: 1 } },
    required: ['workspaceName', 'datasetName']
};
function validate34(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-export:PowerBIExportSettings" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.workspaceName === undefined && (missing0 = 'workspaceName')) ||
                (data.datasetName === undefined && (missing0 = 'datasetName'))) {
                validate34.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.workspaceName !== undefined) {
                    let data0 = data.workspaceName;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate34.errors = [
                                    {
                                        instancePath: instancePath + '/workspaceName',
                                        schemaPath: '#/properties/workspaceName/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate34.errors = [
                                {
                                    instancePath: instancePath + '/workspaceName',
                                    schemaPath: '#/properties/workspaceName/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.datasetName !== undefined) {
                        let data1 = data.datasetName;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate34.errors = [
                                        {
                                            instancePath: instancePath + '/datasetName',
                                            schemaPath: '#/properties/datasetName/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate34.errors = [
                                    {
                                        instancePath: instancePath + '/datasetName',
                                        schemaPath: '#/properties/datasetName/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate34.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate34.errors = vErrors;
    return errors === 0;
}
export const s3FileSchemaValidation = validate35;
const func128 = ucs2length;
const func129 = base64urlToBuffer;
const func130 = base64urlEncode;
const func131 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate35(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common:S3File" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.bucket === undefined && (missing0 = 'bucket')) || (data.key === undefined && (missing0 = 'key'))) {
                validate35.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.bucket !== undefined) {
                    let data0 = data.bucket;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate35.errors = [
                                    {
                                        instancePath: instancePath + '/bucket',
                                        schemaPath: '#/properties/bucket/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate35.errors = [
                                {
                                    instancePath: instancePath + '/bucket',
                                    schemaPath: '#/properties/bucket/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.key !== undefined) {
                        let data1 = data.key;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate35.errors = [
                                        {
                                            instancePath: instancePath + '/key',
                                            schemaPath: '#/properties/key/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate35.errors = [
                                    {
                                        instancePath: instancePath + '/key',
                                        schemaPath: '#/properties/key/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.uploadID !== undefined) {
                            let data2 = data.uploadID;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    const b64min0 = Math.ceil((4 * 9) / 3);
                                    const b64max0 = Math.ceil((4 * 9) / 3) + 3;
                                    if (func128(data2) < b64min0 || func128(data2) > b64max0) {
                                        validate35.errors = [
                                            {
                                                instancePath: instancePath + '/uploadID',
                                                schemaPath: '#/properties/uploadID/uid',
                                                keyword: 'uid',
                                                params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func128(data2) },
                                                message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func128(data2)
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        const decoded0 = func129(data2);
                                        if (decoded0.length !== 9) {
                                            validate35.errors = [
                                                {
                                                    instancePath: instancePath + '/uploadID',
                                                    schemaPath: '#/properties/uploadID/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'decoded' },
                                                    message: 'must decode to 9 bytes'
                                                }
                                            ];
                                            return false;
                                        }
                                        else {
                                            const encoded0 = func130(decoded0);
                                            if (func131(encoded0) !== func131(data2)) {
                                                validate35.errors = [
                                                    {
                                                        instancePath: instancePath + '/uploadID',
                                                        schemaPath: '#/properties/uploadID/uid',
                                                        keyword: 'uid',
                                                        params: { error: 'ambiguous' },
                                                        message: 'encoding is ambiguous'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                    }
                                }
                                else {
                                    validate35.errors = [
                                        {
                                            instancePath: instancePath + '/uploadID',
                                            schemaPath: '#/properties/uploadID/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate35.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate35.errors = vErrors;
    return errors === 0;
}
export const s3ParquetExportSettingsSchemaValidation = validate36;
const schema66 = {
    $id: 'urn:wisepipe-common-export:S3ParquetExportSettings',
    type: 'object',
    properties: { s3File: { $ref: 'urn:wisepipe-common:S3File' } },
    required: ['s3File']
};
const func134 = ucs2length;
const func135 = base64urlToBuffer;
const func136 = base64urlEncode;
const func137 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate36(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-export:S3ParquetExportSettings" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.s3File === undefined && (missing0 = 's3File')) {
                validate36.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.s3File !== undefined) {
                    let data0 = data.s3File;
                    const _errs2 = errors;
                    if (errors === _errs2) {
                        if (data0 && typeof data0 == 'object' && !Array.isArray(data0)) {
                            let missing1;
                            if ((data0.bucket === undefined && (missing1 = 'bucket')) ||
                                (data0.key === undefined && (missing1 = 'key'))) {
                                validate36.errors = [
                                    {
                                        instancePath: instancePath + '/s3File',
                                        schemaPath: 'urn:wisepipe-common:S3File/required',
                                        keyword: 'required',
                                        params: { missingProperty: missing1 },
                                        message: "must have required property '" + missing1 + "'"
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (data0.bucket !== undefined) {
                                    let data1 = data0.bucket;
                                    const _errs4 = errors;
                                    if (errors === _errs4) {
                                        if (typeof data1 === 'string') {
                                            if (func2(data1) < 1) {
                                                validate36.errors = [
                                                    {
                                                        instancePath: instancePath + '/s3File/bucket',
                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/bucket/minLength',
                                                        keyword: 'minLength',
                                                        params: { limit: 1 },
                                                        message: 'must NOT have fewer than 1 characters'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate36.errors = [
                                                {
                                                    instancePath: instancePath + '/s3File/bucket',
                                                    schemaPath: 'urn:wisepipe-common:S3File/properties/bucket/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid2 = _errs4 === errors;
                                }
                                else {
                                    var valid2 = true;
                                }
                                if (valid2) {
                                    if (data0.key !== undefined) {
                                        let data2 = data0.key;
                                        const _errs6 = errors;
                                        if (errors === _errs6) {
                                            if (typeof data2 === 'string') {
                                                if (func2(data2) < 1) {
                                                    validate36.errors = [
                                                        {
                                                            instancePath: instancePath + '/s3File/key',
                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/key/minLength',
                                                            keyword: 'minLength',
                                                            params: { limit: 1 },
                                                            message: 'must NOT have fewer than 1 characters'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            else {
                                                validate36.errors = [
                                                    {
                                                        instancePath: instancePath + '/s3File/key',
                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/key/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid2 = _errs6 === errors;
                                    }
                                    else {
                                        var valid2 = true;
                                    }
                                    if (valid2) {
                                        if (data0.uploadID !== undefined) {
                                            let data3 = data0.uploadID;
                                            const _errs8 = errors;
                                            if (errors === _errs8) {
                                                if (typeof data3 === 'string') {
                                                    const b64min0 = Math.ceil((4 * 9) / 3);
                                                    const b64max0 = Math.ceil((4 * 9) / 3) + 3;
                                                    if (func134(data3) < b64min0 || func134(data3) > b64max0) {
                                                        validate36.errors = [
                                                            {
                                                                instancePath: instancePath + '/s3File/uploadID',
                                                                schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                keyword: 'uid',
                                                                params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func134(data3) },
                                                                message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func134(data3)
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    else {
                                                        const decoded0 = func135(data3);
                                                        if (decoded0.length !== 9) {
                                                            validate36.errors = [
                                                                {
                                                                    instancePath: instancePath + '/s3File/uploadID',
                                                                    schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                    keyword: 'uid',
                                                                    params: { error: 'decoded' },
                                                                    message: 'must decode to 9 bytes'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        else {
                                                            const encoded0 = func136(decoded0);
                                                            if (func137(encoded0) !== func137(data3)) {
                                                                validate36.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/s3File/uploadID',
                                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                        keyword: 'uid',
                                                                        params: { error: 'ambiguous' },
                                                                        message: 'encoding is ambiguous'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                    }
                                                }
                                                else {
                                                    validate36.errors = [
                                                        {
                                                            instancePath: instancePath + '/s3File/uploadID',
                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid2 = _errs8 === errors;
                                        }
                                        else {
                                            var valid2 = true;
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            validate36.errors = [
                                {
                                    instancePath: instancePath + '/s3File',
                                    schemaPath: 'urn:wisepipe-common:S3File/type',
                                    keyword: 'type',
                                    params: { type: 'object' },
                                    message: 'must be object'
                                }
                            ];
                            return false;
                        }
                    }
                }
            }
        }
        else {
            validate36.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate36.errors = vErrors;
    return errors === 0;
}
export const salesforceExportSettingsSchemaValidation = validate37;
const schema68 = {
    $id: 'urn:wisepipe-common-export:SalesforceExportSettings',
    type: 'object',
    properties: { objectName: { type: 'string', minLength: 1 } },
    required: ['objectName']
};
function validate37(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-export:SalesforceExportSettings" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.objectName === undefined && (missing0 = 'objectName')) {
                validate37.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.objectName !== undefined) {
                    let data0 = data.objectName;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate37.errors = [
                                    {
                                        instancePath: instancePath + '/objectName',
                                        schemaPath: '#/properties/objectName/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate37.errors = [
                                {
                                    instancePath: instancePath + '/objectName',
                                    schemaPath: '#/properties/objectName/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                }
            }
        }
        else {
            validate37.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate37.errors = vErrors;
    return errors === 0;
}
export const sftpExportSettingsSchemaValidation = validate38;
const schema69 = {
    $id: 'urn:wisepipe-common-export:SftpExportSettings',
    type: 'object',
    properties: {
        sftpPrefix: { type: 'string' },
        publicKey: { type: 'string', minLength: 1 },
        s3StagingLoc: { $ref: 'urn:wisepipe-common:S3File' },
        isExcel: { type: 'boolean' },
        addTimestampSuffix: { type: 'boolean' },
        delimiter: { type: 'string' },
        exportFileType: { type: 'string', enum: ['.csv', '.xlsx', '.txt'] }
    },
    required: ['sftpPrefix']
};
const func142 = ucs2length;
const func143 = base64urlToBuffer;
const func144 = base64urlEncode;
const func145 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate38(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-export:SftpExportSettings" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.sftpPrefix === undefined && (missing0 = 'sftpPrefix')) {
                validate38.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.sftpPrefix !== undefined) {
                    const _errs1 = errors;
                    if (typeof data.sftpPrefix !== 'string') {
                        validate38.errors = [
                            {
                                instancePath: instancePath + '/sftpPrefix',
                                schemaPath: '#/properties/sftpPrefix/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.publicKey !== undefined) {
                        let data1 = data.publicKey;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate38.errors = [
                                        {
                                            instancePath: instancePath + '/publicKey',
                                            schemaPath: '#/properties/publicKey/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate38.errors = [
                                    {
                                        instancePath: instancePath + '/publicKey',
                                        schemaPath: '#/properties/publicKey/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.s3StagingLoc !== undefined) {
                            let data2 = data.s3StagingLoc;
                            const _errs5 = errors;
                            const _errs6 = errors;
                            if (errors === _errs6) {
                                if (data2 && typeof data2 == 'object' && !Array.isArray(data2)) {
                                    let missing1;
                                    if ((data2.bucket === undefined && (missing1 = 'bucket')) ||
                                        (data2.key === undefined && (missing1 = 'key'))) {
                                        validate38.errors = [
                                            {
                                                instancePath: instancePath + '/s3StagingLoc',
                                                schemaPath: 'urn:wisepipe-common:S3File/required',
                                                keyword: 'required',
                                                params: { missingProperty: missing1 },
                                                message: "must have required property '" + missing1 + "'"
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        if (data2.bucket !== undefined) {
                                            let data3 = data2.bucket;
                                            const _errs8 = errors;
                                            if (errors === _errs8) {
                                                if (typeof data3 === 'string') {
                                                    if (func2(data3) < 1) {
                                                        validate38.errors = [
                                                            {
                                                                instancePath: instancePath + '/s3StagingLoc/bucket',
                                                                schemaPath: 'urn:wisepipe-common:S3File/properties/bucket/minLength',
                                                                keyword: 'minLength',
                                                                params: { limit: 1 },
                                                                message: 'must NOT have fewer than 1 characters'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                else {
                                                    validate38.errors = [
                                                        {
                                                            instancePath: instancePath + '/s3StagingLoc/bucket',
                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/bucket/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid2 = _errs8 === errors;
                                        }
                                        else {
                                            var valid2 = true;
                                        }
                                        if (valid2) {
                                            if (data2.key !== undefined) {
                                                let data4 = data2.key;
                                                const _errs10 = errors;
                                                if (errors === _errs10) {
                                                    if (typeof data4 === 'string') {
                                                        if (func2(data4) < 1) {
                                                            validate38.errors = [
                                                                {
                                                                    instancePath: instancePath + '/s3StagingLoc/key',
                                                                    schemaPath: 'urn:wisepipe-common:S3File/properties/key/minLength',
                                                                    keyword: 'minLength',
                                                                    params: { limit: 1 },
                                                                    message: 'must NOT have fewer than 1 characters'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    else {
                                                        validate38.errors = [
                                                            {
                                                                instancePath: instancePath + '/s3StagingLoc/key',
                                                                schemaPath: 'urn:wisepipe-common:S3File/properties/key/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                var valid2 = _errs10 === errors;
                                            }
                                            else {
                                                var valid2 = true;
                                            }
                                            if (valid2) {
                                                if (data2.uploadID !== undefined) {
                                                    let data5 = data2.uploadID;
                                                    const _errs12 = errors;
                                                    if (errors === _errs12) {
                                                        if (typeof data5 === 'string') {
                                                            const b64min0 = Math.ceil((4 * 9) / 3);
                                                            const b64max0 = Math.ceil((4 * 9) / 3) + 3;
                                                            if (func142(data5) < b64min0 || func142(data5) > b64max0) {
                                                                validate38.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/s3StagingLoc/uploadID',
                                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                        keyword: 'uid',
                                                                        params: {
                                                                            error: 'encoded',
                                                                            b64min: b64min0,
                                                                            b64max: b64max0,
                                                                            length: func142(data5)
                                                                        },
                                                                        message: 'length must be between ' +
                                                                            b64min0 +
                                                                            ' and ' +
                                                                            b64max0 +
                                                                            ', but is ' +
                                                                            func142(data5)
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            else {
                                                                const decoded0 = func143(data5);
                                                                if (decoded0.length !== 9) {
                                                                    validate38.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/s3StagingLoc/uploadID',
                                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                            keyword: 'uid',
                                                                            params: { error: 'decoded' },
                                                                            message: 'must decode to 9 bytes'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                                else {
                                                                    const encoded0 = func144(decoded0);
                                                                    if (func145(encoded0) !== func145(data5)) {
                                                                        validate38.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/s3StagingLoc/uploadID',
                                                                                schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                                keyword: 'uid',
                                                                                params: { error: 'ambiguous' },
                                                                                message: 'encoding is ambiguous'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                            }
                                                        }
                                                        else {
                                                            validate38.errors = [
                                                                {
                                                                    instancePath: instancePath + '/s3StagingLoc/uploadID',
                                                                    schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    var valid2 = _errs12 === errors;
                                                }
                                                else {
                                                    var valid2 = true;
                                                }
                                            }
                                        }
                                    }
                                }
                                else {
                                    validate38.errors = [
                                        {
                                            instancePath: instancePath + '/s3StagingLoc',
                                            schemaPath: 'urn:wisepipe-common:S3File/type',
                                            keyword: 'type',
                                            params: { type: 'object' },
                                            message: 'must be object'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.isExcel !== undefined) {
                                const _errs14 = errors;
                                if (typeof data.isExcel !== 'boolean') {
                                    validate38.errors = [
                                        {
                                            instancePath: instancePath + '/isExcel',
                                            schemaPath: '#/properties/isExcel/type',
                                            keyword: 'type',
                                            params: { type: 'boolean' },
                                            message: 'must be boolean'
                                        }
                                    ];
                                    return false;
                                }
                                var valid0 = _errs14 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.addTimestampSuffix !== undefined) {
                                    const _errs16 = errors;
                                    if (typeof data.addTimestampSuffix !== 'boolean') {
                                        validate38.errors = [
                                            {
                                                instancePath: instancePath + '/addTimestampSuffix',
                                                schemaPath: '#/properties/addTimestampSuffix/type',
                                                keyword: 'type',
                                                params: { type: 'boolean' },
                                                message: 'must be boolean'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid0 = _errs16 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.delimiter !== undefined) {
                                        const _errs18 = errors;
                                        if (typeof data.delimiter !== 'string') {
                                            validate38.errors = [
                                                {
                                                    instancePath: instancePath + '/delimiter',
                                                    schemaPath: '#/properties/delimiter/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                        var valid0 = _errs18 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                    if (valid0) {
                                        if (data.exportFileType !== undefined) {
                                            let data9 = data.exportFileType;
                                            const _errs20 = errors;
                                            if (typeof data9 !== 'string') {
                                                validate38.errors = [
                                                    {
                                                        instancePath: instancePath + '/exportFileType',
                                                        schemaPath: '#/properties/exportFileType/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                            if (!(data9 === '.csv' || data9 === '.xlsx' || data9 === '.txt')) {
                                                validate38.errors = [
                                                    {
                                                        instancePath: instancePath + '/exportFileType',
                                                        schemaPath: '#/properties/exportFileType/enum',
                                                        keyword: 'enum',
                                                        params: { allowedValues: schema69.properties.exportFileType.enum },
                                                        message: 'must be equal to one of the allowed values'
                                                    }
                                                ];
                                                return false;
                                            }
                                            var valid0 = _errs20 === errors;
                                        }
                                        else {
                                            var valid0 = true;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate38.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate38.errors = vErrors;
    return errors === 0;
}
export const snowflakeExportSettingsSchemaValidation = validate39;
const schema71 = {
    $id: 'urn:wisepipe-common-export:SnowflakeExportSettings',
    type: 'object',
    properties: {
        schema: { type: 'string', minLength: 1 },
        keyColumns: { type: 'array', items: { type: 'string', minLength: 1 }, uniqueItems: true, minItems: 1 },
        fileFormat: { type: 'string', minLength: 1 }
    },
    required: ['schema', 'keyColumns', 'fileFormat']
};
function validate39(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-export:SnowflakeExportSettings" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.schema === undefined && (missing0 = 'schema')) ||
                (data.keyColumns === undefined && (missing0 = 'keyColumns')) ||
                (data.fileFormat === undefined && (missing0 = 'fileFormat'))) {
                validate39.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.schema !== undefined) {
                    let data0 = data.schema;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate39.errors = [
                                    {
                                        instancePath: instancePath + '/schema',
                                        schemaPath: '#/properties/schema/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate39.errors = [
                                {
                                    instancePath: instancePath + '/schema',
                                    schemaPath: '#/properties/schema/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.keyColumns !== undefined) {
                        let data1 = data.keyColumns;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (Array.isArray(data1)) {
                                if (data1.length < 1) {
                                    validate39.errors = [
                                        {
                                            instancePath: instancePath + '/keyColumns',
                                            schemaPath: '#/properties/keyColumns/minItems',
                                            keyword: 'minItems',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 items'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    var valid1 = true;
                                    const len0 = data1.length;
                                    for (let i0 = 0; i0 < len0; i0++) {
                                        let data2 = data1[i0];
                                        const _errs5 = errors;
                                        if (errors === _errs5) {
                                            if (typeof data2 === 'string') {
                                                if (func2(data2) < 1) {
                                                    validate39.errors = [
                                                        {
                                                            instancePath: instancePath + '/keyColumns/' + i0,
                                                            schemaPath: '#/properties/keyColumns/items/minLength',
                                                            keyword: 'minLength',
                                                            params: { limit: 1 },
                                                            message: 'must NOT have fewer than 1 characters'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            else {
                                                validate39.errors = [
                                                    {
                                                        instancePath: instancePath + '/keyColumns/' + i0,
                                                        schemaPath: '#/properties/keyColumns/items/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid1 = _errs5 === errors;
                                        if (!valid1) {
                                            break;
                                        }
                                    }
                                    if (valid1) {
                                        let i1 = data1.length;
                                        let j0;
                                        if (i1 > 1) {
                                            const indices0 = {};
                                            for (; i1--;) {
                                                let item0 = data1[i1];
                                                if (typeof item0 !== 'string') {
                                                    continue;
                                                }
                                                if (typeof indices0[item0] == 'number') {
                                                    j0 = indices0[item0];
                                                    validate39.errors = [
                                                        {
                                                            instancePath: instancePath + '/keyColumns',
                                                            schemaPath: '#/properties/keyColumns/uniqueItems',
                                                            keyword: 'uniqueItems',
                                                            params: { i: i1, j: j0 },
                                                            message: 'must NOT have duplicate items (items ## ' + j0 + ' and ' + i1 + ' are identical)'
                                                        }
                                                    ];
                                                    return false;
                                                    break;
                                                }
                                                indices0[item0] = i1;
                                            }
                                        }
                                    }
                                }
                            }
                            else {
                                validate39.errors = [
                                    {
                                        instancePath: instancePath + '/keyColumns',
                                        schemaPath: '#/properties/keyColumns/type',
                                        keyword: 'type',
                                        params: { type: 'array' },
                                        message: 'must be array'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.fileFormat !== undefined) {
                            let data3 = data.fileFormat;
                            const _errs7 = errors;
                            if (errors === _errs7) {
                                if (typeof data3 === 'string') {
                                    if (func2(data3) < 1) {
                                        validate39.errors = [
                                            {
                                                instancePath: instancePath + '/fileFormat',
                                                schemaPath: '#/properties/fileFormat/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate39.errors = [
                                        {
                                            instancePath: instancePath + '/fileFormat',
                                            schemaPath: '#/properties/fileFormat/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs7 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate39.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate39.errors = vErrors;
    return errors === 0;
}
export const symonExportSettingsSchemaValidation = validate40;
const schema72 = {
    $id: 'urn:wisepipe-common-export:SymonExportSettings',
    type: 'object',
    properties: { dataSourceID: { type: 'string', uid: 9 }, originID: { type: 'string', uid: 9 } },
    required: ['dataSourceID', 'originID']
};
const func149 = ucs2length;
const func150 = base64urlToBuffer;
const func151 = base64urlEncode;
const func152 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func153 = ucs2length;
const func154 = base64urlToBuffer;
const func155 = base64urlEncode;
const func156 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate40(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-export:SymonExportSettings" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.dataSourceID === undefined && (missing0 = 'dataSourceID')) ||
                (data.originID === undefined && (missing0 = 'originID'))) {
                validate40.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.dataSourceID !== undefined) {
                    let data0 = data.dataSourceID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            const b64min0 = Math.ceil((4 * 9) / 3);
                            const b64max0 = Math.ceil((4 * 9) / 3) + 3;
                            if (func149(data0) < b64min0 || func149(data0) > b64max0) {
                                validate40.errors = [
                                    {
                                        instancePath: instancePath + '/dataSourceID',
                                        schemaPath: '#/properties/dataSourceID/uid',
                                        keyword: 'uid',
                                        params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func149(data0) },
                                        message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func149(data0)
                                    }
                                ];
                                return false;
                            }
                            else {
                                const decoded0 = func150(data0);
                                if (decoded0.length !== 9) {
                                    validate40.errors = [
                                        {
                                            instancePath: instancePath + '/dataSourceID',
                                            schemaPath: '#/properties/dataSourceID/uid',
                                            keyword: 'uid',
                                            params: { error: 'decoded' },
                                            message: 'must decode to 9 bytes'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const encoded0 = func151(decoded0);
                                    if (func152(encoded0) !== func152(data0)) {
                                        validate40.errors = [
                                            {
                                                instancePath: instancePath + '/dataSourceID',
                                                schemaPath: '#/properties/dataSourceID/uid',
                                                keyword: 'uid',
                                                params: { error: 'ambiguous' },
                                                message: 'encoding is ambiguous'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                        }
                        else {
                            validate40.errors = [
                                {
                                    instancePath: instancePath + '/dataSourceID',
                                    schemaPath: '#/properties/dataSourceID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.originID !== undefined) {
                        let data1 = data.originID;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                const b64min1 = Math.ceil((4 * 9) / 3);
                                const b64max1 = Math.ceil((4 * 9) / 3) + 3;
                                if (func153(data1) < b64min1 || func153(data1) > b64max1) {
                                    validate40.errors = [
                                        {
                                            instancePath: instancePath + '/originID',
                                            schemaPath: '#/properties/originID/uid',
                                            keyword: 'uid',
                                            params: { error: 'encoded', b64min: b64min1, b64max: b64max1, length: func153(data1) },
                                            message: 'length must be between ' + b64min1 + ' and ' + b64max1 + ', but is ' + func153(data1)
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const decoded1 = func154(data1);
                                    if (decoded1.length !== 9) {
                                        validate40.errors = [
                                            {
                                                instancePath: instancePath + '/originID',
                                                schemaPath: '#/properties/originID/uid',
                                                keyword: 'uid',
                                                params: { error: 'decoded' },
                                                message: 'must decode to 9 bytes'
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        const encoded1 = func155(decoded1);
                                        if (func156(encoded1) !== func156(data1)) {
                                            validate40.errors = [
                                                {
                                                    instancePath: instancePath + '/originID',
                                                    schemaPath: '#/properties/originID/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'ambiguous' },
                                                    message: 'encoding is ambiguous'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                            }
                            else {
                                validate40.errors = [
                                    {
                                        instancePath: instancePath + '/originID',
                                        schemaPath: '#/properties/originID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate40.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate40.errors = vErrors;
    return errors === 0;
}
export const tableauExportSettingsSchemaValidation = validate41;
const schema73 = {
    $id: 'urn:wisepipe-common-export:TableauExportSettings',
    type: 'object',
    properties: { projectName: { type: 'string', minLength: 1 }, dataSourceName: { type: 'string', minLength: 1 } },
    required: ['projectName', 'dataSourceName']
};
function validate41(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-export:TableauExportSettings" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.projectName === undefined && (missing0 = 'projectName')) ||
                (data.dataSourceName === undefined && (missing0 = 'dataSourceName'))) {
                validate41.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.projectName !== undefined) {
                    let data0 = data.projectName;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate41.errors = [
                                    {
                                        instancePath: instancePath + '/projectName',
                                        schemaPath: '#/properties/projectName/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate41.errors = [
                                {
                                    instancePath: instancePath + '/projectName',
                                    schemaPath: '#/properties/projectName/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.dataSourceName !== undefined) {
                        let data1 = data.dataSourceName;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate41.errors = [
                                        {
                                            instancePath: instancePath + '/dataSourceName',
                                            schemaPath: '#/properties/dataSourceName/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate41.errors = [
                                    {
                                        instancePath: instancePath + '/dataSourceName',
                                        schemaPath: '#/properties/dataSourceName/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate41.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate41.errors = vErrors;
    return errors === 0;
}
export const taskAuthInfoSchemaValidation = validate42;
function validate42(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-auth:TaskAuthInfo" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.orgID === undefined && (missing0 = 'orgID')) ||
                (data.userID === undefined && (missing0 = 'userID')) ||
                (data.taskID === undefined && (missing0 = 'taskID')) ||
                (data.taskAuthToken === undefined && (missing0 = 'taskAuthToken')) ||
                (data.expiration === undefined && (missing0 = 'expiration'))) {
                validate42.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.orgID !== undefined) {
                    let data0 = data.orgID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (errors === _errs1) {
                            if (typeof data0 === 'string') {
                                if (!formats2.test(data0)) {
                                    validate42.errors = [
                                        {
                                            instancePath: instancePath + '/orgID',
                                            schemaPath: '#/properties/orgID/format',
                                            keyword: 'format',
                                            params: { format: 'uuid' },
                                            message: 'must match format "' + 'uuid' + '"'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate42.errors = [
                                    {
                                        instancePath: instancePath + '/orgID',
                                        schemaPath: '#/properties/orgID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.userID !== undefined) {
                        let data1 = data.userID;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (errors === _errs3) {
                                if (typeof data1 === 'string') {
                                    if (!formats2.test(data1)) {
                                        validate42.errors = [
                                            {
                                                instancePath: instancePath + '/userID',
                                                schemaPath: '#/properties/userID/format',
                                                keyword: 'format',
                                                params: { format: 'uuid' },
                                                message: 'must match format "' + 'uuid' + '"'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate42.errors = [
                                        {
                                            instancePath: instancePath + '/userID',
                                            schemaPath: '#/properties/userID/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.taskID !== undefined) {
                            const _errs5 = errors;
                            if (typeof data.taskID !== 'string') {
                                validate42.errors = [
                                    {
                                        instancePath: instancePath + '/taskID',
                                        schemaPath: '#/properties/taskID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.taskAuthToken !== undefined) {
                                const _errs7 = errors;
                                if (typeof data.taskAuthToken !== 'string') {
                                    validate42.errors = [
                                        {
                                            instancePath: instancePath + '/taskAuthToken',
                                            schemaPath: '#/properties/taskAuthToken/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.expiration !== undefined) {
                                    let data4 = data.expiration;
                                    const _errs9 = errors;
                                    if (!(typeof data4 == 'number' && !(data4 % 1) && !isNaN(data4))) {
                                        validate42.errors = [
                                            {
                                                instancePath: instancePath + '/expiration',
                                                schemaPath: '#/properties/expiration/type',
                                                keyword: 'type',
                                                params: { type: 'integer' },
                                                message: 'must be integer'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.endpoint !== undefined) {
                                        const _errs11 = errors;
                                        if (typeof data.endpoint !== 'string') {
                                            validate42.errors = [
                                                {
                                                    instancePath: instancePath + '/endpoint',
                                                    schemaPath: '#/properties/endpoint/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                        var valid0 = _errs11 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate42.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate42.errors = vErrors;
    return errors === 0;
}
export const tqHeaderSchemaValidation = validate43;
const schema75 = {
    $id: 'urn:wisepipe-common-export:TqHeader',
    type: 'object',
    properties: {
        name: { type: 'string', minLength: 1 },
        required: { type: 'boolean' },
        type: { type: 'string', enum: ['text', 'character varying', 'integer', 'numeric', 'date'] }
    },
    required: ['name', 'required', 'type']
};
function validate43(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-export:TqHeader" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.name === undefined && (missing0 = 'name')) ||
                (data.required === undefined && (missing0 = 'required')) ||
                (data.type === undefined && (missing0 = 'type'))) {
                validate43.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.name !== undefined) {
                    let data0 = data.name;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate43.errors = [
                                    {
                                        instancePath: instancePath + '/name',
                                        schemaPath: '#/properties/name/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate43.errors = [
                                {
                                    instancePath: instancePath + '/name',
                                    schemaPath: '#/properties/name/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.required !== undefined) {
                        const _errs3 = errors;
                        if (typeof data.required !== 'boolean') {
                            validate43.errors = [
                                {
                                    instancePath: instancePath + '/required',
                                    schemaPath: '#/properties/required/type',
                                    keyword: 'type',
                                    params: { type: 'boolean' },
                                    message: 'must be boolean'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.type !== undefined) {
                            let data2 = data.type;
                            const _errs5 = errors;
                            if (typeof data2 !== 'string') {
                                validate43.errors = [
                                    {
                                        instancePath: instancePath + '/type',
                                        schemaPath: '#/properties/type/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                            if (!(data2 === 'text' ||
                                data2 === 'character varying' ||
                                data2 === 'integer' ||
                                data2 === 'numeric' ||
                                data2 === 'date')) {
                                validate43.errors = [
                                    {
                                        instancePath: instancePath + '/type',
                                        schemaPath: '#/properties/type/enum',
                                        keyword: 'enum',
                                        params: { allowedValues: schema75.properties.type.enum },
                                        message: 'must be equal to one of the allowed values'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate43.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate43.errors = vErrors;
    return errors === 0;
}
export const tqPostgresExportSettingsSchemaValidation = validate44;
const schema76 = {
    $id: 'urn:wisepipe-common-export:TqPostgresExportSettings',
    type: 'object',
    properties: {
        uuid: { type: 'string', minLength: 1 },
        tqHeaders: { type: 'array', items: { $ref: 'urn:wisepipe-common-export:TqHeader' } }
    },
    required: ['uuid', 'tqHeaders']
};
function validate44(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-export:TqPostgresExportSettings" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.uuid === undefined && (missing0 = 'uuid')) ||
                (data.tqHeaders === undefined && (missing0 = 'tqHeaders'))) {
                validate44.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.uuid !== undefined) {
                    let data0 = data.uuid;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate44.errors = [
                                    {
                                        instancePath: instancePath + '/uuid',
                                        schemaPath: '#/properties/uuid/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate44.errors = [
                                {
                                    instancePath: instancePath + '/uuid',
                                    schemaPath: '#/properties/uuid/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.tqHeaders !== undefined) {
                        let data1 = data.tqHeaders;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (Array.isArray(data1)) {
                                var valid1 = true;
                                const len0 = data1.length;
                                for (let i0 = 0; i0 < len0; i0++) {
                                    let data2 = data1[i0];
                                    const _errs5 = errors;
                                    const _errs6 = errors;
                                    if (errors === _errs6) {
                                        if (data2 && typeof data2 == 'object' && !Array.isArray(data2)) {
                                            let missing1;
                                            if ((data2.name === undefined && (missing1 = 'name')) ||
                                                (data2.required === undefined && (missing1 = 'required')) ||
                                                (data2.type === undefined && (missing1 = 'type'))) {
                                                validate44.errors = [
                                                    {
                                                        instancePath: instancePath + '/tqHeaders/' + i0,
                                                        schemaPath: 'urn:wisepipe-common-export:TqHeader/required',
                                                        keyword: 'required',
                                                        params: { missingProperty: missing1 },
                                                        message: "must have required property '" + missing1 + "'"
                                                    }
                                                ];
                                                return false;
                                            }
                                            else {
                                                if (data2.name !== undefined) {
                                                    let data3 = data2.name;
                                                    const _errs8 = errors;
                                                    if (errors === _errs8) {
                                                        if (typeof data3 === 'string') {
                                                            if (func2(data3) < 1) {
                                                                validate44.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/tqHeaders/' + i0 + '/name',
                                                                        schemaPath: 'urn:wisepipe-common-export:TqHeader/properties/name/minLength',
                                                                        keyword: 'minLength',
                                                                        params: { limit: 1 },
                                                                        message: 'must NOT have fewer than 1 characters'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        else {
                                                            validate44.errors = [
                                                                {
                                                                    instancePath: instancePath + '/tqHeaders/' + i0 + '/name',
                                                                    schemaPath: 'urn:wisepipe-common-export:TqHeader/properties/name/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    var valid3 = _errs8 === errors;
                                                }
                                                else {
                                                    var valid3 = true;
                                                }
                                                if (valid3) {
                                                    if (data2.required !== undefined) {
                                                        const _errs10 = errors;
                                                        if (typeof data2.required !== 'boolean') {
                                                            validate44.errors = [
                                                                {
                                                                    instancePath: instancePath + '/tqHeaders/' + i0 + '/required',
                                                                    schemaPath: 'urn:wisepipe-common-export:TqHeader/properties/required/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'boolean' },
                                                                    message: 'must be boolean'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        var valid3 = _errs10 === errors;
                                                    }
                                                    else {
                                                        var valid3 = true;
                                                    }
                                                    if (valid3) {
                                                        if (data2.type !== undefined) {
                                                            let data5 = data2.type;
                                                            const _errs12 = errors;
                                                            if (typeof data5 !== 'string') {
                                                                validate44.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/tqHeaders/' + i0 + '/type',
                                                                        schemaPath: 'urn:wisepipe-common-export:TqHeader/properties/type/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'string' },
                                                                        message: 'must be string'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            if (!(data5 === 'text' ||
                                                                data5 === 'character varying' ||
                                                                data5 === 'integer' ||
                                                                data5 === 'numeric' ||
                                                                data5 === 'date')) {
                                                                validate44.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/tqHeaders/' + i0 + '/type',
                                                                        schemaPath: 'urn:wisepipe-common-export:TqHeader/properties/type/enum',
                                                                        keyword: 'enum',
                                                                        params: { allowedValues: schema75.properties.type.enum },
                                                                        message: 'must be equal to one of the allowed values'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            var valid3 = _errs12 === errors;
                                                        }
                                                        else {
                                                            var valid3 = true;
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                        else {
                                            validate44.errors = [
                                                {
                                                    instancePath: instancePath + '/tqHeaders/' + i0,
                                                    schemaPath: 'urn:wisepipe-common-export:TqHeader/type',
                                                    keyword: 'type',
                                                    params: { type: 'object' },
                                                    message: 'must be object'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid1 = _errs5 === errors;
                                    if (!valid1) {
                                        break;
                                    }
                                }
                            }
                            else {
                                validate44.errors = [
                                    {
                                        instancePath: instancePath + '/tqHeaders',
                                        schemaPath: '#/properties/tqHeaders/type',
                                        keyword: 'type',
                                        params: { type: 'array' },
                                        message: 'must be array'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate44.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate44.errors = vErrors;
    return errors === 0;
}
export const tqpExportSettingsSchemaValidation = validate45;
const schema78 = { $id: 'urn:wisepipe-common-export:TqpExportSettings', type: 'object' };
function validate45(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-export:TqpExportSettings" */ let vErrors = null;
    let errors = 0;
    if (!(data && typeof data == 'object' && !Array.isArray(data))) {
        validate45.errors = [
            { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
        ];
        return false;
    }
    validate45.errors = vErrors;
    return errors === 0;
}
export const transientPipeExportSchemaValidation = validate46;
const schema79 = {
    $id: 'urn:wisepipe-common-export:TransientPipeExport',
    type: 'object',
    properties: {
        exportSettings: { $ref: 'urn:wisepipe-common-export:ExportSettings' },
        connection: { $ref: 'urn:wisepipe-common-connection:Connection' },
        credentials: { $ref: 'urn:wisepipe-common:Credentials' },
        connID: { type: 'string', uid: 9 }
    },
    required: ['exportSettings']
};
const func162 = ucs2length;
const func163 = base64urlToBuffer;
const func164 = base64urlEncode;
const func165 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func168 = ucs2length;
const func169 = base64urlToBuffer;
const func170 = base64urlEncode;
const func171 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate46(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-export:TransientPipeExport" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.exportSettings === undefined && (missing0 = 'exportSettings')) {
                validate46.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.exportSettings !== undefined) {
                    let data0 = data.exportSettings;
                    const _errs1 = errors;
                    const _errs2 = errors;
                    if (errors === _errs2) {
                        if (data0 && typeof data0 == 'object' && !Array.isArray(data0)) {
                            let missing1;
                            if (data0.exportType === undefined && (missing1 = 'exportType')) {
                                validate46.errors = [
                                    {
                                        instancePath: instancePath + '/exportSettings',
                                        schemaPath: 'urn:wisepipe-common-export:ExportSettings/required',
                                        keyword: 'required',
                                        params: { missingProperty: missing1 },
                                        message: "must have required property '" + missing1 + "'"
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (data0.exportType !== undefined) {
                                    let data1 = data0.exportType;
                                    if (typeof data1 !== 'string') {
                                        validate46.errors = [
                                            {
                                                instancePath: instancePath + '/exportSettings/exportType',
                                                schemaPath: 'urn:wisepipe-common-export:ExportSettings/properties/exportType/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                    if (!(data1 === 'gsheets' ||
                                        data1 === 'icm' ||
                                        data1 === 'postgres' ||
                                        data1 === 'tq-postgres' ||
                                        data1 === 'powerbi' ||
                                        data1 === 'symon' ||
                                        data1 === 'salesForce' ||
                                        data1 === 'workday-payroll' ||
                                        data1 === 'tableau' ||
                                        data1 === 'tqp' ||
                                        data1 === 'sftp' ||
                                        data1 === 's3-csv' ||
                                        data1 === 'snowflake' ||
                                        data1 === 's3parquet' ||
                                        data1 === 'msSql' ||
                                        data1 === 'oneDrive')) {
                                        validate46.errors = [
                                            {
                                                instancePath: instancePath + '/exportSettings/exportType',
                                                schemaPath: 'urn:wisepipe-common-export:ExportSettings/properties/exportType/enum',
                                                keyword: 'enum',
                                                params: { allowedValues: schema53.properties.exportType.enum },
                                                message: 'must be equal to one of the allowed values'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                        }
                        else {
                            validate46.errors = [
                                {
                                    instancePath: instancePath + '/exportSettings',
                                    schemaPath: 'urn:wisepipe-common-export:ExportSettings/type',
                                    keyword: 'type',
                                    params: { type: 'object' },
                                    message: 'must be object'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.connection !== undefined) {
                        let data2 = data.connection;
                        const _errs6 = errors;
                        const _errs7 = errors;
                        if (errors === _errs7) {
                            if (data2 && typeof data2 == 'object' && !Array.isArray(data2)) {
                                let missing2;
                                if ((data2.connectionType === undefined && (missing2 = 'connectionType')) ||
                                    (data2.name === undefined && (missing2 = 'name'))) {
                                    validate46.errors = [
                                        {
                                            instancePath: instancePath + '/connection',
                                            schemaPath: 'urn:wisepipe-common-connection:Connection/required',
                                            keyword: 'required',
                                            params: { missingProperty: missing2 },
                                            message: "must have required property '" + missing2 + "'"
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    if (data2.connectionID !== undefined) {
                                        let data3 = data2.connectionID;
                                        const _errs9 = errors;
                                        if (errors === _errs9) {
                                            if (typeof data3 === 'string') {
                                                const b64min0 = Math.ceil((4 * 9) / 3);
                                                const b64max0 = Math.ceil((4 * 9) / 3) + 3;
                                                if (func162(data3) < b64min0 || func162(data3) > b64max0) {
                                                    validate46.errors = [
                                                        {
                                                            instancePath: instancePath + '/connection/connectionID',
                                                            schemaPath: 'urn:wisepipe-common-connection:Connection/properties/connectionID/uid',
                                                            keyword: 'uid',
                                                            params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func162(data3) },
                                                            message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func162(data3)
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                else {
                                                    const decoded0 = func163(data3);
                                                    if (decoded0.length !== 9) {
                                                        validate46.errors = [
                                                            {
                                                                instancePath: instancePath + '/connection/connectionID',
                                                                schemaPath: 'urn:wisepipe-common-connection:Connection/properties/connectionID/uid',
                                                                keyword: 'uid',
                                                                params: { error: 'decoded' },
                                                                message: 'must decode to 9 bytes'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    else {
                                                        const encoded0 = func164(decoded0);
                                                        if (func165(encoded0) !== func165(data3)) {
                                                            validate46.errors = [
                                                                {
                                                                    instancePath: instancePath + '/connection/connectionID',
                                                                    schemaPath: 'urn:wisepipe-common-connection:Connection/properties/connectionID/uid',
                                                                    keyword: 'uid',
                                                                    params: { error: 'ambiguous' },
                                                                    message: 'encoding is ambiguous'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                }
                                            }
                                            else {
                                                validate46.errors = [
                                                    {
                                                        instancePath: instancePath + '/connection/connectionID',
                                                        schemaPath: 'urn:wisepipe-common-connection:Connection/properties/connectionID/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid4 = _errs9 === errors;
                                    }
                                    else {
                                        var valid4 = true;
                                    }
                                    if (valid4) {
                                        if (data2.connectionType !== undefined) {
                                            let data4 = data2.connectionType;
                                            const _errs11 = errors;
                                            if (typeof data4 !== 'string') {
                                                validate46.errors = [
                                                    {
                                                        instancePath: instancePath + '/connection/connectionType',
                                                        schemaPath: 'urn:wisepipe-common-connection:Connection/properties/connectionType/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                            if (!(data4 === 'google' ||
                                                data4 === 'gsheetsImport' ||
                                                data4 === 'gsheetsExport' ||
                                                data4 === 'shopify' ||
                                                data4 === 'salesForce' ||
                                                data4 === 'postgreSql' ||
                                                data4 === 'icm' ||
                                                data4 === 'tq-postgres' ||
                                                data4 === 'mySql' ||
                                                data4 === 'msSql' ||
                                                data4 === 'oracle' ||
                                                data4 === 'amazonRedshift' ||
                                                data4 === 'amazonAurora' ||
                                                data4 === 'amazonS3' ||
                                                data4 === 'amazonS3Export' ||
                                                data4 === 'tqp' ||
                                                data4 === 'hubspot' ||
                                                data4 === 'symon' ||
                                                data4 === 'snowflake' ||
                                                data4 === 'dynamics' ||
                                                data4 === 'agentSync' ||
                                                data4 === 'workday' ||
                                                data4 === 'workdayRaaS' ||
                                                data4 === 'workdayExport' ||
                                                data4 === 'tableau' ||
                                                data4 === 'sftp' ||
                                                data4 === 'powerbi' ||
                                                data4 === 'rest' ||
                                                data4 === 'gong' ||
                                                data4 === 'netSuite' ||
                                                data4 === 'oneDrive' ||
                                                data4 === 'oneDriveExport' ||
                                                data4 === 'sapSuccessFactors' ||
                                                data4 === 'sapCrm' ||
                                                data4 === 'ukg' ||
                                                data4 === 'oracleHcm' ||
                                                data4 === 'Adp' ||
                                                data4 === 'dynamics365Sales' ||
                                                data4 === 'ceridianDayforce' ||
                                                data4 === 'oracleCrm' ||
                                                data4 === 'oracleErpCloud' ||
                                                data4 === 'sageIntacct' ||
                                                data4 === 'bambooHr' ||
                                                data4 === 'sapErp' ||
                                                data4 === 'googleCloudPlatformCloudStorage' ||
                                                data4 === 'sas' ||
                                                data4 === 'dropbox' ||
                                                data4 === 'googleDrive' ||
                                                data4 === 'jira' ||
                                                data4 === 'monday' ||
                                                data4 === 'zuora' ||
                                                data4 === 'adobeAnalytics' ||
                                                data4 === 'zoomInfo' ||
                                                data4 === 'marketo' ||
                                                data4 === 'activeCampaign' ||
                                                data4 === 'mailchimp' ||
                                                data4 === 'infor' ||
                                                data4 === 'cornerstoneOnDemand' ||
                                                data4 === 'gusto' ||
                                                data4 === 'paychexFlex' ||
                                                data4 === 'zendesk' ||
                                                data4 === 'serviceNow' ||
                                                data4 === 'zohoCrm' ||
                                                data4 === 'pipedrive' ||
                                                data4 === 'quickBooks' ||
                                                data4 === 'xero' ||
                                                data4 === 'freshbooks' ||
                                                data4 === 'zohoBooks' ||
                                                data4 === 'waveFinancial')) {
                                                validate46.errors = [
                                                    {
                                                        instancePath: instancePath + '/connection/connectionType',
                                                        schemaPath: 'urn:wisepipe-common-connection:Connection/properties/connectionType/enum',
                                                        keyword: 'enum',
                                                        params: { allowedValues: schema31.properties.connectionType.enum },
                                                        message: 'must be equal to one of the allowed values'
                                                    }
                                                ];
                                                return false;
                                            }
                                            var valid4 = _errs11 === errors;
                                        }
                                        else {
                                            var valid4 = true;
                                        }
                                        if (valid4) {
                                            if (data2.name !== undefined) {
                                                let data5 = data2.name;
                                                const _errs13 = errors;
                                                if (errors === _errs13) {
                                                    if (typeof data5 === 'string') {
                                                        if (func2(data5) < 1) {
                                                            validate46.errors = [
                                                                {
                                                                    instancePath: instancePath + '/connection/name',
                                                                    schemaPath: 'urn:wisepipe-common-connection:Connection/properties/name/minLength',
                                                                    keyword: 'minLength',
                                                                    params: { limit: 1 },
                                                                    message: 'must NOT have fewer than 1 characters'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    else {
                                                        validate46.errors = [
                                                            {
                                                                instancePath: instancePath + '/connection/name',
                                                                schemaPath: 'urn:wisepipe-common-connection:Connection/properties/name/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                var valid4 = _errs13 === errors;
                                            }
                                            else {
                                                var valid4 = true;
                                            }
                                            if (valid4) {
                                                if (data2.source !== undefined) {
                                                    let data6 = data2.source;
                                                    const _errs15 = errors;
                                                    if (errors === _errs15) {
                                                        if (typeof data6 === 'string') {
                                                            if (func2(data6) < 1) {
                                                                validate46.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/connection/source',
                                                                        schemaPath: 'urn:wisepipe-common-connection:Connection/properties/source/minLength',
                                                                        keyword: 'minLength',
                                                                        params: { limit: 1 },
                                                                        message: 'must NOT have fewer than 1 characters'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        else {
                                                            validate46.errors = [
                                                                {
                                                                    instancePath: instancePath + '/connection/source',
                                                                    schemaPath: 'urn:wisepipe-common-connection:Connection/properties/source/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    var valid4 = _errs15 === errors;
                                                }
                                                else {
                                                    var valid4 = true;
                                                }
                                                if (valid4) {
                                                    if (data2.failedOnLastTry !== undefined) {
                                                        const _errs17 = errors;
                                                        if (typeof data2.failedOnLastTry !== 'boolean') {
                                                            validate46.errors = [
                                                                {
                                                                    instancePath: instancePath + '/connection/failedOnLastTry',
                                                                    schemaPath: 'urn:wisepipe-common-connection:Connection/properties/failedOnLastTry/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'boolean' },
                                                                    message: 'must be boolean'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        var valid4 = _errs17 === errors;
                                                    }
                                                    else {
                                                        var valid4 = true;
                                                    }
                                                    if (valid4) {
                                                        if (data2.isDiscoveryFail !== undefined) {
                                                            const _errs19 = errors;
                                                            if (typeof data2.isDiscoveryFail !== 'boolean') {
                                                                validate46.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/connection/isDiscoveryFail',
                                                                        schemaPath: 'urn:wisepipe-common-connection:Connection/properties/isDiscoveryFail/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'boolean' },
                                                                        message: 'must be boolean'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            var valid4 = _errs19 === errors;
                                                        }
                                                        else {
                                                            var valid4 = true;
                                                        }
                                                        if (valid4) {
                                                            if (data2.verificationErrorMessage !== undefined) {
                                                                const _errs21 = errors;
                                                                if (typeof data2.verificationErrorMessage !== 'string') {
                                                                    validate46.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/connection/verificationErrorMessage',
                                                                            schemaPath: 'urn:wisepipe-common-connection:Connection/properties/verificationErrorMessage/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'string' },
                                                                            message: 'must be string'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                                var valid4 = _errs21 === errors;
                                                            }
                                                            else {
                                                                var valid4 = true;
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            else {
                                validate46.errors = [
                                    {
                                        instancePath: instancePath + '/connection',
                                        schemaPath: 'urn:wisepipe-common-connection:Connection/type',
                                        keyword: 'type',
                                        params: { type: 'object' },
                                        message: 'must be object'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs6 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.credentials !== undefined) {
                            let data10 = data.credentials;
                            const _errs23 = errors;
                            const _errs24 = errors;
                            if (errors === _errs24) {
                                if (data10 && typeof data10 == 'object' && !Array.isArray(data10)) {
                                    let missing3;
                                    if (data10.credentialsType === undefined && (missing3 = 'credentialsType')) {
                                        validate46.errors = [
                                            {
                                                instancePath: instancePath + '/credentials',
                                                schemaPath: 'urn:wisepipe-common:Credentials/required',
                                                keyword: 'required',
                                                params: { missingProperty: missing3 },
                                                message: "must have required property '" + missing3 + "'"
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        if (data10.credentialsType !== undefined) {
                                            let data11 = data10.credentialsType;
                                            if (typeof data11 !== 'string') {
                                                validate46.errors = [
                                                    {
                                                        instancePath: instancePath + '/credentials/credentialsType',
                                                        schemaPath: 'urn:wisepipe-common:Credentials/properties/credentialsType/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                            if (!(data11 === 'oauth' ||
                                                data11 === 'userPassword' ||
                                                data11 === 's3Credentials' ||
                                                data11 === 'apiKey' ||
                                                data11 === 'symon' ||
                                                data11 === 'awsRoleAssumption' ||
                                                data11 === 'rest' ||
                                                data11 === 'tokenBasedAuthentication')) {
                                                validate46.errors = [
                                                    {
                                                        instancePath: instancePath + '/credentials/credentialsType',
                                                        schemaPath: 'urn:wisepipe-common:Credentials/properties/credentialsType/enum',
                                                        keyword: 'enum',
                                                        params: { allowedValues: schema32.properties.credentialsType.enum },
                                                        message: 'must be equal to one of the allowed values'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                    }
                                }
                                else {
                                    validate46.errors = [
                                        {
                                            instancePath: instancePath + '/credentials',
                                            schemaPath: 'urn:wisepipe-common:Credentials/type',
                                            keyword: 'type',
                                            params: { type: 'object' },
                                            message: 'must be object'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs23 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.connID !== undefined) {
                                let data12 = data.connID;
                                const _errs28 = errors;
                                if (errors === _errs28) {
                                    if (typeof data12 === 'string') {
                                        const b64min1 = Math.ceil((4 * 9) / 3);
                                        const b64max1 = Math.ceil((4 * 9) / 3) + 3;
                                        if (func168(data12) < b64min1 || func168(data12) > b64max1) {
                                            validate46.errors = [
                                                {
                                                    instancePath: instancePath + '/connID',
                                                    schemaPath: '#/properties/connID/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'encoded', b64min: b64min1, b64max: b64max1, length: func168(data12) },
                                                    message: 'length must be between ' + b64min1 + ' and ' + b64max1 + ', but is ' + func168(data12)
                                                }
                                            ];
                                            return false;
                                        }
                                        else {
                                            const decoded1 = func169(data12);
                                            if (decoded1.length !== 9) {
                                                validate46.errors = [
                                                    {
                                                        instancePath: instancePath + '/connID',
                                                        schemaPath: '#/properties/connID/uid',
                                                        keyword: 'uid',
                                                        params: { error: 'decoded' },
                                                        message: 'must decode to 9 bytes'
                                                    }
                                                ];
                                                return false;
                                            }
                                            else {
                                                const encoded1 = func170(decoded1);
                                                if (func171(encoded1) !== func171(data12)) {
                                                    validate46.errors = [
                                                        {
                                                            instancePath: instancePath + '/connID',
                                                            schemaPath: '#/properties/connID/uid',
                                                            keyword: 'uid',
                                                            params: { error: 'ambiguous' },
                                                            message: 'encoding is ambiguous'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                        }
                                    }
                                    else {
                                        validate46.errors = [
                                            {
                                                instancePath: instancePath + '/connID',
                                                schemaPath: '#/properties/connID/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs28 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                        }
                    }
                }
            }
        }
        else {
            validate46.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate46.errors = vErrors;
    return errors === 0;
}
export const workdayPayrollExportSettingsSchemaValidation = validate47;
const schema83 = {
    $id: 'urn:wisepipe-common-export:WorkdayPayrollExportSettings',
    type: 'object',
    properties: { batchID: { type: 'string' } },
    required: ['batchID']
};
function validate47(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-export:WorkdayPayrollExportSettings" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.batchID === undefined && (missing0 = 'batchID')) {
                validate47.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.batchID !== undefined) {
                    if (typeof data.batchID !== 'string') {
                        validate47.errors = [
                            {
                                instancePath: instancePath + '/batchID',
                                schemaPath: '#/properties/batchID/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                }
            }
        }
        else {
            validate47.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate47.errors = vErrors;
    return errors === 0;
}
//# sourceMappingURL=validations.generated.js.map